export interface IRawCarc {
  content: string,
  groupNum: number,
}

export interface ICARC {
  code: string,
  descr: string
}

export class HttpErr {
  errorNumber: number;
  message: string;
  displayMsg: string;
}

import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { EMPTY, Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { HelperRtnsComponent } from '../../shared/helper-rtns.component';

@Injectable({
  providedIn: 'root'
})
export class CkRegister835DetailService {

  constructor(private _http: HttpClient,
    private _help: HelperRtnsComponent) { }

  carcGroupCodes: ICARC[] = [ // From https://x12.org/codes/claim-adjustment-group-codes  4/24/2023
    { code: 'CO', descr: 'Contractual Obligation' },
    { code: 'OA', descr: 'Other Adjustment' },
    { code: 'PI', descr: 'Payor Initiated Reduction' },
    { code: 'PR', descr: 'Patient Responsibility' },
    { code: 'CR', descr: 'Corrections and Reversal' },
    { code: 'RARC', descr: 'Remittance Advice Remark Code' }  // Pseudo code - not a real code
  ];

  populateUpdateCarcSqlTable(rawCarcs: IRawCarc[]): Observable<any | HttpErr> {
    let dispMsg = 'Error creating/updating Sql table [CARC] from rawCarcs[] @ CkRegister835DetailService \n';
    return this._http.post(this._help.urlDB + '/api/post-carc',
      rawCarcs,
      { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) })
      .pipe(
        catchError(err => this.HttpErr(err, dispMsg + ' errorNumber=' + err.errorNumber + '\n'
          + ' message=' + err.message))
      );
  }

  getCarcDescrFromReasonCode(code: string): Observable<any | HttpErr> {
    let dispMsg = 'Internet Connection Problem';

    if (!code) {  // In case code not valid from MB PayFiles xml column
      return EMPTY;
    }

    return this._http.get(this._help.urlDB + `/api/get-carcDescr/${code}`,
      {
        headers: new HttpHeaders(
          { 'Accept': 'application/json' }
        )
      })
      .pipe(
        map(data => data),
        catchError(err => this.HttpErr(err, dispMsg))
      );
  }

  getReclaimFormsXml(): Observable<any | HttpErr> {
    let dispMsg = 'Internet Connection Problem';
    return this._http.get(this._help.urlDB + '/api/get-reclaimXml',
      {
        headers: new HttpHeaders(
          { 'Accept': 'application/json' }
        )
      })
      .pipe(
        map(data => data),
        catchError(err => this.HttpErr(err, dispMsg))
      );
  }

  private HttpErr(error: HttpErrorResponse, dispMsg: string): Observable<HttpErr> {
    const dataErr: HttpErr = {
      errorNumber: error.status,
      message: error.statusText,
      displayMsg: dispMsg
    };
    return throwError(() => dataErr);
  }

  rawCarcs: IRawCarc[] = [ // Claim Adjustment Reason Codes extracted from https://x12.org/codes/claim-adjustment-reason-codes 4/24/2023
    // {
    //   "content": "1", "groupNum": 1,
    // },
    // {
    //   "content": "Deductible Amount", "groupNum": 2,
    // },
    // {
    //   "content": "2", "groupNum": 1,
    // },
    // {
    //   "content": "Coinsurance Amount", "groupNum": 2,
    // },
    // {
    //   "content": "3", "groupNum": 1,
    // },
    // {
    //   "content": "Co-payment Amount", "groupNum": 2,
    // },
    // {
    //   "content": "4", "groupNum": 1,
    // },
    // {
    //   "content": "The procedure code is inconsistent with the modifier used. Usage: Refer to the 835 Healthcare Policy Identification Segment (loop 2110 Service Payment Information REF), if present.", "groupNum": 2,
    // },
    // {
    //   "content": "5", "groupNum": 1,
    // },
    // {
    //   "content": "The procedure code/type of bill is inconsistent with the place of service. Usage: Refer to the 835 Healthcare Policy Identification Segment (loop 2110 Service Payment Information REF), if present.", "groupNum": 2,
    // },
    // {
    //   "content": "6", "groupNum": 1,
    // },
    // {
    //   "content": "The procedure/revenue code is inconsistent with the patient's age. Usage: Refer to the 835 Healthcare Policy Identification Segment (loop 2110 Service Payment Information REF), if present.", "groupNum": 2,
    // },
    // {
    //   "content": "7", "groupNum": 1,
    // },
    // {
    //   "content": "The procedure/revenue code is inconsistent with the patient's gender. Usage: Refer to the 835 Healthcare Policy Identification Segment (loop 2110 Service Payment Information REF), if present.", "groupNum": 2,
    // },
    // {
    //   "content": "8", "groupNum": 1,
    // },
    // {
    //   "content": "The procedure code is inconsistent with the provider type/specialty (taxonomy). Usage: Refer to the 835 Healthcare Policy Identification Segment (loop 2110 Service Payment Information REF), if present.", "groupNum": 2,
    // },
    // {
    //   "content": "9", "groupNum": 1,
    // },
    // {
    //   "content": "The diagnosis is inconsistent with the patient's age. Usage: Refer to the 835 Healthcare Policy Identification Segment (loop 2110 Service Payment Information REF), if present.", "groupNum": 2,
    // },
    // {
    //   "content": "10", "groupNum": 1,
    // },
    // {
    //   "content": "The diagnosis is inconsistent with the patient's gender. Usage: Refer to the 835 Healthcare Policy Identification Segment (loop 2110 Service Payment Information REF), if present.", "groupNum": 2,
    // },
    // {
    //   "content": "11", "groupNum": 1,
    // },
    // {
    //   "content": "The diagnosis is inconsistent with the procedure. Usage: Refer to the 835 Healthcare Policy Identification Segment (loop 2110 Service Payment Information REF), if present.", "groupNum": 2,
    // },
    // {
    //   "content": "12", "groupNum": 1,
    // },
    // {
    //   "content": "The diagnosis is inconsistent with the provider type. Usage: Refer to the 835 Healthcare Policy Identification Segment (loop 2110 Service Payment Information REF), if present.", "groupNum": 2,
    // },
    // {
    //   "content": "13", "groupNum": 1,
    // },
    // {
    //   "content": "The date of death precedes the date of service.", "groupNum": 2,
    // },
    // {
    //   "content": "14", "groupNum": 1,
    // },
    // {
    //   "content": "The date of birth follows the date of service.", "groupNum": 2,
    // },
    // {
    //   "content": "15", "groupNum": 1,
    // },
    // {
    //   "content": "The authorization number is missing, invalid, or does not apply to the billed services or provider.", "groupNum": 2,
    // },
    // {
    //   "content": "16", "groupNum": 1,
    // },
    // {
    //   "content": "Claim/service lacks information or has submission/billing error(s). Usage: Do not use this code for claims attachment(s)/other documentation. At least one Remark Code must be provided (may be comprised of either the NCPDP Reject Reason Code, or Remittance Advice Remark Code that is not an ALERT.) Refer to the 835 Healthcare Policy Identification Segment (loop 2110 Service Payment Information REF), if present.", "groupNum": 2,
    // },
    // {
    //   "content": "17", "groupNum": 1,
    // },
    // {
    //   "content": "Requested information was not provided or was insufficient/incomplete. At least one Remark Code must be provided (may be comprised of either the Remittance Advice Remark Code or NCPDP Reject Reason Code.)", "groupNum": 2,
    // },
    // {
    //   "content": "18", "groupNum": 1,
    // },
    // {
    //   "content": "Exact duplicate claim/service (Use only with Group Code OA except where state workers' compensation regulations requires CO)", "groupNum": 2,
    // },
    // {
    //   "content": "19", "groupNum": 1,
    // },
    // {
    //   "content": "This is a work-related injury/illness and thus the liability of the Worker's Compensation Carrier.", "groupNum": 2,
    // },
    // {
    //   "content": "20", "groupNum": 1,
    // },
    // {
    //   "content": "This injury/illness is covered by the liability carrier.", "groupNum": 2,
    // },
    // {
    //   "content": "21", "groupNum": 1,
    // },
    // {
    //   "content": "This injury/illness is the liability of the no-fault carrier.", "groupNum": 2,
    // },
    // {
    //   "content": "22", "groupNum": 1,
    // },
    // {
    //   "content": "This care may be covered by another payer per coordination of benefits.", "groupNum": 2,
    // },
    // {
    //   "content": "23", "groupNum": 1,
    // },
    // {
    //   "content": "The impact of prior payer(s) adjudication including payments and/or adjustments. (Use only with Group Code OA)", "groupNum": 2,
    // },
    // {
    //   "content": "24", "groupNum": 1,
    // },
    // {
    //   "content": "Charges are covered under a capitation agreement/managed care plan.", "groupNum": 2,
    // },
    // {
    //   "content": "25", "groupNum": 1,
    // },
    // {
    //   "content": "Payment denied. Your Stop loss deductible has not been met.", "groupNum": 2,
    // },
    // {
    //   "content": "26", "groupNum": 1,
    // },
    // {
    //   "content": "Expenses incurred prior to coverage.", "groupNum": 2,
    // },
    // {
    //   "content": "27", "groupNum": 1,
    // },
    // {
    //   "content": "Expenses incurred after coverage terminated.", "groupNum": 2,
    // },
    // {
    //   "content": "28", "groupNum": 1,
    // },
    // {
    //   "content": "Coverage not in effect at the time the service was provided.", "groupNum": 2,
    // },
    // {
    //   "content": "29", "groupNum": 1,
    // },
    // {
    //   "content": "The time limit for filing has expired.", "groupNum": 2,
    // },
    // {
    //   "content": "30", "groupNum": 1,
    // },
    // {
    //   "content": "Payment adjusted because the patient has not met the required eligibility, spend down, waiting, or residency requirements.", "groupNum": 2,
    // },
    // {
    //   "content": "31", "groupNum": 1,
    // },
    // {
    //   "content": "Patient cannot be identified as our insured.", "groupNum": 2,
    // },
    // {
    //   "content": "32", "groupNum": 1,
    // },
    // {
    //   "content": "Our records indicate the patient is not an eligible dependent.", "groupNum": 2,
    // },
    // {
    //   "content": "33", "groupNum": 1,
    // },
    // {
    //   "content": "Insured has no dependent coverage.", "groupNum": 2,
    // },
    // {
    //   "content": "34", "groupNum": 1,
    // },
    // {
    //   "content": "Insured has no coverage for newborns.", "groupNum": 2,
    // },
    // {
    //   "content": "35", "groupNum": 1,
    // },
    // {
    //   "content": "Lifetime benefit maximum has been reached.", "groupNum": 2,
    // },
    // {
    //   "content": "36", "groupNum": 1,
    // },
    // {
    //   "content": "Balance does not exceed co-payment amount.", "groupNum": 2,
    // },
    // {
    //   "content": "37", "groupNum": 1,
    // },
    // {
    //   "content": "Balance does not exceed deductible.", "groupNum": 2,
    // },
    // {
    //   "content": "38", "groupNum": 1,
    // },
    // {
    //   "content": "Services not provided or authorized by designated (network/primary care) providers.", "groupNum": 2,
    // },
    // {
    //   "content": "39", "groupNum": 1,
    // },
    // {
    //   "content": "Services denied at the time authorization/pre-certification was requested.", "groupNum": 2,
    // },
    // {
    //   "content": "40", "groupNum": 1,
    // },
    // {
    //   "content": "Charges do not meet qualifications for emergent/urgent care. Usage: Refer to the 835 Healthcare Policy Identification Segment (loop 2110 Service Payment Information REF), if present.", "groupNum": 2,
    // },
    // {
    //   "content": "41", "groupNum": 1,
    // },
    // {
    //   "content": "Discount agreed to in Preferred Provider contract.", "groupNum": 2,
    // },
    // {
    //   "content": "42", "groupNum": 1,
    // },
    // {
    //   "content": "Charges exceed our fee schedule or maximum allowable amount. (Use CARC 45)", "groupNum": 2,
    // },
    // {
    //   "content": "43", "groupNum": 1,
    // },
    // {
    //   "content": "Gramm-Rudman reduction.", "groupNum": 2,
    // },
    // {
    //   "content": "44", "groupNum": 1,
    // },
    // {
    //   "content": "Prompt-pay discount.", "groupNum": 2,
    // },
    // {
    //   "content": "45", "groupNum": 1,
    // },
    // {
    //   "content": "Charge exceeds fee schedule/maximum allowable or contracted/legislated fee arrangement. Usage: This adjustment amount cannot equal the total service or claim charge amount; and must not duplicate provider adjustment amounts (payments and contractual reductions) that have resulted from prior payer(s) adjudication. (Use only with Group Codes PR or CO depending upon liability)", "groupNum": 2,
    // },
    // {
    //   "content": "46", "groupNum": 1,
    // },
    // {
    //   "content": "This (these) service(s) is (are) not covered.", "groupNum": 2,
    // },
    // {
    //   "content": "47", "groupNum": 1,
    // },
    // {
    //   "content": "This (these) diagnosis(es) is (are) not covered, missing, or are invalid.", "groupNum": 2,
    // },
    // {
    //   "content": "48", "groupNum": 1,
    // },
    // {
    //   "content": "This (these) procedure(s) is (are) not covered.", "groupNum": 2,
    // },
    // {
    //   "content": "49", "groupNum": 1,
    // },
    // {
    //   "content": "This is a non-covered service because it is a routine/preventive exam or a diagnostic/screening procedure done in conjunction with a routine/preventive exam. Usage: Refer to the 835 Healthcare Policy Identification Segment (loop 2110 Service Payment Information REF), if present.", "groupNum": 2,
    // },
    // {
    //   "content": "50", "groupNum": 1,
    // },
    // {
    //   "content": "These are non-covered services because this is not deemed a 'medical necessity' by the payer. Usage: Refer to the 835 Healthcare Policy Identification Segment (loop 2110 Service Payment Information REF), if present.", "groupNum": 2,
    // },
    // {
    //   "content": "51", "groupNum": 1,
    // },
    // {
    //   "content": "These are non-covered services because this is a pre-existing condition. Usage: Refer to the 835 Healthcare Policy Identification Segment (loop 2110 Service Payment Information REF), if present.", "groupNum": 2,
    // },
    // {
    //   "content": "52", "groupNum": 1,
    // },
    // {
    //   "content": "The referring/prescribing/rendering provider is not eligible to refer/prescribe/order/perform the service billed.", "groupNum": 2,
    // },
    // {
    //   "content": "53", "groupNum": 1,
    // },
    // {
    //   "content": "Services by an immediate relative or a member of the same household are not covered.", "groupNum": 2,
    // },
    // {
    //   "content": "54", "groupNum": 1,
    // },
    // {
    //   "content": "Multiple physicians/assistants are not covered in this case. Usage: Refer to the 835 Healthcare Policy Identification Segment (loop 2110 Service Payment Information REF), if present.", "groupNum": 2,
    // },
    // {
    //   "content": "55", "groupNum": 1,
    // },
    // {
    //   "content": "Procedure/treatment/drug is deemed experimental/investigational by the payer. Usage: Refer to the 835 Healthcare Policy Identification Segment (loop 2110 Service Payment Information REF), if present.", "groupNum": 2,
    // },
    // {
    //   "content": "56", "groupNum": 1,
    // },
    // {
    //   "content": "Procedure/treatment has not been deemed 'proven to be effective' by the payer. Usage: Refer to the 835 Healthcare Policy Identification Segment (loop 2110 Service Payment Information REF), if present.", "groupNum": 2,
    // },
    // {
    //   "content": "57", "groupNum": 1,
    // },
    // {
    //   "content": "Payment denied/reduced because the payer deems the information submitted does not support this level of service, this many services, this length of service, this dosage, or this day's supply.", "groupNum": 2,
    // },
    // {
    //   "content": "58", "groupNum": 1,
    // },
    // {
    //   "content": "Treatment was deemed by the payer to have been rendered in an inappropriate or invalid place of service. Usage: Refer to the 835 Healthcare Policy Identification Segment (loop 2110 Service Payment Information REF), if present.", "groupNum": 2,
    // },
    // {
    //   "content": "59", "groupNum": 1,
    // },
    // {
    //   "content": "Processed based on multiple or concurrent procedure rules. (For example multiple surgery or diagnostic imaging, concurrent anesthesia.) Usage: Refer to the 835 Healthcare Policy Identification Segment (loop 2110 Service Payment Information REF), if present.", "groupNum": 2,
    // },
    // {
    //   "content": "60", "groupNum": 1,
    // },
    // {
    //   "content": "Charges for outpatient services are not covered when performed within a period of time prior to or after inpatient services.", "groupNum": 2,
    // },
    // {
    //   "content": "61", "groupNum": 1,
    // },
    // {
    //   "content": "Adjusted for failure to obtain second surgical opinion", "groupNum": 2,
    // },
    // {
    //   "content": "62", "groupNum": 1,
    // },
    // {
    //   "content": "Payment denied/reduced for absence of, or exceeded, pre-certification/authorization.", "groupNum": 2,
    // },
    // {
    //   "content": "63", "groupNum": 1,
    // },
    // {
    //   "content": "Correction to a prior claim.", "groupNum": 2,
    // },
    // {
    //   "content": "64", "groupNum": 1,
    // },
    // {
    //   "content": "Denial reversed per Medical Review.", "groupNum": 2,
    // },
    // {
    //   "content": "65", "groupNum": 1,
    // },
    // {
    //   "content": "Procedure code was incorrect. This payment reflects the correct code.", "groupNum": 2,
    // },
    // {
    //   "content": "66", "groupNum": 1,
    // },
    // {
    //   "content": "Blood Deductible.", "groupNum": 2,
    // },
    // {
    //   "content": "68", "groupNum": 1,
    // },
    // {
    //   "content": "DRG weight. (Handled in CLP12)", "groupNum": 2,
    // },
    // {
    //   "content": "69", "groupNum": 1,
    // },
    // {
    //   "content": "Day outlier amount.", "groupNum": 2,
    // },
    // {
    //   "content": "70", "groupNum": 1,
    // },
    // {
    //   "content": "Cost outlier - Adjustment to compensate for additional costs.", "groupNum": 2,
    // },
    // {
    //   "content": "71", "groupNum": 1,
    // },
    // {
    //   "content": "Primary Payer amount.", "groupNum": 2,
    // },
    // {
    //   "content": "73", "groupNum": 1,
    // },
    // {
    //   "content": "Administrative days.", "groupNum": 2,
    // },
    // {
    //   "content": "74", "groupNum": 1,
    // },
    // {
    //   "content": "Indirect Medical Education Adjustment.", "groupNum": 2,
    // },
    // {
    //   "content": "75", "groupNum": 1,
    // },
    // {
    //   "content": "Direct Medical Education Adjustment.", "groupNum": 2,
    // },
    // {
    //   "content": "76", "groupNum": 1,
    // },
    // {
    //   "content": "Disproportionate Share Adjustment.", "groupNum": 2,
    // },
    // {
    //   "content": "78", "groupNum": 1,
    // },
    // {
    //   "content": "Non-Covered days/Room charge adjustment.", "groupNum": 2,
    // },
    // {
    //   "content": "79", "groupNum": 1,
    // },
    // {
    //   "content": "Cost Report days. (Handled in MIA15)", "groupNum": 2,
    // },
    // {
    //   "content": "81", "groupNum": 1,
    // },
    // {
    //   "content": "Discharges.", "groupNum": 2,
    // },
    // {
    //   "content": "82", "groupNum": 1,
    // },
    // {
    //   "content": "PIP days.", "groupNum": 2,
    // },
    // {
    //   "content": "83", "groupNum": 1,
    // },
    // {
    //   "content": "Total visits.", "groupNum": 2,
    // },
    // {
    //   "content": "84", "groupNum": 1,
    // },
    // {
    //   "content": "Capital Adjustment. (Handled in MIA)", "groupNum": 2,
    // },
    // {
    //   "content": "85", "groupNum": 1,
    // },
    // {
    //   "content": "Patient Interest Adjustment (Use Only Group code PR)", "groupNum": 2,
    // },
    // {
    //   "content": "86", "groupNum": 1,
    // },
    // {
    //   "content": "Statutory Adjustment.", "groupNum": 2,
    // },
    // {
    //   "content": "87", "groupNum": 1,
    // },
    // {
    //   "content": "Transfer amount.", "groupNum": 2,
    // },
    // {
    //   "content": "88", "groupNum": 1,
    // },
    // {
    //   "content": "Adjustment amount represents collection against receivable created in prior overpayment.", "groupNum": 2,
    // },
    // {
    //   "content": "89", "groupNum": 1,
    // },
    // {
    //   "content": "Professional fees removed from charges.", "groupNum": 2,
    // },
    // {
    //   "content": "90", "groupNum": 1,
    // },
    // {
    //   "content": "Ingredient cost adjustment. Usage: To be used for pharmaceuticals only.", "groupNum": 2,
    // },
    // {
    //   "content": "91", "groupNum": 1,
    // },
    // {
    //   "content": "Dispensing fee adjustment.", "groupNum": 2,
    // },
    // {
    //   "content": "92", "groupNum": 1,
    // },
    // {
    //   "content": "Claim Paid in full.", "groupNum": 2,
    // },
    // {
    //   "content": "93", "groupNum": 1,
    // },
    // {
    //   "content": "No Claim level Adjustments.", "groupNum": 2,
    // },
    // {
    //   "content": "94", "groupNum": 1,
    // },
    // {
    //   "content": "Processed in Excess of charges.", "groupNum": 2,
    // },
    // {
    //   "content": "95", "groupNum": 1,
    // },
    // {
    //   "content": "Plan procedures not followed.", "groupNum": 2,
    // },
    // {
    //   "content": "96", "groupNum": 1,
    // },
    // {
    //   "content": "Non-covered charge(s). At least one Remark Code must be provided (may be comprised of either the NCPDP Reject Reason Code, or Remittance Advice Remark Code that is not an ALERT.) Usage: Refer to the 835 Healthcare Policy Identification Segment (loop 2110 Service Payment Information REF), if present.", "groupNum": 2,
    // },
    // {
    //   "content": "97", "groupNum": 1,
    // },
    // {
    //   "content": "The benefit for this service is included in the payment/allowance for another service/procedure that has already been adjudicated. Usage: Refer to the 835 Healthcare Policy Identification Segment (loop 2110 Service Payment Information REF), if present.", "groupNum": 2,
    // },
    // {
    //   "content": "98", "groupNum": 1,
    // },
    // {
    //   "content": "The hospital must file the Medicare claim for this inpatient non-physician service.", "groupNum": 2,
    // },
    // {
    //   "content": "99", "groupNum": 1,
    // },
    // {
    //   "content": "Medicare Secondary Payer Adjustment Amount.", "groupNum": 2,
    // },
    // {
    //   "content": "100", "groupNum": 1,
    // },
    // {
    //   "content": "Payment made to patient/insured/responsible party.", "groupNum": 2,
    // },
    // {
    //   "content": "101", "groupNum": 1,
    // },
    // {
    //   "content": "Predetermination: anticipated payment upon completion of services or claim adjudication.", "groupNum": 2,
    // },
    // {
    //   "content": "102", "groupNum": 1,
    // },
    // {
    //   "content": "Major Medical Adjustment.", "groupNum": 2,
    // },
    // {
    //   "content": "103", "groupNum": 1,
    // },
    // {
    //   "content": "Provider promotional discount (e.g., Senior citizen discount).", "groupNum": 2,
    // },
    // {
    //   "content": "104", "groupNum": 1,
    // },
    // {
    //   "content": "Managed care withholding.", "groupNum": 2,
    // },
    // {
    //   "content": "105", "groupNum": 1,
    // },
    // {
    //   "content": "Tax withholding.", "groupNum": 2,
    // },
    // {
    //   "content": "106", "groupNum": 1,
    // },
    // {
    //   "content": "Patient payment option/election not in effect.", "groupNum": 2,
    // },
    // {
    //   "content": "107", "groupNum": 1,
    // },
    // {
    //   "content": "The related or qualifying claim/service was not identified on this claim. Usage: Refer to the 835 Healthcare Policy Identification Segment (loop 2110 Service Payment Information REF), if present.", "groupNum": 2,
    // },
    // {
    //   "content": "108", "groupNum": 1,
    // },
    // {
    //   "content": "Rent/purchase guidelines were not met. Usage: Refer to the 835 Healthcare Policy Identification Segment (loop 2110 Service Payment Information REF), if present.", "groupNum": 2,
    // },
    // {
    //   "content": "109", "groupNum": 1,
    // },
    // {
    //   "content": "Claim/service not covered by this payer/contractor. You must send the claim/service to the correct payer/contractor.", "groupNum": 2,
    // },
    // {
    //   "content": "110", "groupNum": 1,
    // },
    // {
    //   "content": "Billing date predates service date.", "groupNum": 2,
    // },
    // {
    //   "content": "111", "groupNum": 1,
    // },
    // {
    //   "content": "Not covered unless the provider accepts assignment.", "groupNum": 2,
    // },
    // {
    //   "content": "112", "groupNum": 1,
    // },
    // {
    //   "content": "Service not furnished directly to the patient and/or not documented.", "groupNum": 2,
    // },
    // {
    //   "content": "113", "groupNum": 1,
    // },
    // {
    //   "content": "Payment denied because service/procedure was provided outside the United States or as a result of war.", "groupNum": 2,
    // },
    // {
    //   "content": "114", "groupNum": 1,
    // },
    // {
    //   "content": "Procedure/product not approved by the Food and Drug Administration.", "groupNum": 2,
    // },
    // {
    //   "content": "115", "groupNum": 1,
    // },
    // {
    //   "content": "Procedure postponed, canceled, or delayed.", "groupNum": 2,
    // },
    // {
    //   "content": "116", "groupNum": 1,
    // },
    // {
    //   "content": "The advance indemnification notice signed by the patient did not comply with requirements.", "groupNum": 2,
    // },
    // {
    //   "content": "117", "groupNum": 1,
    // },
    // {
    //   "content": "Transportation is only covered to the closest facility that can provide the necessary care.", "groupNum": 2,
    // },
    // {
    //   "content": "118", "groupNum": 1,
    // },
    // {
    //   "content": "ESRD network support adjustment.", "groupNum": 2,
    // },
    // {
    //   "content": "119", "groupNum": 1,
    // },
    // {
    //   "content": "Benefit maximum for this time period or occurrence has been reached.", "groupNum": 2,
    // },
    // {
    //   "content": "120", "groupNum": 1,
    // },
    // {
    //   "content": "Patient is covered by a managed care plan.", "groupNum": 2,
    // },
    // {
    //   "content": "121", "groupNum": 1,
    // },
    // {
    //   "content": "Indemnification adjustment - compensation for outstanding member responsibility.", "groupNum": 2,
    // },
    // {
    //   "content": "122", "groupNum": 1,
    // },
    // {
    //   "content": "Psychiatric reduction.", "groupNum": 2,
    // },
    // {
    //   "content": "123", "groupNum": 1,
    // },
    // {
    //   "content": "Payer refund due to overpayment.", "groupNum": 2,
    // },
    // {
    //   "content": "124", "groupNum": 1,
    // },
    // {
    //   "content": "Payer refund amount - not our patient.", "groupNum": 2,
    // },
    // {
    //   "content": "125", "groupNum": 1,
    // },
    // {
    //   "content": "Submission/billing error(s). At least one Remark Code must be provided (may be comprised of either the NCPDP Reject Reason Code, or Remittance Advice Remark Code that is not an ALERT.)", "groupNum": 2,
    // },
    // {
    //   "content": "126", "groupNum": 1,
    // },
    // {
    //   "content": "Deductible -- Major Medical", "groupNum": 2,
    // },
    // {
    //   "content": "127", "groupNum": 1,
    // },
    // {
    //   "content": "Coinsurance -- Major Medical", "groupNum": 2,
    // },
    // {
    //   "content": "128", "groupNum": 1,
    // },
    // {
    //   "content": "Newborn's services are covered in the mother's Allowance.", "groupNum": 2,
    // },
    // {
    //   "content": "129", "groupNum": 1,
    // },
    // {
    //   "content": "Prior processing information appears incorrect. At least one Remark Code must be provided (may be comprised of either the NCPDP Reject Reason Code, or Remittance Advice Remark Code that is not an ALERT.)", "groupNum": 2,
    // },
    // {
    //   "content": "130", "groupNum": 1,
    // },
    // {
    //   "content": "Claim submission fee.", "groupNum": 2,
    // },
    // {
    //   "content": "131", "groupNum": 1,
    // },
    // {
    //   "content": "Claim specific negotiated discount.", "groupNum": 2,
    // },
    // {
    //   "content": "132", "groupNum": 1,
    // },
    // {
    //   "content": "Prearranged demonstration project adjustment.", "groupNum": 2,
    // },
    // {
    //   "content": "133", "groupNum": 1,
    // },
    // {
    //   "content": "The disposition of this service line is pending further review. (Use only with Group Code OA). Usage: Use of this code requires a reversal and correction when the service line is finalized (use only in Loop 2110 CAS segment of the 835 or Loop 2430 of the 837).", "groupNum": 2,
    // },
    // {
    //   "content": "134", "groupNum": 1,
    // },
    // {
    //   "content": "Technical fees removed from charges.", "groupNum": 2,
    // },
    // {
    //   "content": "135", "groupNum": 1,
    // },
    // {
    //   "content": "Interim bills cannot be processed.", "groupNum": 2,
    // },
    // {
    //   "content": "136", "groupNum": 1,
    // },
    // {
    //   "content": "Failure to follow prior payer's coverage rules. (Use only with Group Code OA)", "groupNum": 2,
    // },
    // {
    //   "content": "137", "groupNum": 1,
    // },
    // {
    //   "content": "Regulatory Surcharges, Assessments, Allowances or Health Related Taxes.", "groupNum": 2,
    // },
    // {
    //   "content": "138", "groupNum": 1,
    // },
    // {
    //   "content": "Appeal procedures not followed or time limits not met.", "groupNum": 2,
    // },
    // {
    //   "content": "139", "groupNum": 1,
    // },
    // {
    //   "content": "Contracted funding agreement - Subscriber is employed by the provider of services. Use only with Group Code CO.", "groupNum": 2,
    // },
    // {
    //   "content": "140", "groupNum": 1,
    // },
    // {
    //   "content": "Patient/Insured health identification number and name do not match.", "groupNum": 2,
    // },
    // {
    //   "content": "141", "groupNum": 1,
    // },
    // {
    //   "content": "Claim spans eligible and ineligible periods of coverage.", "groupNum": 2,
    // },
    // {
    //   "content": "142", "groupNum": 1,
    // },
    // {
    //   "content": "Monthly Medicaid patient liability amount.", "groupNum": 2,
    // },
    // {
    //   "content": "143", "groupNum": 1,
    // },
    // {
    //   "content": "Portion of payment deferred.", "groupNum": 2,
    // },
    // {
    //   "content": "144", "groupNum": 1,
    // },
    // {
    //   "content": "Incentive adjustment, e.g. preferred product/service.", "groupNum": 2,
    // },
    // {
    //   "content": "145", "groupNum": 1,
    // },
    // {
    //   "content": "Premium payment withholding", "groupNum": 2,
    // },
    // {
    //   "content": "146", "groupNum": 1,
    // },
    // {
    //   "content": "Diagnosis was invalid for the date(s) of service reported.", "groupNum": 2,
    // },
    // {
    //   "content": "147", "groupNum": 1,
    // },
    // {
    //   "content": "Provider contracted/negotiated rate expired or not on file.", "groupNum": 2,
    // },
    // {
    //   "content": "148", "groupNum": 1,
    // },
    // {
    //   "content": "Information from another provider was not provided or was insufficient/incomplete. At least one Remark Code must be provided (may be comprised of either the NCPDP Reject Reason Code, or Remittance Advice Remark Code that is not an ALERT.)", "groupNum": 2,
    // },
    // {
    //   "content": "149", "groupNum": 1,
    // },
    // {
    //   "content": "Lifetime benefit maximum has been reached for this service/benefit category.", "groupNum": 2,
    // },
    // {
    //   "content": "150", "groupNum": 1,
    // },
    // {
    //   "content": "Payer deems the information submitted does not support this level of service.", "groupNum": 2,
    // },
    // {
    //   "content": "151", "groupNum": 1,
    // },
    // {
    //   "content": "Payment adjusted because the payer deems the information submitted does not support this many/frequency of services.", "groupNum": 2,
    // },
    // {
    //   "content": "152", "groupNum": 1,
    // },
    // {
    //   "content": "Payer deems the information submitted does not support this length of service. Usage: Refer to the 835 Healthcare Policy Identification Segment (loop 2110 Service Payment Information REF), if present.", "groupNum": 2,
    // },
    // {
    //   "content": "153", "groupNum": 1,
    // },
    // {
    //   "content": "Payer deems the information submitted does not support this dosage.", "groupNum": 2,
    // },
    // {
    //   "content": "154", "groupNum": 1,
    // },
    // {
    //   "content": "Payer deems the information submitted does not support this day's supply.", "groupNum": 2,
    // },
    // {
    //   "content": "155", "groupNum": 1,
    // },
    // {
    //   "content": "Patient refused the service/procedure.", "groupNum": 2,
    // },
    // {
    //   "content": "156", "groupNum": 1,
    // },
    // {
    //   "content": "Flexible spending account payments. Note: Use code 187.", "groupNum": 2,
    // },
    // {
    //   "content": "157", "groupNum": 1,
    // },
    // {
    //   "content": "Service/procedure was provided as a result of an act of war.", "groupNum": 2,
    // },
    // {
    //   "content": "158", "groupNum": 1,
    // },
    // {
    //   "content": "Service/procedure was provided outside of the United States.", "groupNum": 2,
    // },
    // {
    //   "content": "159", "groupNum": 1,
    // },
    // {
    //   "content": "Service/procedure was provided as a result of terrorism.", "groupNum": 2,
    // },
    // {
    //   "content": "160", "groupNum": 1,
    // },
    // {
    //   "content": "Injury/illness was the result of an activity that is a benefit exclusion.", "groupNum": 2,
    // },
    // {
    //   "content": "161", "groupNum": 1,
    // },
    // {
    //   "content": "Provider performance bonus", "groupNum": 2,
    // },
    // {
    //   "content": "162", "groupNum": 1,
    // },
    // {
    //   "content": "State-mandated Requirement for Property and Casualty, see Claim Payment Remarks Code for specific explanation.", "groupNum": 2,
    // },
    // {
    //   "content": "163", "groupNum": 1,
    // },
    // {
    //   "content": "Attachment/other documentation referenced on the claim was not received.", "groupNum": 2,
    // },
    // {
    //   "content": "164", "groupNum": 1,
    // },
    // {
    //   "content": "Attachment/other documentation referenced on the claim was not received in a timely fashion.", "groupNum": 2,
    // },
    // {
    //   "content": "165", "groupNum": 1,
    // },
    // {
    //   "content": "Referral absent or exceeded.", "groupNum": 2,
    // },
    // {
    //   "content": "166", "groupNum": 1,
    // },
    // {
    //   "content": "These services were submitted after this payers responsibility for processing claims under this plan ended.", "groupNum": 2,
    // },
    // {
    //   "content": "167", "groupNum": 1,
    // },
    // {
    //   "content": "This (these) diagnosis(es) is (are) not covered. Usage: Refer to the 835 Healthcare Policy Identification Segment (loop 2110 Service Payment Information REF), if present.", "groupNum": 2,
    // },
    // {
    //   "content": "168", "groupNum": 1,
    // },
    // {
    //   "content": "Service(s) have been considered under the patient's medical plan. Benefits are not available under this dental plan.", "groupNum": 2,
    // },
    // {
    //   "content": "169", "groupNum": 1,
    // },
    // {
    //   "content": "Alternate benefit has been provided.", "groupNum": 2,
    // },
    // {
    //   "content": "170", "groupNum": 1,
    // },
    // {
    //   "content": "Payment is denied when performed/billed by this type of provider. Usage: Refer to the 835 Healthcare Policy Identification Segment (loop 2110 Service Payment Information REF), if present.", "groupNum": 2,
    // },
    // {
    //   "content": "171", "groupNum": 1,
    // },
    // {
    //   "content": "Payment is denied when performed/billed by this type of provider in this type of facility. Usage: Refer to the 835 Healthcare Policy Identification Segment (loop 2110 Service Payment Information REF), if present.", "groupNum": 2,
    // },
    // {
    //   "content": "172", "groupNum": 1,
    // },
    // {
    //   "content": "Payment is adjusted when performed/billed by a provider of this specialty. Usage: Refer to the 835 Healthcare Policy Identification Segment (loop 2110 Service Payment Information REF), if present.", "groupNum": 2,
    // },
    // {
    //   "content": "173", "groupNum": 1,
    // },
    // {
    //   "content": "Service/equipment was not prescribed by a physician.", "groupNum": 2,
    // },
    // {
    //   "content": "174", "groupNum": 1,
    // },
    // {
    //   "content": "Service was not prescribed prior to delivery.", "groupNum": 2,
    // },
    // {
    //   "content": "175", "groupNum": 1,
    // },
    // {
    //   "content": "Prescription is incomplete.", "groupNum": 2,
    // },
    // {
    //   "content": "176", "groupNum": 1,
    // },
    // {
    //   "content": "Prescription is not current.", "groupNum": 2,
    // },
    // {
    //   "content": "177", "groupNum": 1,
    // },
    // {
    //   "content": "Patient has not met the required eligibility requirements.", "groupNum": 2,
    // },
    // {
    //   "content": "178", "groupNum": 1,
    // },
    // {
    //   "content": "Patient has not met the required spend down requirements.", "groupNum": 2,
    // },
    // {
    //   "content": "179", "groupNum": 1,
    // },
    // {
    //   "content": "Patient has not met the required waiting requirements. Usage: Refer to the 835 Healthcare Policy Identification Segment (loop 2110 Service Payment Information REF), if present.", "groupNum": 2,
    // },
    // {
    //   "content": "180", "groupNum": 1,
    // },
    // {
    //   "content": "Patient has not met the required residency requirements.", "groupNum": 2,
    // },
    // {
    //   "content": "181", "groupNum": 1,
    // },
    // {
    //   "content": "Procedure code was invalid on the date of service.", "groupNum": 2,
    // },
    // {
    //   "content": "182", "groupNum": 1,
    // },
    // {
    //   "content": "Procedure modifier was invalid on the date of service.", "groupNum": 2,
    // },
    // {
    //   "content": "183", "groupNum": 1,
    // },
    // {
    //   "content": "The referring provider is not eligible to refer the service billed. Usage: Refer to the 835 Healthcare Policy Identification Segment (loop 2110 Service Payment Information REF), if present.", "groupNum": 2,
    // },
    // {
    //   "content": "184", "groupNum": 1,
    // },
    // {
    //   "content": "The prescribing/ordering provider is not eligible to prescribe/order the service billed. Usage: Refer to the 835 Healthcare Policy Identification Segment (loop 2110 Service Payment Information REF), if present.", "groupNum": 2,
    // },
    // {
    //   "content": "185", "groupNum": 1,
    // },
    // {
    //   "content": "The rendering provider is not eligible to perform the service billed. Usage: Refer to the 835 Healthcare Policy Identification Segment (loop 2110 Service Payment Information REF), if present.", "groupNum": 2,
    // },
    // {
    //   "content": "186", "groupNum": 1,
    // },
    // {
    //   "content": "Level of care change adjustment.", "groupNum": 2,
    // },
    // {
    //   "content": "187", "groupNum": 1,
    // },
    // {
    //   "content": "Consumer Spending Account payments (includes but is not limited to Flexible Spending Account, Health Savings Account, Health Reimbursement Account, etc.)", "groupNum": 2,
    // },
    // {
    //   "content": "188", "groupNum": 1,
    // },
    // {
    //   "content": "This product/procedure is only covered when used according to FDA recommendations.", "groupNum": 2,
    // },
    // {
    //   "content": "189", "groupNum": 1,
    // },
    // {
    //   "content": "'Not otherwise classified' or 'unlisted' procedure code (CPT/HCPCS) was billed when there is a specific procedure code for this procedure/service", "groupNum": 2,
    // },
    // {
    //   "content": "190", "groupNum": 1,
    // },
    // {
    //   "content": "Payment is included in the allowance for a Skilled Nursing Facility (SNF) qualified stay.", "groupNum": 2,
    // },
    // {
    //   "content": "191", "groupNum": 1,
    // },
    // {
    //   "content": "Not a work related injury/illness and thus not the liability of the workers' compensation carrier Note: If adjustment is at the Claim Level, the payer must send and the provider should refer to the 835 Insurance Policy Number Segment (Loop 2100 Other Claim Related Information REF qualifier 'IG') for the jurisdictional regulation. If adjustment is at the Line Level, the payer must send and the provider should refer to the 835 Healthcare Policy Identification Segment (loop 2110 Service Payment information REF)", "groupNum": 2,
    // },
    // {
    //   "content": "192", "groupNum": 1,
    // },
    // {
    //   "content": "Non standard adjustment code from paper remittance. Usage: This code is to be used by providers/payers providing Coordination of Benefits information to another payer in the 837 transaction only. This code is only used when the non-standard code cannot be reasonably mapped to an existing Claims Adjustment Reason Code, specifically Deductible, Coinsurance and Co-payment.", "groupNum": 2,
    // },
    // {
    //   "content": "193", "groupNum": 1,
    // },
    // {
    //   "content": "Original payment decision is being maintained. Upon review, it was determined that this claim was processed properly.", "groupNum": 2,
    // },
    // {
    //   "content": "194", "groupNum": 1,
    // },
    // {
    //   "content": "Anesthesia performed by the operating physician, the assistant surgeon or the attending physician.", "groupNum": 2,
    // },
    // {
    //   "content": "195", "groupNum": 1,
    // },
    // {
    //   "content": "Refund issued to an erroneous priority payer for this claim/service.", "groupNum": 2,
    // },
    // {
    //   "content": "196", "groupNum": 1,
    // },
    // {
    //   "content": "Claim/service denied based on prior payer's coverage determination.", "groupNum": 2,
    // },
    // {
    //   "content": "197", "groupNum": 1,
    // },
    // {
    //   "content": "Precertification/authorization/notification/pre-treatment absent.", "groupNum": 2,
    // },
    // {
    //   "content": "198", "groupNum": 1,
    // },
    // {
    //   "content": "Precertification/notification/authorization/pre-treatment exceeded.", "groupNum": 2,
    // },
    // {
    //   "content": "199", "groupNum": 1,
    // },
    // {
    //   "content": "Revenue code and Procedure code do not match.", "groupNum": 2,
    // },
    // {
    //   "content": "200", "groupNum": 1,
    // },
    // {
    //   "content": "Expenses incurred during lapse in coverage", "groupNum": 2,
    // },
    // {
    //   "content": "201", "groupNum": 1,
    // },
    // {
    //   "content": "Patient is responsible for amount of this claim/service through 'set aside arrangement' or other agreement. (Use only with Group Code PR)  At least one Remark Code must be provided (may be comprised of either the NCPDP Reject Reason Code, or Remittance Advice Remark Code that is not an ALERT.)", "groupNum": 2,
    // },
    // {
    //   "content": "202", "groupNum": 1,
    // },
    // {
    //   "content": "Non-covered personal comfort or convenience services.", "groupNum": 2,
    // },
    // {
    //   "content": "203", "groupNum": 1,
    // },
    // {
    //   "content": "Discontinued or reduced service.", "groupNum": 2,
    // },
    // {
    //   "content": "204", "groupNum": 1,
    // },
    // {
    //   "content": "This service/equipment/drug is not covered under the patient's current benefit plan", "groupNum": 2,
    // },
    // {
    //   "content": "205", "groupNum": 1,
    // },
    // {
    //   "content": "Pharmacy discount card processing fee", "groupNum": 2,
    // },
    // {
    //   "content": "206", "groupNum": 1,
    // },
    // {
    //   "content": "National Provider Identifier - missing.", "groupNum": 2,
    // },
    // {
    //   "content": "207", "groupNum": 1,
    // },
    // {
    //   "content": "National Provider identifier - Invalid format", "groupNum": 2,
    // },
    // {
    //   "content": "208", "groupNum": 1,
    // },
    // {
    //   "content": "National Provider Identifier - Not matched.", "groupNum": 2,
    // },
    // {
    //   "content": "209", "groupNum": 1,
    // },
    // {
    //   "content": "Per regulatory or other agreement. The provider cannot collect this amount from the patient. However, this amount may be billed to subsequent payer. Refund to patient if collected. (Use only with Group code OA)", "groupNum": 2,
    // },
    // {
    //   "content": "210", "groupNum": 1,
    // },
    // {
    //   "content": "Payment adjusted because pre-certification/authorization not received in a timely fashion", "groupNum": 2,
    // },
    // {
    //   "content": "211", "groupNum": 1,
    // },
    // {
    //   "content": "National Drug Codes (NDC) not eligible for rebate, are not covered.", "groupNum": 2,
    // },
    // {
    //   "content": "212", "groupNum": 1,
    // },
    // {
    //   "content": "Administrative surcharges are not covered", "groupNum": 2,
    // },
    // {
    //   "content": "213", "groupNum": 1,
    // },
    // {
    //   "content": "Non-compliance with the physician self referral prohibition legislation or payer policy.", "groupNum": 2,
    // },
    // {
    //   "content": "214", "groupNum": 1,
    // },
    // {
    //   "content": "Workers' Compensation claim adjudicated as non-compensable. This Payer not liable for claim or service/treatment. Note: If adjustment is at the Claim Level, the payer must send and the provider should refer to the 835 Insurance Policy Number Segment (Loop 2100 Other Claim Related Information REF qualifier 'IG') for the jurisdictional regulation. If adjustment is at the Line Level, the payer must send and the provider should refer to the 835 Healthcare Policy Identification Segment (loop 2110 Service Payment information REF). To be used for Workers' Compensation only", "groupNum": 2,
    // },
    // {
    //   "content": "215", "groupNum": 1,
    // },
    // {
    //   "content": "Based on subrogation of a third party settlement", "groupNum": 2,
    // },
    // {
    //   "content": "216", "groupNum": 1,
    // },
    // {
    //   "content": "Based on the findings of a review organization", "groupNum": 2,
    // },
    // {
    //   "content": "217", "groupNum": 1,
    // },
    // {
    //   "content": "Based on payer reasonable and customary fees. No maximum allowable defined by legislated fee arrangement. (Note: To be used for Property and Casualty only)", "groupNum": 2,
    // },
    // {
    //   "content": "218", "groupNum": 1,
    // },
    // {
    //   "content": "Based on entitlement to benefits. Note: If adjustment is at the Claim Level, the payer must send and the provider should refer to the 835 Insurance Policy Number Segment (Loop 2100 Other Claim Related Information REF qualifier 'IG') for the jurisdictional regulation. If adjustment is at the Line Level, the payer must send and the provider should refer to the 835 Healthcare Policy Identification Segment (loop 2110 Service Payment information REF). To be used for Workers' Compensation only", "groupNum": 2,
    // },
    // {
    //   "content": "219", "groupNum": 1,
    // },
    // {
    //   "content": "Based on extent of injury. Usage: If adjustment is at the Claim Level, the payer must send and the provider should refer to the 835 Insurance Policy Number Segment (Loop 2100 Other Claim Related Information REF qualifier 'IG') for the jurisdictional regulation. If adjustment is at the Line Level, the payer must send and the provider should refer to the 835 Healthcare Policy Identification Segment (loop 2110 Service Payment information REF).", "groupNum": 2,
    // },
    // {
    //   "content": "220", "groupNum": 1,
    // },
    // {
    //   "content": "The applicable fee schedule/fee database does not contain the billed code. Please resubmit a bill with the appropriate fee schedule/fee database code(s) that best describe the service(s) provided and supporting documentation if required. (Note: To be used for Property and Casualty only)", "groupNum": 2,
    // },
    // {
    //   "content": "221", "groupNum": 1,
    // },
    // {
    //   "content": "Claim is under investigation. Note: If adjustment is at the Claim Level, the payer must send and the provider should refer to the 835 Insurance Policy Number Segment (Loop 2100 Other Claim Related Information REF qualifier 'IG') for the jurisdictional regulation. If adjustment is at the Line Level, the payer must send and the provider should refer to the 835 Healthcare Policy Identification Segment (loop 2110 Service Payment information REF). (Note: To be used by Property &amp; Casualty only)", "groupNum": 2,
    // },
    // {
    //   "content": "222", "groupNum": 1,
    // },
    // {
    //   "content": "Exceeds the contracted maximum number of hours/days/units by this provider for this period. This is not patient specific. Usage: Refer to the 835 Healthcare Policy Identification Segment (loop 2110 Service Payment Information REF), if present.", "groupNum": 2,
    // },
    // {
    //   "content": "223", "groupNum": 1,
    // },
    // {
    //   "content": "Adjustment code for mandated federal, state or local law/regulation that is not already covered by another code and is mandated before a new code can be created.", "groupNum": 2,
    // },
    // {
    //   "content": "224", "groupNum": 1,
    // },
    // {
    //   "content": "Patient identification compromised by identity theft. Identity verification required for processing this and future claims.", "groupNum": 2,
    // },
    // {
    //   "content": "225", "groupNum": 1,
    // },
    // {
    //   "content": "Penalty or Interest Payment by Payer (Only used for plan to plan encounter reporting within the 837)", "groupNum": 2,
    // },
    // {
    //   "content": "226", "groupNum": 1,
    // },
    // {
    //   "content": "Information requested from the Billing/Rendering Provider was not provided or not provided timely or was insufficient/incomplete. At least one Remark Code must be provided (may be comprised of either the NCPDP Reject Reason Code, or Remittance Advice Remark Code that is not an ALERT.)", "groupNum": 2,
    // },
    // {
    //   "content": "227", "groupNum": 1,
    // },
    // {
    //   "content": "Information requested from the patient/insured/responsible party was not provided or was insufficient/incomplete. At least one Remark Code must be provided (may be comprised of either the NCPDP Reject Reason Code, or Remittance Advice Remark Code that is not an ALERT.)", "groupNum": 2,
    // },
    // {
    //   "content": "228", "groupNum": 1,
    // },
    // {
    //   "content": "Denied for failure of this provider, another provider or the subscriber to supply requested information to a previous payer for their adjudication", "groupNum": 2,
    // },
    // {
    //   "content": "229", "groupNum": 1,
    // },
    // {
    //   "content": "Partial charge amount not considered by Medicare due to the initial claim Type of Bill being 12X. Usage: This code can only be used in the 837 transaction to convey Coordination of Benefits information when the secondary payer's cost avoidance policy allows providers to bypass claim submission to a prior payer. (Use only with Group Code PR)", "groupNum": 2,
    // },
    // {
    //   "content": "230", "groupNum": 1,
    // },
    // {
    //   "content": "No available or correlating CPT/HCPCS code to describe this service. Note: Used only by Property and Casualty.", "groupNum": 2,
    // },
    // {
    //   "content": "231", "groupNum": 1,
    // },
    // {
    //   "content": "Mutually exclusive procedures cannot be done in the same day/setting. Usage: Refer to the 835 Healthcare Policy Identification Segment (loop 2110 Service Payment Information REF), if present.", "groupNum": 2,
    // },
    // {
    //   "content": "232", "groupNum": 1,
    // },
    // {
    //   "content": "Institutional Transfer Amount. Usage: Applies to institutional claims only and explains the DRG amount difference when the patient care crosses multiple institutions.", "groupNum": 2,
    // },
    // {
    //   "content": "233", "groupNum": 1,
    // },
    // {
    //   "content": "Services/charges related to the treatment of a hospital-acquired condition or preventable medical error.", "groupNum": 2,
    // },
    // {
    //   "content": "234", "groupNum": 1,
    // },
    // {
    //   "content": "This procedure is not paid separately. At least one Remark Code must be provided (may be comprised of either the NCPDP Reject Reason Code, or Remittance Advice Remark Code that is not an ALERT.)", "groupNum": 2,
    // },
    // {
    //   "content": "235", "groupNum": 1,
    // },
    // {
    //   "content": "Sales Tax", "groupNum": 2,
    // },
    // {
    //   "content": "236", "groupNum": 1,
    // },
    // {
    //   "content": "This procedure or procedure/modifier combination is not compatible with another procedure or procedure/modifier combination provided on the same day according to the National Correct Coding Initiative or workers compensation state regulations/ fee schedule requirements.", "groupNum": 2,
    // },
    // {
    //   "content": "237", "groupNum": 1,
    // },
    // {
    //   "content": "Legislated/Regulatory Penalty. At least one Remark Code must be provided (may be comprised of either the NCPDP Reject Reason Code, or Remittance Advice Remark Code that is not an ALERT.)", "groupNum": 2,
    // },
    // {
    //   "content": "238", "groupNum": 1,
    // },
    // {
    //   "content": "Claim spans eligible and ineligible periods of coverage, this is the reduction for the ineligible period. (Use only with Group Code PR)", "groupNum": 2,
    // },
    // {
    //   "content": "239", "groupNum": 1,
    // },
    // {
    //   "content": "Claim spans eligible and ineligible periods of coverage. Rebill separate claims.", "groupNum": 2,
    // },
    // {
    //   "content": "240", "groupNum": 1,
    // },
    // {
    //   "content": "The diagnosis is inconsistent with the patient's birth weight. Usage: Refer to the 835 Healthcare Policy Identification Segment (loop 2110 Service Payment Information REF), if present.", "groupNum": 2,
    // },
    // {
    //   "content": "241", "groupNum": 1,
    // },
    // {
    //   "content": "Low Income Subsidy (LIS) Co-payment Amount", "groupNum": 2,
    // },
    // {
    //   "content": "242", "groupNum": 1,
    // },
    // {
    //   "content": "Services not provided by network/primary care providers.", "groupNum": 2,
    // },
    // {
    //   "content": "243", "groupNum": 1,
    // },
    // {
    //   "content": "Services not authorized by network/primary care providers.", "groupNum": 2,
    // },
    // {
    //   "content": "244", "groupNum": 1,
    // },
    // {
    //   "content": "Payment reduced to zero due to litigation. Additional information will be sent following the conclusion of litigation. To be used for Property &amp; Casualty only.", "groupNum": 2,
    // },
    // {
    //   "content": "245", "groupNum": 1,
    // },
    // {
    //   "content": "Provider performance program withhold.", "groupNum": 2,
    // },
    // {
    //   "content": "246", "groupNum": 1,
    // },
    // {
    //   "content": "This non-payable code is for required reporting only.", "groupNum": 2,
    // },
    // {
    //   "content": "247", "groupNum": 1,
    // },
    // {
    //   "content": "Deductible for Professional service rendered in an Institutional setting and billed on an Institutional claim.", "groupNum": 2,
    // },
    // {
    //   "content": "248", "groupNum": 1,
    // },
    // {
    //   "content": "Coinsurance for Professional service rendered in an Institutional setting and billed on an Institutional claim.", "groupNum": 2,
    // },
    // {
    //   "content": "249", "groupNum": 1,
    // },
    // {
    //   "content": "This claim has been identified as a readmission. (Use only with Group Code CO)", "groupNum": 2,
    // },
    // {
    //   "content": "250", "groupNum": 1,
    // },
    // {
    //   "content": "The attachment/other documentation that was received was the incorrect attachment/document. The expected attachment/document is still missing. At least one Remark Code must be provided (may be comprised of either the NCPDP Reject Reason Code, or Remittance Advice Remark Code that is not an ALERT).", "groupNum": 2,
    // },
    // {
    //   "content": "251", "groupNum": 1,
    // },
    // {
    //   "content": "The attachment/other documentation that was received was incomplete or deficient. The necessary information is still needed to process the claim. At least one Remark Code must be provided (may be comprised of either the NCPDP Reject Reason Code, or Remittance Advice Remark Code that is not an ALERT).", "groupNum": 2,
    // },
    // {
    //   "content": "252", "groupNum": 1,
    // },
    // {
    //   "content": "An attachment/other documentation is required to adjudicate this claim/service. At least one Remark Code must be provided (may be comprised of either the NCPDP Reject Reason Code, or Remittance Advice Remark Code that is not an ALERT).", "groupNum": 2,
    // },
    // {
    //   "content": "253", "groupNum": 1,
    // },
    // {
    //   "content": "Sequestration - reduction in federal payment", "groupNum": 2,
    // },
    // {
    //   "content": "254", "groupNum": 1,
    // },
    // {
    //   "content": "Claim received by the dental plan, but benefits not available under this plan.  Submit these services to the patient's medical plan for further consideration.", "groupNum": 2,
    // },
    // {
    //   "content": "255", "groupNum": 1,
    // },
    // {
    //   "content": "The disposition of the related Property &amp; Casualty claim (injury or illness) is pending due to litigation. (Use only with Group Code OA)", "groupNum": 2,
    // },
    // {
    //   "content": "256", "groupNum": 1,
    // },
    // {
    //   "content": "Service not payable per managed care contract.", "groupNum": 2,
    // },
    // {
    //   "content": "257", "groupNum": 1,
    // },
    // {
    //   "content": "The disposition of the claim/service is undetermined during the premium payment grace period, per Health Insurance Exchange requirements. This claim/service will be reversed and corrected when the grace period ends (due to premium payment or lack of premium payment). (Use only with Group Code OA)", "groupNum": 2,
    // },
    // {
    //   "content": "258", "groupNum": 1,
    // },
    // {
    //   "content": "Claim/service not covered when patient is in custody/incarcerated. Applicable federal, state or local authority may cover the claim/service.", "groupNum": 2,
    // },
    // {
    //   "content": "259", "groupNum": 1,
    // },
    // {
    //   "content": "Additional payment for Dental/Vision service utilization.", "groupNum": 2,
    // },
    // {
    //   "content": "260", "groupNum": 1,
    // },
    // {
    //   "content": "Processed under Medicaid ACA Enhanced Fee Schedule", "groupNum": 2,
    // },
    // {
    //   "content": "261", "groupNum": 1,
    // },
    // {
    //   "content": "The procedure or service is inconsistent with the patient's history.", "groupNum": 2,
    // },
    // {
    //   "content": "262", "groupNum": 1,
    // },
    // {
    //   "content": "Adjustment for delivery cost. Usage: To be used for pharmaceuticals only.", "groupNum": 2,
    // },
    // {
    //   "content": "263", "groupNum": 1,
    // },
    // {
    //   "content": "Adjustment for shipping cost. Usage: To be used for pharmaceuticals only.", "groupNum": 2,
    // },
    // {
    //   "content": "264", "groupNum": 1,
    // },
    // {
    //   "content": "Adjustment for postage cost. Usage: To be used for pharmaceuticals only.", "groupNum": 2,
    // },
    // {
    //   "content": "265", "groupNum": 1,
    // },
    // {
    //   "content": "Adjustment for administrative cost. Usage: To be used for pharmaceuticals only.", "groupNum": 2,
    // },
    // {
    //   "content": "266", "groupNum": 1,
    // },
    // {
    //   "content": "Adjustment for compound preparation cost. Usage: To be used for pharmaceuticals only.", "groupNum": 2,
    // },
    // {
    //   "content": "267", "groupNum": 1,
    // },
    // {
    //   "content": "Claim/service spans multiple months. At least one Remark Code must be provided (may be comprised of either the NCPDP Reject Reason Code, or Remittance Advice Remark Code that is not an ALERT.)", "groupNum": 2,
    // },
    // {
    //   "content": "268", "groupNum": 1,
    // },
    // {
    //   "content": "The Claim spans two calendar years. Please resubmit one claim per calendar year.", "groupNum": 2,
    // },
    // {
    //   "content": "269", "groupNum": 1,
    // },
    // {
    //   "content": "Anesthesia not covered for this service/procedure. Usage: Refer to the 835 Healthcare Policy Identification Segment (loop 2110 Service Payment Information REF), if present.", "groupNum": 2,
    // },
    // {
    //   "content": "270", "groupNum": 1,
    // },
    // {
    //   "content": "Claim received by the medical plan, but benefits not available under this plan. Submit these services to the patient's dental plan for further consideration.", "groupNum": 2,
    // },
    // {
    //   "content": "271", "groupNum": 1,
    // },
    // {
    //   "content": "Prior contractual reductions related to a current periodic payment as part of a contractual payment schedule when deferred amounts have been previously reported. (Use only with Group Code OA)", "groupNum": 2,
    // },
    // {
    //   "content": "272", "groupNum": 1,
    // },
    // {
    //   "content": "Coverage/program guidelines were not met.", "groupNum": 2,
    // },
    // {
    //   "content": "273", "groupNum": 1,
    // },
    // {
    //   "content": "Coverage/program guidelines were exceeded.", "groupNum": 2,
    // },
    // {
    //   "content": "274", "groupNum": 1,
    // },
    // {
    //   "content": "Fee/Service not payable per patient Care Coordination arrangement.", "groupNum": 2,
    // },
    // {
    //   "content": "275", "groupNum": 1,
    // },
    // {
    //   "content": "Prior payer's (or payers') patient responsibility (deductible, coinsurance, co-payment) not covered. (Use only with Group Code PR)", "groupNum": 2,
    // },
    // {
    //   "content": "276", "groupNum": 1,
    // },
    // {
    //   "content": "Services denied by the prior payer(s) are not covered by this payer.", "groupNum": 2,
    // },
    // {
    //   "content": "277", "groupNum": 1,
    // },
    // {
    //   "content": "The disposition of the claim/service is undetermined during the premium payment grace period, per Health Insurance SHOP Exchange requirements. This claim/service will be reversed and corrected when the grace period ends (due to premium payment or lack of premium payment). (Use only with Group Code OA)", "groupNum": 2,
    // },
    // {
    //   "content": "278", "groupNum": 1,
    // },
    // {
    //   "content": "Performance program proficiency requirements not met. (Use only with Group Codes CO or PI) Usage: Refer to the 835 Healthcare Policy Identification Segment (loop 2110 Service Payment Information REF), if present.", "groupNum": 2,
    // },
    // {
    //   "content": "279", "groupNum": 1,
    // },
    // {
    //   "content": "Services not provided by Preferred network providers. Usage: Use this code when there are member network limitations. For example, using contracted providers not in the member's 'narrow' network.", "groupNum": 2,
    // },
    // {
    //   "content": "280", "groupNum": 1,
    // },
    // {
    //   "content": "Claim received by the medical plan, but benefits not available under this plan. Submit these services to the patient's Pharmacy plan for further consideration.", "groupNum": 2,
    // },
    // {
    //   "content": "281", "groupNum": 1,
    // },
    // {
    //   "content": "Deductible waived per contractual agreement. Use only with Group Code CO.", "groupNum": 2,
    // },
    // {
    //   "content": "282", "groupNum": 1,
    // },
    // {
    //   "content": "The procedure/revenue code is inconsistent with the type of bill. Usage: Refer to the 835 Healthcare Policy Identification Segment (loop 2110 Service Payment Information REF), if present.", "groupNum": 2,
    // },
    // {
    //   "content": "283", "groupNum": 1,
    // },
    // {
    //   "content": "Attending provider is not eligible to provide direction of care.", "groupNum": 2,
    // },
    // {
    //   "content": "284", "groupNum": 1,
    // },
    // {
    //   "content": "Precertification/authorization/notification/pre-treatment number may be valid but does not apply to the billed services.", "groupNum": 2,
    // },
    // {
    //   "content": "285", "groupNum": 1,
    // },
    // {
    //   "content": "Appeal procedures not followed", "groupNum": 2,
    // },
    // {
    //   "content": "286", "groupNum": 1,
    // },
    // {
    //   "content": "Appeal time limits not met", "groupNum": 2,
    // },
    // {
    //   "content": "287", "groupNum": 1,
    // },
    // {
    //   "content": "Referral exceeded", "groupNum": 2,
    // },
    // {
    //   "content": "288", "groupNum": 1,
    // },
    // {
    //   "content": "Referral absent", "groupNum": 2,
    // },
    // {
    //   "content": "289", "groupNum": 1,
    // },
    // {
    //   "content": "Services considered under the dental and medical plans, benefits not available.", "groupNum": 2,
    // },
    // {
    //   "content": "290", "groupNum": 1,
    // },
    // {
    //   "content": "Claim received by the dental plan, but benefits not available under this plan. Claim has been forwarded to the patient's medical plan for further consideration.", "groupNum": 2,
    // },
    // {
    //   "content": "291", "groupNum": 1,
    // },
    // {
    //   "content": "Claim received by the medical plan, but benefits not available under this plan. Claim has been forwarded to the patient's dental plan for further consideration.", "groupNum": 2,
    // },
    // {
    //   "content": "292", "groupNum": 1,
    // },
    // {
    //   "content": "Claim received by the medical plan, but benefits not available under this plan. Claim has been forwarded to the patient's pharmacy plan for further consideration.", "groupNum": 2,
    // },
    // {
    //   "content": "293", "groupNum": 1,
    // },
    // {
    //   "content": "Payment made to employer.", "groupNum": 2,
    // },
    // {
    //   "content": "294", "groupNum": 1,
    // },
    // {
    //   "content": "Payment made to attorney.", "groupNum": 2,
    // },
    // {
    //   "content": "295", "groupNum": 1,
    // },
    // {
    //   "content": "Pharmacy Direct/Indirect Remuneration (DIR)", "groupNum": 2,
    // },
    // {
    //   "content": "296", "groupNum": 1,
    // },
    // {
    //   "content": "Precertification/authorization/notification/pre-treatment number may be valid but does not apply to the provider.", "groupNum": 2,
    // },
    // {
    //   "content": "297", "groupNum": 1,
    // },
    // {
    //   "content": "Claim received by the medical plan, but benefits not available under this plan. Submit these services to the patient's vision plan for further consideration.", "groupNum": 2,
    // },
    // {
    //   "content": "298", "groupNum": 1,
    // },
    // {
    //   "content": "Claim received by the medical plan, but benefits not available under this plan. Claim has been forwarded to the patient's vision plan for further consideration.", "groupNum": 2,
    // },
    // {
    //   "content": "299", "groupNum": 1,
    // },
    // {
    //   "content": "The billing provider is not eligible to receive payment for the service billed.", "groupNum": 2,
    // },
    // {
    //   "content": "300", "groupNum": 1,
    // },
    // {
    //   "content": "Claim received by the Medical Plan, but benefits not available under this plan. Claim has been forwarded to the patient's Behavioral Health Plan for further consideration.", "groupNum": 2,
    // },
    // {
    //   "content": "301", "groupNum": 1,
    // },
    // {
    //   "content": "Claim received by the Medical Plan, but benefits not available under this plan. Submit these services to the patient's Behavioral Health Plan for further consideration.", "groupNum": 2,
    // },
    // {
    //   "content": "302", "groupNum": 1,
    // },
    // {
    //   "content": "Precertification/notification/authorization/pre-treatment time limit has expired.", "groupNum": 2,
    // },
    // {
    //   "content": "303", "groupNum": 1,
    // },
    // {
    //   "content": "Prior payer's (or payers') patient responsibility (deductible, coinsurance, co-payment) not covered for Qualified Medicare and Medicaid Beneficiaries. (Use only with Group Code CO)", "groupNum": 2,
    // },
    // {
    //   "content": "304", "groupNum": 1,
    // },
    // {
    //   "content": "Claim received by the medical plan, but benefits not available under this plan. Submit these services to the patient's hearing plan for further consideration.", "groupNum": 2,
    // },
    // {
    //   "content": "305", "groupNum": 1,
    // },
    // {
    //   "content": "Claim received by the medical plan, but benefits not available under this plan. Claim has been forwarded to the patient's hearing plan for further consideration.", "groupNum": 2,
    // },
    // {
    //   "content": "A0", "groupNum": 1,
    // },
    // {
    //   "content": "Patient refund amount.", "groupNum": 2,
    // },
    // {
    //   "content": "A1", "groupNum": 1,
    // },
    // {
    //   "content": "Claim/Service denied. At least one Remark Code must be provided (may be comprised of either the NCPDP Reject Reason Code, or Remittance Advice Remark Code that is not an ALERT.)  The following will be added to this definition on 7/1/2023, Usage: Use this code only when a more specific Claim Adjustment Reason Code is not available.", "groupNum": 2,
    // },
    // {
    //   "content": "A2", "groupNum": 1,
    // },
    // {
    //   "content": "Contractual adjustment.", "groupNum": 2,
    // },
    // {
    //   "content": "A3", "groupNum": 1,
    // },
    // {
    //   "content": "Medicare Secondary Payer liability met.", "groupNum": 2,
    // },
    // {
    //   "content": "A4", "groupNum": 1,
    // },
    // {
    //   "content": "Medicare Claim PPS Capital Day Outlier Amount.", "groupNum": 2,
    // },
    // {
    //   "content": "A5", "groupNum": 1,
    // },
    // {
    //   "content": "Medicare Claim PPS Capital Cost Outlier Amount.", "groupNum": 2,
    // },
    // {
    //   "content": "A6", "groupNum": 1,
    // },
    // {
    //   "content": "Prior hospitalization or 30 day transfer requirement not met.", "groupNum": 2,
    // },
    // {
    //   "content": "A7", "groupNum": 1,
    // },
    // {
    //   "content": "Presumptive Payment Adjustment", "groupNum": 2,
    // },
    // {
    //   "content": "A8", "groupNum": 1,
    // },
    // {
    //   "content": "Ungroupable DRG.", "groupNum": 2,
    // },
    // {
    //   "content": "B1", "groupNum": 1,
    // },
    // {
    //   "content": "Non-covered visits.", "groupNum": 2,
    // },
    // {
    //   "content": "B2", "groupNum": 1,
    // },
    // {
    //   "content": "Covered visits.", "groupNum": 2,
    // },
    // {
    //   "content": "B3", "groupNum": 1,
    // },
    // {
    //   "content": "Covered charges.", "groupNum": 2,
    // },
    // {
    //   "content": "B4", "groupNum": 1,
    // },
    // {
    //   "content": "Late filing penalty.", "groupNum": 2,
    // },
    // {
    //   "content": "B5", "groupNum": 1,
    // },
    // {
    //   "content": "Coverage/program guidelines were not met or were exceeded.", "groupNum": 2,
    // },
    // {
    //   "content": "B6", "groupNum": 1,
    // },
    // {
    //   "content": "This payment is adjusted when performed/billed by this type of provider, by this type of provider in this type of facility, or by a provider of this specialty.", "groupNum": 2,
    // },
    // {
    //   "content": "B7", "groupNum": 1,
    // },
    // {
    //   "content": "This provider was not certified/eligible to be paid for this procedure/service on this date of service. Usage: Refer to the 835 Healthcare Policy Identification Segment (loop 2110 Service Payment Information REF), if present.", "groupNum": 2,
    // },
    // {
    //   "content": "B8", "groupNum": 1,
    // },
    // {
    //   "content": "Alternative services were available, and should have been utilized. Usage: Refer to the 835 Healthcare Policy Identification Segment (loop 2110 Service Payment Information REF), if present.", "groupNum": 2,
    // },
    // {
    //   "content": "B9", "groupNum": 1,
    // },
    // {
    //   "content": "Patient is enrolled in a Hospice.", "groupNum": 2,
    // },
    // {
    //   "content": "B10", "groupNum": 1,
    // },
    // {
    //   "content": "Allowed amount has been reduced because a component of the basic procedure/test was paid. The beneficiary is not liable for more than the charge limit for the basic procedure/test.", "groupNum": 2,
    // },
    // {
    //   "content": "B11", "groupNum": 1,
    // },
    // {
    //   "content": "The claim/service has been transferred to the proper payer/processor for processing. Claim/service not covered by this payer/processor.", "groupNum": 2,
    // },
    // {
    //   "content": "B12", "groupNum": 1,
    // },
    // {
    //   "content": "Services not documented in patient's medical records.", "groupNum": 2,
    // },
    // {
    //   "content": "B13", "groupNum": 1,
    // },
    // {
    //   "content": "Previously paid. Payment for this claim/service may have been provided in a previous payment.", "groupNum": 2,
    // },
    // {
    //   "content": "B14", "groupNum": 1,
    // },
    // {
    //   "content": "Only one visit or consultation per physician per day is covered.", "groupNum": 2,
    // },
    // {
    //   "content": "B15", "groupNum": 1,
    // },
    // {
    //   "content": "This service/procedure requires that a qualifying service/procedure be received and covered. The qualifying other service/procedure has not been received/adjudicated. Usage: Refer to the 835 Healthcare Policy Identification Segment (loop 2110 Service Payment Information REF), if present.", "groupNum": 2,
    // },
    // {
    //   "content": "B16", "groupNum": 1,
    // },
    // {
    //   "content": "'New Patient' qualifications were not met.", "groupNum": 2,
    // },
    // {
    //   "content": "B17", "groupNum": 1,
    // },
    // {
    //   "content": "Payment adjusted because this service was not prescribed by a physician, not prescribed prior to delivery, the prescription is incomplete, or the prescription is not current.", "groupNum": 2,
    // },
    // {
    //   "content": "B18", "groupNum": 1,
    // },
    // {
    //   "content": "This procedure code and modifier were invalid on the date of service.", "groupNum": 2,
    // },
    // {
    //   "content": "B19", "groupNum": 1,
    // },
    // {
    //   "content": "Claim/service adjusted because of the finding of a Review Organization.", "groupNum": 2,
    // },
    // {
    //   "content": "B20", "groupNum": 1,
    // },
    // {
    //   "content": "Procedure/service was partially or fully furnished by another provider.", "groupNum": 2,
    // },
    // {
    //   "content": "B21", "groupNum": 1,
    // },
    // {
    //   "content": "The charges were reduced because the service/care was partially furnished by another physician.", "groupNum": 2,
    // },
    // {
    //   "content": "B22", "groupNum": 1,
    // },
    // {
    //   "content": "This payment is adjusted based on the diagnosis.", "groupNum": 2,
    // },
    // {
    //   "content": "B23", "groupNum": 1,
    // },
    // {
    //   "content": "Procedure billed is not authorized per your Clinical Laboratory Improvement Amendment (CLIA) proficiency test.", "groupNum": 2,
    // },
    // {
    //   "content": "D1", "groupNum": 1,
    // },
    // {
    //   "content": "Claim/service denied. Level of subluxation is missing or inadequate.", "groupNum": 2,
    // },
    // {
    //   "content": "D2", "groupNum": 1,
    // },
    // {
    //   "content": "Claim lacks the name, strength, or dosage of the drug furnished.", "groupNum": 2,
    // },
    // {
    //   "content": "D3", "groupNum": 1,
    // },
    // {
    //   "content": "Claim/service denied because information to indicate if the patient owns the equipment that requires the part or supply was missing.", "groupNum": 2,
    // },
    // {
    //   "content": "D4", "groupNum": 1,
    // },
    // {
    //   "content": "Claim/service does not indicate the period of time for which this will be needed.", "groupNum": 2,
    // },
    // {
    //   "content": "D5", "groupNum": 1,
    // },
    // {
    //   "content": "Claim/service denied. Claim lacks individual lab codes included in the test.", "groupNum": 2,
    // },
    // {
    //   "content": "D6", "groupNum": 1,
    // },
    // {
    //   "content": "Claim/service denied. Claim did not include patient's medical record for the service.", "groupNum": 2,
    // },
    // {
    //   "content": "D7", "groupNum": 1,
    // },
    // {
    //   "content": "Claim/service denied. Claim lacks date of patient's most recent physician visit.", "groupNum": 2,
    // },
    // {
    //   "content": "D8", "groupNum": 1,
    // },
    // {
    //   "content": "Claim/service denied. Claim lacks indicator that 'x-ray is available for review.'", "groupNum": 2,
    // },
    // {
    //   "content": "D9", "groupNum": 1,
    // },
    // {
    //   "content": "Claim/service denied. Claim lacks invoice or statement certifying the actual cost of the lens, less discounts or the type of intraocular lens used.", "groupNum": 2,
    // },
    // {
    //   "content": "D10", "groupNum": 1,
    // },
    // {
    //   "content": "Claim/service denied. Completed physician financial relationship form not on file.", "groupNum": 2,
    // },
    // {
    //   "content": "D11", "groupNum": 1,
    // },
    // {
    //   "content": "Claim lacks completed pacemaker registration form.", "groupNum": 2,
    // },
    // {
    //   "content": "D12", "groupNum": 1,
    // },
    // {
    //   "content": "Claim/service denied. Claim does not identify who performed the purchased diagnostic test or the amount you were charged for the test.", "groupNum": 2,
    // },
    // {
    //   "content": "D13", "groupNum": 1,
    // },
    // {
    //   "content": "Claim/service denied. Performed by a facility/supplier in which the ordering/referring physician has a financial interest.", "groupNum": 2,
    // },
    // {
    //   "content": "D14", "groupNum": 1,
    // },
    // {
    //   "content": "Claim lacks indication that plan of treatment is on file.", "groupNum": 2,
    // },
    // {
    //   "content": "D15", "groupNum": 1,
    // },
    // {
    //   "content": "Claim lacks indication that service was supervised or evaluated by a physician.", "groupNum": 2,
    // },
    // {
    //   "content": "D16", "groupNum": 1,
    // },
    // {
    //   "content": "Claim lacks prior payer payment information.", "groupNum": 2,
    // },
    // {
    //   "content": "D17", "groupNum": 1,
    // },
    // {
    //   "content": "Claim/Service has invalid non-covered days.", "groupNum": 2,
    // },
    // {
    //   "content": "D18", "groupNum": 1,
    // },
    // {
    //   "content": "Claim/Service has missing diagnosis information.", "groupNum": 2,
    // },
    // {
    //   "content": "D19", "groupNum": 1,
    // },
    // {
    //   "content": "Claim/Service lacks Physician/Operative or other supporting documentation", "groupNum": 2,
    // },
    // {
    //   "content": "D20", "groupNum": 1,
    // },
    // {
    //   "content": "Claim/Service missing service/product information.", "groupNum": 2,
    // },
    // {
    //   "content": "D21", "groupNum": 1,
    // },
    // {
    //   "content": "This (these) diagnosis(es) is (are) missing or are invalid", "groupNum": 2,
    // },
    // {
    //   "content": "D22", "groupNum": 1,
    // },
    // {
    //   "content": "Reimbursement was adjusted for the reasons to be provided in separate correspondence. (Note: To be used for Workers' Compensation only) - Temporary code to be added for timeframe only until 01/01/2009. Another code to be established and/or for 06/2008 meeting for a revised code to replace or strategy to use another existing code", "groupNum": 2,
    // },
    // {
    //   "content": "D23", "groupNum": 1,
    // },
    // {
    //   "content": "This dual eligible patient is covered by Medicare Part D per Medicare Retro-Eligibility.  At least one Remark Code must be provided (may be comprised of either the NCPDP Reject Reason Code, or Remittance Advice Remark Code that is not an ALERT.)", "groupNum": 2,
    // },
    // {
    //   "content": "P1", "groupNum": 1,
    // },
    // {
    //   "content": "State-mandated Requirement for Property and Casualty, see Claim Payment Remarks Code for specific explanation. To be used for Property and Casualty only.", "groupNum": 2,
    // },
    // {
    //   "content": "P2", "groupNum": 1,
    // },
    // {
    //   "content": "Not a work related injury/illness and thus not the liability of the workers' compensation carrier Usage: If adjustment is at the Claim Level, the payer must send and the provider should refer to the 835 Insurance Policy Number Segment (Loop 2100 Other Claim Related Information REF qualifier 'IG') for the jurisdictional regulation. If adjustment is at the Line Level, the payer must send and the provider should refer to the 835 Healthcare Policy Identification Segment (loop 2110 Service Payment information REF). To be used for Workers' Compensation only.", "groupNum": 2,
    // },
    // {
    //   "content": "P3", "groupNum": 1,
    // },
    // {
    //   "content": "Workers' Compensation case settled. Patient is responsible for amount of this claim/service through WC 'Medicare set aside arrangement' or other agreement. To be used for Workers' Compensation only. (Use only with Group Code PR)", "groupNum": 2,
    // },
    // {
    //   "content": "P4", "groupNum": 1,
    // },
    // {
    //   "content": "Workers' Compensation claim adjudicated as non-compensable. This Payer not liable for claim or service/treatment. Usage: If adjustment is at the Claim Level, the payer must send and the provider should refer to the 835 Insurance Policy Number Segment (Loop 2100 Other Claim Related Information REF qualifier 'IG') for the jurisdictional regulation. If adjustment is at the Line Level, the payer must send and the provider should refer to the 835 Healthcare Policy Identification Segment (loop 2110 Service Payment information REF). To be used for Workers' Compensation only", "groupNum": 2,
    // },
    // {
    //   "content": "P5", "groupNum": 1,
    // },
    // {
    //   "content": "Based on payer reasonable and customary fees. No maximum allowable defined by legislated fee arrangement. To be used for Property and Casualty only.", "groupNum": 2,
    // },
    // {
    //   "content": "P6", "groupNum": 1,
    // },
    // {
    //   "content": "Based on entitlement to benefits. Usage: If adjustment is at the Claim Level, the payer must send and the provider should refer to the 835 Insurance Policy Number Segment (Loop 2100 Other Claim Related Information REF qualifier 'IG') for the jurisdictional regulation. If adjustment is at the Line Level, the payer must send and the provider should refer to the 835 Healthcare Policy Identification Segment (loop 2110 Service Payment information REF). To be used for Property and Casualty only.", "groupNum": 2,
    // },
    // {
    //   "content": "P7", "groupNum": 1,
    // },
    // {
    //   "content": "The applicable fee schedule/fee database does not contain the billed code. Please resubmit a bill with the appropriate fee schedule/fee database code(s) that best describe the service(s) provided and supporting documentation if required. To be used for Property and Casualty only.", "groupNum": 2,
    // },
    // {
    //   "content": "P8", "groupNum": 1,
    // },
    // {
    //   "content": "Claim is under investigation. Usage: If adjustment is at the Claim Level, the payer must send and the provider should refer to the 835 Insurance Policy Number Segment (Loop 2100 Other Claim Related Information REF qualifier 'IG') for the jurisdictional regulation. If adjustment is at the Line Level, the payer must send and the provider should refer to the 835 Healthcare Policy Identification Segment (loop 2110 Service Payment information REF). To be used for Property and Casualty only.", "groupNum": 2,
    // },
    // {
    //   "content": "P9", "groupNum": 1,
    // },
    // {
    //   "content": "No available or correlating CPT/HCPCS code to describe this service. To be used for Property and Casualty only.", "groupNum": 2,
    // },
    // {
    //   "content": "P10", "groupNum": 1,
    // },
    // {
    //   "content": "Payment reduced to zero due to litigation. Additional information will be sent following the conclusion of litigation. To be used for Property and Casualty only.", "groupNum": 2,
    // },
    // {
    //   "content": "P11", "groupNum": 1,
    // },
    // {
    //   "content": "The disposition of the related Property &amp; Casualty claim (injury or illness) is pending due to litigation. To be used for Property and Casualty only. (Use only with Group Code OA)", "groupNum": 2,
    // },
    // {
    //   "content": "P12", "groupNum": 1,
    // },
    // {
    //   "content": "Workers' compensation jurisdictional fee schedule adjustment. Usage: If adjustment is at the Claim Level, the payer must send and the provider should refer to the 835 Class of Contract Code Identification Segment (Loop 2100 Other Claim Related Information REF). If adjustment is at the Line Level, the payer must send and the provider should refer to the 835 Healthcare Policy Identification Segment (loop 2110 Service Payment information REF) if the regulations apply. To be used for Workers' Compensation only.", "groupNum": 2,
    // },
    // {
    //   "content": "P13", "groupNum": 1,
    // },
    // {
    //   "content": "Payment reduced or denied based on workers' compensation jurisdictional regulations or payment policies, use only if no other code is applicable. Usage: If adjustment is at the Claim Level, the payer must send and the provider should refer to the 835 Insurance Policy Number Segment (Loop 2100 Other Claim Related Information REF qualifier 'IG') if the jurisdictional regulation applies. If adjustment is at the Line Level, the payer must send and the provider should refer to the 835 Healthcare Policy Identification Segment (loop 2110 Service Payment information REF) if the regulations apply. To be used for Workers' Compensation only.", "groupNum": 2,
    // },
    // {
    //   "content": "P14", "groupNum": 1,
    // },
    // {
    //   "content": "The Benefit for this Service is included in the payment/allowance for another service/procedure that has been performed on the same day. Usage: Refer to the 835 Healthcare Policy Identification Segment (loop 2110 Service Payment Information REF), if present. To be used for Property and Casualty only.", "groupNum": 2,
    // },
    // {
    //   "content": "P15", "groupNum": 1,
    // },
    // {
    //   "content": "Workers' Compensation Medical Treatment Guideline Adjustment. To be used for Workers' Compensation only.", "groupNum": 2,
    // },
    // {
    //   "content": "P16", "groupNum": 1,
    // },
    // {
    //   "content": "Medical provider not authorized/certified to provide treatment to injured workers in this jurisdiction. To be used for Workers' Compensation only. (Use with Group Code CO or OA)", "groupNum": 2,
    // },
    // {
    //   "content": "P17", "groupNum": 1,
    // },
    // {
    //   "content": "Referral not authorized by attending physician per regulatory requirement. To be used for Property and Casualty only.", "groupNum": 2,
    // },
    // {
    //   "content": "P18", "groupNum": 1,
    // },
    // {
    //   "content": "Procedure is not listed in the jurisdiction fee schedule.  An allowance has been made for a comparable service. To be used for Property and Casualty only.", "groupNum": 2,
    // },
    // {
    //   "content": "P19", "groupNum": 1,
    // },
    // {
    //   "content": "Procedure has a relative value of zero in the jurisdiction fee schedule, therefore no payment is due. To be used for Property and Casualty only.", "groupNum": 2,
    // },
    // {
    //   "content": "P20", "groupNum": 1,
    // },
    // {
    //   "content": "Service not paid under jurisdiction allowed outpatient facility fee schedule. To be used for Property and Casualty only.", "groupNum": 2,
    // },
    // {
    //   "content": "P21", "groupNum": 1,
    // },
    // {
    //   "content": "Payment denied based on the Medical Payments Coverage (MPC) and/or Personal Injury Protection (PIP) Benefits jurisdictional regulations, or payment policies. Usage: If adjustment is at the Claim Level, the payer must send and the provider should refer to the 835 Insurance Policy Number Segment (Loop 2100 Other Claim Related Information REF qualifier 'IG') if the jurisdictional regulation applies. If adjustment is at the Line Level, the payer must send and the provider should refer to the 835 Healthcare Policy Identification Segment (loop 2110 Service Payment information REF) if the regulations apply. To be used for Property and Casualty Auto only.", "groupNum": 2,
    // },
    // {
    //   "content": "P22", "groupNum": 1,
    // },
    // {
    //   "content": "Payment adjusted based on the Medical Payments Coverage (MPC) and/or Personal Injury Protection (PIP) Benefits jurisdictional regulations, or payment policies. Usage: If adjustment is at the Claim Level, the payer must send and the provider should refer to the 835 Insurance Policy Number Segment (Loop 2100 Other Claim Related Information REF qualifier 'IG') if the jurisdictional regulation applies. If adjustment is at the Line Level, the payer must send and the provider should refer to the 835 Healthcare Policy Identification Segment (loop 2110 Service Payment information REF) if the regulations apply. To be used for Property and Casualty Auto only.", "groupNum": 2,
    // },
    // {
    //   "content": "P23", "groupNum": 1,
    // },
    // {
    //   "content": "Medical Payments Coverage (MPC) or Personal Injury Protection (PIP) Benefits jurisdictional fee schedule adjustment. Usage: If adjustment is at the Claim Level, the payer must send and the provider should refer to the 835 Class of Contract Code Identification Segment (Loop 2100 Other Claim Related Information REF). If adjustment is at the Line Level, the payer must send and the provider should refer to the 835 Healthcare Policy Identification Segment (loop 2110 Service Payment information REF) if the regulations apply. To be used for Property and Casualty Auto only.", "groupNum": 2,
    // },
    // {
    //   "content": "P24", "groupNum": 1,
    // },
    // {
    //   "content": "Payment adjusted based on Preferred Provider Organization (PPO).  Usage: If adjustment is at the Claim Level, the payer must send and the provider should refer to the 835 Class of Contract Code Identification Segment (Loop 2100 Other Claim Related Information REF). If adjustment is at the Line Level, the payer must send and the provider should refer to the 835 Healthcare Policy Identification Segment (loop 2110 Service Payment information REF) if the regulations apply. To be used for Property and Casualty only. Use only with Group Code CO.", "groupNum": 2,
    // },
    // {
    //   "content": "P25", "groupNum": 1,
    // },
    // {
    //   "content": "Payment adjusted based on Medical Provider Network (MPN).  Usage: If adjustment is at the Claim Level, the payer must send and the provider should refer to the 835 Class of Contract Code Identification Segment (Loop 2100 Other Claim Related Information REF). If adjustment is at the Line Level, the payer must send and the provider should refer to the 835 Healthcare Policy Identification Segment (loop 2110 Service Payment information REF) if the regulations apply. To be used for Property and Casualty only. (Use only with Group Code CO).", "groupNum": 2,
    // },
    // {
    //   "content": "P26", "groupNum": 1,
    // },
    // {
    //   "content": "Payment adjusted based on Voluntary Provider network (VPN).  Usage: If adjustment is at the Claim Level, the payer must send and the provider should refer to the 835 Class of Contract Code Identification Segment (Loop 2100 Other Claim Related Information REF). If adjustment is at the Line Level, the payer must send and the provider should refer to the 835 Healthcare Policy Identification Segment (loop 2110 Service Payment information REF) if the regulations apply. To be used for Property and Casualty only. (Use only with Group Code CO).", "groupNum": 2,
    // },
    // {
    //   "content": "P27", "groupNum": 1,
    // },
    // {
    //   "content": "Payment denied based on the Liability Coverage Benefits jurisdictional regulations and/or payment policies. Usage: If adjustment is at the Claim Level, the payer must send and the provider should refer to the 835 Insurance Policy Number Segment (Loop 2100 Other Claim Related Information REF qualifier 'IG') if the jurisdictional regulation applies. If adjustment is at the Line Level, the payer must send and the provider should refer to the 835 Healthcare Policy Identification Segment (loop 2110 Service Payment information REF) if the regulations apply. To be used for Property and Casualty Auto only.", "groupNum": 2,
    // },
    // {
    //   "content": "P28", "groupNum": 1,
    // },
    // {
    //   "content": "Payment adjusted based on the Liability Coverage Benefits jurisdictional regulations and/or payment policies. Usage: If adjustment is at the Claim Level, the payer must send and the provider should refer to the 835 Insurance Policy Number Segment (Loop 2100 Other Claim Related Information REF qualifier 'IG') if the jurisdictional regulation applies. If adjustment is at the Line Level, the payer must send and the provider should refer to the 835 Healthcare Policy Identification Segment (loop 2110 Service Payment information REF) if the regulations apply. To be used for Property and Casualty Auto only.", "groupNum": 2,
    // },
    // {
    //   "content": "P29", "groupNum": 1,
    // },
    // {
    //   "content": "Liability Benefits jurisdictional fee schedule adjustment. Usage: If adjustment is at the Claim Level, the payer must send and the provider should refer to the 835 Class of Contract Code Identification Segment (Loop 2100 Other Claim Related Information REF). If adjustment is at the Line Level, the payer must send and the provider should refer to the 835 Healthcare Policy Identification Segment (loop 2110 Service Payment information REF) if the regulations apply. To be used for Property and Casualty Auto only.", "groupNum": 2,
    // },
    // {
    //   "content": "P30", "groupNum": 1,
    // },
    // {
    //   "content": "Payment denied for exacerbation when supporting documentation was not complete. To be used for Property and Casualty only.", "groupNum": 2,
    // },
    // {
    //   "content": "P31", "groupNum": 1,
    // },
    // {
    //   "content": "Payment denied for exacerbation when treatment exceeds time allowed. To be used for Property and Casualty only.", "groupNum": 2,
    // },
    // {
    //   "content": "P32", "groupNum": 1,
    // },
    // {
    //   "content": "Payment adjusted due to Apportionment.", "groupNum": 2,
    // },
    // {
    //   "content": "W1", "groupNum": 1,
    // },
    // {
    //   "content": "Workers' compensation jurisdictional fee schedule adjustment.  Note: If adjustment is at the Claim Level, the payer must send and the provider should refer to the 835 Class of Contract Code Identification Segment (Loop 2100 Other Claim Related Information REF). If adjustment is at the Line Level, the payer must send and the provider should refer to the 835 Healthcare Policy Identification Segment (loop 2110 Service Payment information REF) if the regulations apply.", "groupNum": 2,
    // },
    // {
    //   "content": "W2", "groupNum": 1,
    // },
    // {
    //   "content": "Payment reduced or denied based on workers' compensation jurisdictional regulations or payment policies, use only if no other code is applicable. Note: If adjustment is at the Claim Level, the payer must send and the provider should refer to the 835 Insurance Policy Number Segment (Loop 2100 Other Claim Related Information REF qualifier 'IG') if the jurisdictional regulation applies. If adjustment is at the Line Level, the payer must send and the provider should refer to the 835 Healthcare Policy Identification Segment (loop 2110 Service Payment information REF) if the regulations apply. To be used for Workers' Compensation only.", "groupNum": 2,
    // },
    // {
    //   "content": "W3", "groupNum": 1,
    // },
    // {
    //   "content": "The Benefit for this Service is included in the payment/allowance for another service/procedure that has been performed on the same day. Note: Refer to the 835 Healthcare Policy Identification Segment (loop 2110 Service Payment Information REF), if present. For use by Property and Casualty only.", "groupNum": 2,
    // },
    // {
    //   "content": "W4", "groupNum": 1,
    // },
    // {
    //   "content": "Workers' Compensation Medical Treatment Guideline Adjustment.", "groupNum": 2,
    // },
    // {
    //   "content": "W5", "groupNum": 1,
    // },
    // {
    //   "content": "Medical provider not authorized/certified to provide treatment to injured workers in this jurisdiction. (Use with Group Code CO or OA)", "groupNum": 2,
    // },
    // {
    //   "content": "W6", "groupNum": 1,
    // },
    // {
    //   "content": "Referral not authorized by attending physician per regulatory requirement.", "groupNum": 2,
    // },
    // {
    //   "content": "W7", "groupNum": 1,
    // },
    // {
    //   "content": "Procedure is not listed in the jurisdiction fee schedule.  An allowance has been made for a comparable service.", "groupNum": 2,
    // },
    // {
    //   "content": "W8", "groupNum": 1,
    // },
    // {
    //   "content": "Procedure has a relative value of zero in the jurisdiction fee schedule, therefore no payment is due.", "groupNum": 2,
    // },
    // {
    //   "content": "W9", "groupNum": 1,
    // },
    // {
    //   "content": "Service not paid under jurisdiction allowed outpatient facility fee schedule.", "groupNum": 2,
    // },
    // {
    //   "content": "Y1", "groupNum": 1,
    // },
    // {
    //   "content": "Payment denied based on Medical Payments Coverage (MPC) or Personal Injury Protection (PIP) Benefits jurisdictional regulations or payment policies, use only if no other code is applicable. Note: If adjustment is at the Claim Level, the payer must send and the provider should refer to the 835 Insurance Policy Number Segment (Loop 2100 Other Claim Related Information REF qualifier 'IG') if the jurisdictional regulation applies. If adjustment is at the Line Level, the payer must send and the provider should refer to the 835 Healthcare Policy Identification Segment (loop 2110 Service Payment information REF) if the regulations apply. To be used for P&amp;C Auto only.", "groupNum": 2,
    // },
    // {
    //   "content": "Y2", "groupNum": 1,
    // },
    // {
    //   "content": "Payment adjusted based on Medical Payments Coverage (MPC) or Personal Injury Protection (PIP) Benefits jurisdictional regulations or payment policies, use only if no other code is applicable. Note: If adjustment is at the Claim Level, the payer must send and the provider should refer to the 835 Insurance Policy Number Segment (Loop 2100 Other Claim Related Information REF qualifier 'IG') if the jurisdictional regulation applies. If adjustment is at the Line Level, the payer must send and the provider should refer to the 835 Healthcare Policy Identification Segment (loop 2110 Service Payment information REF) if the regulations apply. To be used for P&amp;C Auto only.", "groupNum": 2,
    // },
    // {
    //   "content": "Y3", "groupNum": 1,
    // },
    // {
    //   "content": "Medical Payments Coverage (MPC) or Personal Injury Protection (PIP) Benefits jurisdictional fee schedule adjustment. Note: If adjustment is at the Claim Level, the payer must send and the provider should refer to the 835 Class of Contract Code Identification Segment (Loop 2100 Other Claim Related Information REF). If adjustment is at the Line Level, the payer must send and the provider should refer to the 835 Healthcare Policy Identification Segment (loop 2110 Service Payment information REF) if the regulations apply. To be used for P&amp;C Auto only.", "groupNum": 2,
    // }
  ];

  rawCarcsEP: ICARC[] = [ // From Easy Print 7/03/17 3.4.1 Codes.ini file.
    // {
    //   "code": "1",
    //   "descr": "Deductible Amount "
    // },
    // {
    //   "code": "2",
    //   "descr": "Coinsurance Amount "
    // },
    // {
    //   "code": "3",
    //   "descr": "Co-payment Amount "
    // },
    // {
    //   "code": "4",
    //   "descr": "The procedure code is inconsistent with the modifier used or a required modifier is missing. Usage: Refer to the 835 Healthcare Policy Identification Segment (loop 2110 Service Payment Information REF), if present."
    // },
    // {
    //   "code": "5",
    //   "descr": "The procedure code/bill type is inconsistent with the place of service. Usage: Refer to the 835 Healthcare Policy Identification Segment (loop 2110 Service Payment Information REF), if present. "
    // },
    // {
    //   "code": "6",
    //   "descr": "The procedure/revenue code is inconsistent with the patient's age. Usage: Refer to the 835 Healthcare Policy Identification Segment (loop 2110 Service Payment Information REF), if present. "
    // },
    // {
    //   "code": "7",
    //   "descr": "The procedure/revenue code is inconsistent with the patient's gender. Usage: Refer to the 835 Healthcare Policy Identification Segment (loop 2110 Service Payment Information REF), if present. "
    // },
    // {
    //   "code": "8",
    //   "descr": "The procedure code is inconsistent with the provider type/specialty (taxonomy). Usage: Refer to the 835 Healthcare Policy Identification Segment (loop 2110 Service Payment Information REF), if present. "
    // },
    // {
    //   "code": "9",
    //   "descr": "The diagnosis is inconsistent with the patient's age. Usage: Refer to the 835 Healthcare Policy Identification Segment (loop 2110 Service Payment Information REF), if present. "
    // },
    // {
    //   "code": "10",
    //   "descr": "The diagnosis is inconsistent with the patient's gender. Usage: Refer to the 835 Healthcare Policy Identification Segment (loop 2110 Service Payment Information REF), if present. "
    // },
    // {
    //   "code": "11",
    //   "descr": "The diagnosis is inconsistent with the procedure. Usage: Refer to the 835 Healthcare Policy Identification Segment (loop 2110 Service Payment Information REF), if present. "
    // },
    // {
    //   "code": "12",
    //   "descr": "The diagnosis is inconsistent with the provider type. Usage: Refer to the 835 Healthcare Policy Identification Segment (loop 2110 Service Payment Information REF), if present. "
    // },
    // {
    //   "code": "13",
    //   "descr": "The date of death precedes the date of service. "
    // },
    // {
    //   "code": "14",
    //   "descr": "The date of birth follows the date of service. "
    // },
    // {
    //   "code": "15",
    //   "descr": "The authorization number is missing, invalid, or does not apply to the billed services or provider. "
    // },
    // {
    //   "code": "16",
    //   "descr": "Claim/service lacks information or has submission/billing error(s) which is needed for adjudication. Do not use this code for claims attachment(s)/other documentation. At least one Remark Code must be provided (may be comprised of either the NCPDP Reject Reason Code, or Remittance Advice Remark Code that is not an ALERT.) Usage: Refer to the 835 Healthcare Policy Identification Segment (loop 2110 Service Payment Information REF), if present. "
    // },
    // {
    //   "code": "17",
    //   "descr": "Requested information was not provided or was insufficient/incomplete. At least one Remark Code must be provided (may be comprised of either the Remittance Advice Remark Code or NCPDP Reject Reason Code.) "
    // },
    // {
    //   "code": "18",
    //   "descr": "Exact duplicate claim/service (Use only with Group Code OA except where state workers' compensation regulations requires CO) "
    // },
    // {
    //   "code": "19",
    //   "descr": "This is a work-related injury/illness and thus the liability of the Worker's Compensation Carrier. "
    // },
    // {
    //   "code": "20",
    //   "descr": "This injury/illness is covered by the liability carrier. "
    // },
    // {
    //   "code": "21",
    //   "descr": "This injury/illness is the liability of the no-fault carrier. "
    // },
    // {
    //   "code": "22",
    //   "descr": "This care may be covered by another payer per coordination of benefits. "
    // },
    // {
    //   "code": "23",
    //   "descr": "The impact of prior payer(s) adjudication including payments and/or adjustments. (Use only with Group Code OA) "
    // },
    // {
    //   "code": "24",
    //   "descr": "Charges are covered under a capitation agreement/managed care plan. "
    // },
    // {
    //   "code": "25",
    //   "descr": "Payment denied. Your Stop loss deductible has not been met. "
    // },
    // {
    //   "code": "26",
    //   "descr": "Expenses incurred prior to coverage. "
    // },
    // {
    //   "code": "27",
    //   "descr": "Expenses incurred after coverage terminated. "
    // },
    // {
    //   "code": "28",
    //   "descr": "Coverage not in effect at the time the service was provided. "
    // },
    // {
    //   "code": "29",
    //   "descr": "The time limit for filing has expired. "
    // },
    // {
    //   "code": "30",
    //   "descr": "Payment adjusted because the patient has not met the required eligibility, spend down, waiting, or residency requirements. "
    // },
    // {
    //   "code": "31",
    //   "descr": "Patient cannot be identified as our insured. "
    // },
    // {
    //   "code": "32",
    //   "descr": "Our records indicate that this dependent is not an eligible dependent as defined. "
    // },
    // {
    //   "code": "33",
    //   "descr": "Insured has no dependent coverage. "
    // },
    // {
    //   "code": "34",
    //   "descr": "Insured has no coverage for newborns. "
    // },
    // {
    //   "code": "35",
    //   "descr": "Lifetime benefit maximum has been reached. "
    // },
    // {
    //   "code": "36",
    //   "descr": "Balance does not exceed co-payment amount. "
    // },
    // {
    //   "code": "37",
    //   "descr": "Balance does not exceed deductible. "
    // },
    // {
    //   "code": "38",
    //   "descr": "Services not provided or authorized by designated (network/primary care) providers. "
    // },
    // {
    //   "code": "39",
    //   "descr": "Services denied at the time authorization/pre-certification was requested. "
    // },
    // {
    //   "code": "40",
    //   "descr": "Charges do not meet qualifications for emergent/urgent care. Usage: Refer to the 835 Healthcare Policy Identification Segment (loop 2110 Service Payment Information REF), if present. "
    // },
    // {
    //   "code": "41",
    //   "descr": "Discount agreed to in Preferred Provider contract. "
    // },
    // {
    //   "code": "42",
    //   "descr": "Charges exceed our fee schedule or maximum allowable amount. (Use CARC 45) "
    // },
    // {
    //   "code": "43",
    //   "descr": "Gramm-Rudman reduction. "
    // },
    // {
    //   "code": "44",
    //   "descr": "Prompt-pay discount. "
    // },
    // {
    //   "code": "45",
    //   "descr": "Charge exceeds fee schedule/maximum allowable or contracted/legislated fee arrangement. Usage: This adjustment amount cannot equal the total service or claim charge amount; and must not duplicate provider adjustment amounts (payments and contractual reductions) that have resulted from prior payer(s) adjudication. (Use only with Group Codes PR or CO depending upon liability) "
    // },
    // {
    //   "code": "46",
    //   "descr": "This (these) service(s) is (are) not covered. "
    // },
    // {
    //   "code": "47",
    //   "descr": "This (these) diagnosis(es) is (are) not covered, missing, or are invalid. "
    // },
    // {
    //   "code": "48",
    //   "descr": "This (these) procedure(s) is (are) not covered. "
    // },
    // {
    //   "code": "49",
    //   "descr": "This is a non-covered service because it is a routine/preventive exam or a diagnostic/screening procedure done in conjunction with a routine/preventive exam. Usage: Refer to the 835 Healthcare Policy Identification Segment (loop 2110 Service Payment Information REF), if present. "
    // },
    // {
    //   "code": "50",
    //   "descr": "These are non-covered services because this is not deemed a 'medical necessity' by the payer. Usage: Refer to the 835 Healthcare Policy Identification Segment (loop 2110 Service Payment Information REF), if present. "
    // },
    // {
    //   "code": "51",
    //   "descr": "These are non-covered services because this is a pre-existing condition. Usage: Refer to the 835 Healthcare Policy Identification Segment (loop 2110 Service Payment Information REF), if present. "
    // },
    // {
    //   "code": "52",
    //   "descr": "The referring/prescribing/rendering provider is not eligible to refer/prescribe/order/perform the service billed. "
    // },
    // {
    //   "code": "53",
    //   "descr": "Services by an immediate relative or a member of the same household are not covered. "
    // },
    // {
    //   "code": "54",
    //   "descr": "Multiple physicians/assistants are not covered in this case. Usage: Refer to the 835 Healthcare Policy Identification Segment (loop 2110 Service Payment Information REF), if present. "
    // },
    // {
    //   "code": "55",
    //   "descr": "Procedure/treatment/drug is deemed experimental/investigational by the payer. Usage: Refer to the 835 Healthcare Policy Identification Segment (loop 2110 Service Payment Information REF), if present. "
    // },
    // {
    //   "code": "56",
    //   "descr": "Procedure/treatment has not been deemed 'proven to be effective' by the payer. Usage: Refer to the 835 Healthcare Policy Identification Segment (loop 2110 Service Payment Information REF), if present. "
    // },
    // {
    //   "code": "57",
    //   "descr": "Payment denied/reduced because the payer deems the information submitted does not support this level of service, this many services, this length of service, this dosage, or this day's supply. "
    // },
    // {
    //   "code": "58",
    //   "descr": "Treatment was deemed by the payer to have been rendered in an inappropriate or invalid place of service. Usage: Refer to the 835 Healthcare Policy Identification Segment (loop 2110 Service Payment Information REF), if present. "
    // },
    // {
    //   "code": "59",
    //   "descr": "Processed based on multiple or concurrent procedure rules. (For example multiple surgery or diagnostic imaging, concurrent anesthesia.) Usage: Refer to the 835 Healthcare Policy Identification Segment (loop 2110 Service Payment Information REF), if present. "
    // },
    // {
    //   "code": "60",
    //   "descr": "Charges for outpatient services are not covered when performed within a period of time prior to or after inpatient services. "
    // },
    // {
    //   "code": "61",
    //   "descr": "Adjusted for failure to obtain second surgical opinion "
    // },
    // {
    //   "code": "62",
    //   "descr": "Payment denied/reduced for absence of, or exceeded, pre-certification/authorization. "
    // },
    // {
    //   "code": "63",
    //   "descr": "Correction to a prior claim. "
    // },
    // {
    //   "code": "64",
    //   "descr": "Denial reversed per Medical Review. "
    // },
    // {
    //   "code": "65",
    //   "descr": "Procedure code was incorrect. This payment reflects the correct code. "
    // },
    // {
    //   "code": "66",
    //   "descr": "Blood Deductible. "
    // },
    // {
    //   "code": "67",
    //   "descr": "Lifetime reserve days. (Handled in QTY, QTY01=LA)"
    // },
    // {
    //   "code": "68",
    //   "descr": "DRG weight. (Handled in CLP12) "
    // },
    // {
    //   "code": "69",
    //   "descr": "Day outlier amount. "
    // },
    // {
    //   "code": "70",
    //   "descr": "Cost outlier - Adjustment to compensate for additional costs. "
    // },
    // {
    //   "code": "71",
    //   "descr": "Primary Payer amount. "
    // },
    // {
    //   "code": "72",
    //   "descr": "Coinsurance day. (Handled in QTY, QTY01=CD)"
    // },
    // {
    //   "code": "73",
    //   "descr": "Administrative days. "
    // },
    // {
    //   "code": "74",
    //   "descr": "Indirect Medical Education Adjustment. "
    // },
    // {
    //   "code": "75",
    //   "descr": "Direct Medical Education Adjustment. "
    // },
    // {
    //   "code": "76",
    //   "descr": "Disproportionate Share Adjustment. "
    // },
    // {
    //   "code": "77",
    //   "descr": "Covered days. (Handled in QTY, QTY01=CA)"
    // },
    // {
    //   "code": "78",
    //   "descr": "Non-Covered days/Room charge adjustment. "
    // },
    // {
    //   "code": "79",
    //   "descr": "Cost Report days. (Handled in MIA15) "
    // },
    // {
    //   "code": "80",
    //   "descr": "Outlier days. (Handled in QTY, QTY01=OU)"
    // },
    // {
    //   "code": "81",
    //   "descr": "Discharges. "
    // },
    // {
    //   "code": "82",
    //   "descr": "PIP days. "
    // },
    // {
    //   "code": "83",
    //   "descr": "Total visits. "
    // },
    // {
    //   "code": "84",
    //   "descr": "Capital Adjustment. (Handled in MIA) "
    // },
    // {
    //   "code": "85",
    //   "descr": "Patient Interest Adjustment (Use Only Group code PR) "
    // },
    // {
    //   "code": "86",
    //   "descr": "Statutory Adjustment. "
    // },
    // {
    //   "code": "87",
    //   "descr": "Transfer amount. "
    // },
    // {
    //   "code": "88",
    //   "descr": "Adjustment amount represents collection against receivable created in prior overpayment. "
    // },
    // {
    //   "code": "89",
    //   "descr": "Professional fees removed from charges. "
    // },
    // {
    //   "code": "90",
    //   "descr": "Ingredient cost adjustment. Usage: To be used for pharmaceuticals only. "
    // },
    // {
    //   "code": "91",
    //   "descr": "Dispensing fee adjustment. "
    // },
    // {
    //   "code": "92",
    //   "descr": "Claim Paid in full. "
    // },
    // {
    //   "code": "93",
    //   "descr": "No Claim level Adjustments. "
    // },
    // {
    //   "code": "94",
    //   "descr": "Processed in Excess of charges. "
    // },
    // {
    //   "code": "95",
    //   "descr": "Plan procedures not followed. "
    // },
    // {
    //   "code": "96",
    //   "descr": "Non-covered charge(s). At least one Remark Code must be provided (may be comprised of either the NCPDP Reject Reason Code, or Remittance Advice Remark Code that is not an ALERT.) Usage: Refer to the 835 Healthcare Policy Identification Segment (loop 2110 Service Payment Information REF), if present. "
    // },
    // {
    //   "code": "97",
    //   "descr": "The benefit for this service is included in the payment/allowance for another service/procedure that has already been adjudicated. Usage: Refer to the 835 Healthcare Policy Identification Segment (loop 2110 Service Payment Information REF), if present. "
    // },
    // {
    //   "code": "98",
    //   "descr": "The hospital must file the Medicare claim for this inpatient non-physician service. "
    // },
    // {
    //   "code": "99",
    //   "descr": "Medicare Secondary Payer Adjustment Amount. "
    // },
    // {
    //   "code": "100",
    //   "descr": "Payment made to patient/insured/responsible party/employer. "
    // },
    // {
    //   "code": "101",
    //   "descr": "Predetermination: anticipated payment upon completion of services or claim adjudication. "
    // },
    // {
    //   "code": "102",
    //   "descr": "Major Medical Adjustment. "
    // },
    // {
    //   "code": "103",
    //   "descr": "Provider promotional discount (e.g., Senior citizen discount). "
    // },
    // {
    //   "code": "104",
    //   "descr": "Managed care withholding. "
    // },
    // {
    //   "code": "105",
    //   "descr": "Tax withholding. "
    // },
    // {
    //   "code": "106",
    //   "descr": "Patient payment option/election not in effect. "
    // },
    // {
    //   "code": "107",
    //   "descr": "The related or qualifying claim/service was not identified on this claim. Usage: Refer to the 835 Healthcare Policy Identification Segment (loop 2110 Service Payment Information REF), if present. "
    // },
    // {
    //   "code": "108",
    //   "descr": "Rent/purchase guidelines were not met. Usage: Refer to the 835 Healthcare Policy Identification Segment (loop 2110 Service Payment Information REF), if present. "
    // },
    // {
    //   "code": "109",
    //   "descr": "Claim/service not covered by this payer/contractor. You must send the claim/service to the correct payer/contractor. "
    // },
    // {
    //   "code": "110",
    //   "descr": "Billing date predates service date. "
    // },
    // {
    //   "code": "111",
    //   "descr": "Not covered unless the provider accepts assignment. "
    // },
    // {
    //   "code": "112",
    //   "descr": "Service not furnished directly to the patient and/or not documented. "
    // },
    // {
    //   "code": "113",
    //   "descr": "Payment denied because service/procedure was provided outside the United States or as a result of war. "
    // },
    // {
    //   "code": "114",
    //   "descr": "Procedure/product not approved by the Food and Drug Administration. "
    // },
    // {
    //   "code": "115",
    //   "descr": "Procedure postponed, canceled, or delayed. "
    // },
    // {
    //   "code": "116",
    //   "descr": "The advance indemnification notice signed by the patient did not comply with requirements. "
    // },
    // {
    //   "code": "117",
    //   "descr": "Transportation is only covered to the closest facility that can provide the necessary care. "
    // },
    // {
    //   "code": "118",
    //   "descr": "ESRD network support adjustment. "
    // },
    // {
    //   "code": "119",
    //   "descr": "Benefit maximum for this time period or occurrence has been reached. "
    // },
    // {
    //   "code": "120",
    //   "descr": "Patient is covered by a managed care plan. "
    // },
    // {
    //   "code": "121",
    //   "descr": "Indemnification adjustment - compensation for outstanding member responsibility. "
    // },
    // {
    //   "code": "122",
    //   "descr": "Psychiatric reduction. "
    // },
    // {
    //   "code": "123",
    //   "descr": "Payer refund due to overpayment. "
    // },
    // {
    //   "code": "124",
    //   "descr": "Payer refund amount - not our patient. "
    // },
    // {
    //   "code": "125",
    //   "descr": "Submission/billing error(s). At least one Remark Code must be provided (may be comprised of either the NCPDP Reject Reason Code, or Remittance Advice Remark Code that is not an ALERT.) "
    // },
    // {
    //   "code": "126",
    //   "descr": "Deductible -- Major Medical "
    // },
    // {
    //   "code": "127",
    //   "descr": "Coinsurance -- Major Medical "
    // },
    // {
    //   "code": "128",
    //   "descr": "Newborn's services are covered in the mother's Allowance. "
    // },
    // {
    //   "code": "129",
    //   "descr": "Prior processing information appears incorrect. At least one Remark Code must be provided (may be comprised of either the NCPDP Reject Reason Code, or Remittance Advice Remark Code that is not an ALERT.) "
    // },
    // {
    //   "code": "130",
    //   "descr": "Claim submission fee. "
    // },
    // {
    //   "code": "131",
    //   "descr": "Claim specific negotiated discount. "
    // },
    // {
    //   "code": "132",
    //   "descr": "Prearranged demonstration project adjustment. "
    // },
    // {
    //   "code": "133",
    //   "descr": "The disposition of this service line is pending further review. (Use only with Group Code OA). Usage: Use of this code requires a reversal and correction when the service line is finalized (use only in Loop 2110 CAS segment of the 835 or Loop 2430 of the 837). "
    // },
    // {
    //   "code": "134",
    //   "descr": "Technical fees removed from charges. "
    // },
    // {
    //   "code": "135",
    //   "descr": "Interim bills cannot be processed. "
    // },
    // {
    //   "code": "136",
    //   "descr": "Failure to follow prior payer's coverage rules. (Use only with Group Code OA) "
    // },
    // {
    //   "code": "137",
    //   "descr": "Regulatory Surcharges, Assessments, Allowances or Health Related Taxes. "
    // },
    // {
    //   "code": "138",
    //   "descr": "Appeal procedures not followed or time limits not met. "
    // },
    // {
    //   "code": "139",
    //   "descr": "Contracted funding agreement - Subscriber is employed by the provider of services. "
    // },
    // {
    //   "code": "140",
    //   "descr": "Patient/Insured health identification number and name do not match. "
    // },
    // {
    //   "code": "141",
    //   "descr": "Claim spans eligible and ineligible periods of coverage. "
    // },
    // {
    //   "code": "142",
    //   "descr": "Monthly Medicaid patient liability amount. "
    // },
    // {
    //   "code": "143",
    //   "descr": "Portion of payment deferred. "
    // },
    // {
    //   "code": "144",
    //   "descr": "Incentive adjustment, e.g. preferred product/service. "
    // },
    // {
    //   "code": "145",
    //   "descr": "Premium payment withholding "
    // },
    // {
    //   "code": "146",
    //   "descr": "Diagnosis was invalid for the date(s) of service reported. "
    // },
    // {
    //   "code": "147",
    //   "descr": "Provider contracted/negotiated rate expired or not on file. "
    // },
    // {
    //   "code": "148",
    //   "descr": "Information from another provider was not provided or was insufficient/incomplete. At least one Remark Code must be provided (may be comprised of either the NCPDP Reject Reason Code, or Remittance Advice Remark Code that is not an ALERT.) "
    // },
    // {
    //   "code": "149",
    //   "descr": "Lifetime benefit maximum has been reached for this service/benefit category. "
    // },
    // {
    //   "code": "150",
    //   "descr": "Payer deems the information submitted does not support this level of service. "
    // },
    // {
    //   "code": "151",
    //   "descr": "Payment adjusted because the payer deems the information submitted does not support this many/frequency of services. "
    // },
    // {
    //   "code": "152",
    //   "descr": "Payer deems the information submitted does not support this length of service. Usage: Refer to the 835 Healthcare Policy Identification Segment (loop 2110 Service Payment Information REF), if present. "
    // },
    // {
    //   "code": "153",
    //   "descr": "Payer deems the information submitted does not support this dosage. "
    // },
    // {
    //   "code": "154",
    //   "descr": "Payer deems the information submitted does not support this day's supply. "
    // },
    // {
    //   "code": "155",
    //   "descr": "Patient refused the service/procedure. "
    // },
    // {
    //   "code": "156",
    //   "descr": "Flexible spending account payments. Note: Use code 187. "
    // },
    // {
    //   "code": "157",
    //   "descr": "Service/procedure was provided as a result of an act of war. "
    // },
    // {
    //   "code": "158",
    //   "descr": "Service/procedure was provided outside of the United States. "
    // },
    // {
    //   "code": "159",
    //   "descr": "Service/procedure was provided as a result of terrorism. "
    // },
    // {
    //   "code": "160",
    //   "descr": "Injury/illness was the result of an activity that is a benefit exclusion. "
    // },
    // {
    //   "code": "161",
    //   "descr": "Provider performance bonus "
    // },
    // {
    //   "code": "162",
    //   "descr": "State-mandated Requirement for Property and Casualty, see Claim Payment Remarks Code for specific explanation. "
    // },
    // {
    //   "code": "163",
    //   "descr": "Attachment/other documentation referenced on the claim was not received. "
    // },
    // {
    //   "code": "164",
    //   "descr": "Attachment/other documentation referenced on the claim was not received in a timely fashion. "
    // },
    // {
    //   "code": "165",
    //   "descr": "Referral absent or exceeded. "
    // },
    // {
    //   "code": "166",
    //   "descr": "These services were submitted after this payers responsibility for processing claims under this plan ended. "
    // },
    // {
    //   "code": "167",
    //   "descr": "This (these) diagnosis(es) is (are) not covered. Usage: Refer to the 835 Healthcare Policy Identification Segment (loop 2110 Service Payment Information REF), if present. "
    // },
    // {
    //   "code": "168",
    //   "descr": "Service(s) have been considered under the patient's medical plan. Benefits are not available under this dental plan. "
    // },
    // {
    //   "code": "169",
    //   "descr": "Alternate benefit has been provided. "
    // },
    // {
    //   "code": "170",
    //   "descr": "Payment is denied when performed/billed by this type of provider. Usage: Refer to the 835 Healthcare Policy Identification Segment (loop 2110 Service Payment Information REF), if present. "
    // },
    // {
    //   "code": "171",
    //   "descr": "Payment is denied when performed/billed by this type of provider in this type of facility. Usage: Refer to the 835 Healthcare Policy Identification Segment (loop 2110 Service Payment Information REF), if present. "
    // },
    // {
    //   "code": "172",
    //   "descr": "Payment is adjusted when performed/billed by a provider of this specialty. Usage: Refer to the 835 Healthcare Policy Identification Segment (loop 2110 Service Payment Information REF), if present. "
    // },
    // {
    //   "code": "173",
    //   "descr": "Service/equipment was not prescribed by a physician. "
    // },
    // {
    //   "code": "174",
    //   "descr": "Service was not prescribed prior to delivery. "
    // },
    // {
    //   "code": "175",
    //   "descr": "Prescription is incomplete. "
    // },
    // {
    //   "code": "176",
    //   "descr": "Prescription is not current. "
    // },
    // {
    //   "code": "177",
    //   "descr": "Patient has not met the required eligibility requirements. "
    // },
    // {
    //   "code": "178",
    //   "descr": "Patient has not met the required spend down requirements. "
    // },
    // {
    //   "code": "179",
    //   "descr": "Patient has not met the required waiting requirements. Usage: Refer to the 835 Healthcare Policy Identification Segment (loop 2110 Service Payment Information REF), if present. "
    // },
    // {
    //   "code": "180",
    //   "descr": "Patient has not met the required residency requirements. "
    // },
    // {
    //   "code": "181",
    //   "descr": "Procedure code was invalid on the date of service. "
    // },
    // {
    //   "code": "182",
    //   "descr": "Procedure modifier was invalid on the date of service. "
    // },
    // {
    //   "code": "183",
    //   "descr": "The referring provider is not eligible to refer the service billed. Usage: Refer to the 835 Healthcare Policy Identification Segment (loop 2110 Service Payment Information REF), if present. "
    // },
    // {
    //   "code": "184",
    //   "descr": "The prescribing/ordering provider is not eligible to prescribe/order the service billed. Usage: Refer to the 835 Healthcare Policy Identification Segment (loop 2110 Service Payment Information REF), if present. "
    // },
    // {
    //   "code": "185",
    //   "descr": "The rendering provider is not eligible to perform the service billed. Usage: Refer to the 835 Healthcare Policy Identification Segment (loop 2110 Service Payment Information REF), if present. "
    // },
    // {
    //   "code": "186",
    //   "descr": "Level of care change adjustment. "
    // },
    // {
    //   "code": "187",
    //   "descr": "Consumer Spending Account payments (includes but is not limited to Flexible Spending Account, Health Savings Account, Health Reimbursement Account, etc.) "
    // },
    // {
    //   "code": "188",
    //   "descr": "This product/procedure is only covered when used according to FDA recommendations. "
    // },
    // {
    //   "code": "189",
    //   "descr": "'Not otherwise classified' or 'unlisted' procedure code (CPT/HCPCS) was billed when there is a specific procedure code for this procedure/service "
    // },
    // {
    //   "code": "190",
    //   "descr": "Payment is included in the allowance for a Skilled Nursing Facility (SNF) qualified stay. "
    // },
    // {
    //   "code": "191",
    //   "descr": "Not a work related injury/illness and thus not the liability of the workers' compensation carrier Note: If adjustment is at the Claim Level, the payer must send and the provider should refer to the 835 Insurance Policy Number Segment (Loop 2100 Other Claim Related Information REF qualifier 'IG') for the jurisdictional regulation. If adjustment is at the Line Level, the payer must send and the provider should refer to the 835 Healthcare Policy Identification Segment (loop 2110 Service Payment information REF) "
    // },
    // {
    //   "code": "192",
    //   "descr": "Non standard adjustment code from paper remittance. Usage: This code is to be used by providers/payers providing Coordination of Benefits information to another payer in the 837 transaction only. This code is only used when the non-standard code cannot be reasonably mapped to an existing Claims Adjustment Reason Code, specifically Deductible, Coinsurance and Co-payment. "
    // },
    // {
    //   "code": "193",
    //   "descr": "Original payment decision is being maintained. Upon review, it was determined that this claim was processed properly. "
    // },
    // {
    //   "code": "194",
    //   "descr": "Anesthesia performed by the operating physician, the assistant surgeon or the attending physician. "
    // },
    // {
    //   "code": "195",
    //   "descr": "Refund issued to an erroneous priority payer for this claim/service. "
    // },
    // {
    //   "code": "196",
    //   "descr": "Claim/service denied based on prior payer's coverage determination. "
    // },
    // {
    //   "code": "197",
    //   "descr": "Precertification/authorization/notification absent. "
    // },
    // {
    //   "code": "198",
    //   "descr": "Precertification/authorization exceeded. "
    // },
    // {
    //   "code": "199",
    //   "descr": "Revenue code and Procedure code do not match. "
    // },
    // {
    //   "code": "200",
    //   "descr": "Expenses incurred during lapse in coverage "
    // },
    // {
    //   "code": "201",
    //   "descr": "Patient is responsible for amount of this claim/service through 'set aside arrangement' or other agreement. (Use only with Group Code PR)  At least one Remark Code must be provided (may be comprised of either the NCPDP Reject Reason Code, or Remittance Advice Remark Code that is not an ALERT.) "
    // },
    // {
    //   "code": "202",
    //   "descr": "Non-covered personal comfort or convenience services. "
    // },
    // {
    //   "code": "203",
    //   "descr": "Discontinued or reduced service. "
    // },
    // {
    //   "code": "204",
    //   "descr": "This service/equipment/drug is not covered under the patient's current benefit plan "
    // },
    // {
    //   "code": "205",
    //   "descr": "Pharmacy discount card processing fee "
    // },
    // {
    //   "code": "206",
    //   "descr": "National Provider Identifier - missing. "
    // },
    // {
    //   "code": "207",
    //   "descr": "National Provider identifier - Invalid format "
    // },
    // {
    //   "code": "208",
    //   "descr": "National Provider Identifier - Not matched. "
    // },
    // {
    //   "code": "209",
    //   "descr": "Per regulatory or other agreement. The provider cannot collect this amount from the patient. However, this amount may be billed to subsequent payer. Refund to patient if collected. (Use only with Group code OA) "
    // },
    // {
    //   "code": "210",
    //   "descr": "Payment adjusted because pre-certification/authorization not received in a timely fashion "
    // },
    // {
    //   "code": "211",
    //   "descr": "National Drug Codes (NDC) not eligible for rebate, are not covered. "
    // },
    // {
    //   "code": "212",
    //   "descr": "Administrative surcharges are not covered "
    // },
    // {
    //   "code": "213",
    //   "descr": "Non-compliance with the physician self referral prohibition legislation or payer policy. "
    // },
    // {
    //   "code": "214",
    //   "descr": "Workers' Compensation claim adjudicated as non-compensable. This Payer not liable for claim or service/treatment. Note: If adjustment is at the Claim Level, the payer must send and the provider should refer to the 835 Insurance Policy Number Segment (Loop 2100 Other Claim Related Information REF qualifier 'IG') for the jurisdictional regulation. If adjustment is at the Line Level, the payer must send and the provider should refer to the 835 Healthcare Policy Identification Segment (loop 2110 Service Payment information REF). To be used for Workers' Compensation only "
    // },
    // {
    //   "code": "215",
    //   "descr": "Based on subrogation of a third party settlement "
    // },
    // {
    //   "code": "216",
    //   "descr": "Based on the findings of a review organization "
    // },
    // {
    //   "code": "217",
    //   "descr": "Based on payer reasonable and customary fees. No maximum allowable defined by legislated fee arrangement. (Note: To be used for Property and Casualty only) "
    // },
    // {
    //   "code": "218",
    //   "descr": "Based on entitlement to benefits. Note: If adjustment is at the Claim Level, the payer must send and the provider should refer to the 835 Insurance Policy Number Segment (Loop 2100 Other Claim Related Information REF qualifier 'IG') for the jurisdictional regulation. If adjustment is at the Line Level, the payer must send and the provider should refer to the 835 Healthcare Policy Identification Segment (loop 2110 Service Payment information REF). To be used for Workers' Compensation only "
    // },
    // {
    //   "code": "219",
    //   "descr": "Based on extent of injury. Usage: If adjustment is at the Claim Level, the payer must send and the provider should refer to the 835 Insurance Policy Number Segment (Loop 2100 Other Claim Related Information REF qualifier 'IG') for the jurisdictional regulation. If adjustment is at the Line Level, the payer must send and the provider should refer to the 835 Healthcare Policy Identification Segment (loop 2110 Service Payment information REF). "
    // },
    // {
    //   "code": "220",
    //   "descr": "The applicable fee schedule/fee database does not contain the billed code. Please resubmit a bill with the appropriate fee schedule/fee database code(s) that best describe the service(s) provided and supporting documentation if required. (Note: To be used for Property and Casualty only) "
    // },
    // {
    //   "code": "221",
    //   "descr": "Claim is under investigation. Note: If adjustment is at the Claim Level, the payer must send and the provider should refer to the 835 Insurance Policy Number Segment (Loop 2100 Other Claim Related Information REF qualifier 'IG') for the jurisdictional regulation. If adjustment is at the Line Level, the payer must send and the provider should refer to the 835 Healthcare Policy Identification Segment (loop 2110 Service Payment information REF). (Note: To be used by Property & Casualty only)"
    // },
    // {
    //   "code": "222",
    //   "descr": "Exceeds the contracted maximum number of hours/days/units by this provider for this period. This is not patient specific. Usage: Refer to the 835 Healthcare Policy Identification Segment (loop 2110 Service Payment Information REF), if present. "
    // },
    // {
    //   "code": "223",
    //   "descr": "Adjustment code for mandated federal, state or local law/regulation that is not already covered by another code and is mandated before a new code can be created. "
    // },
    // {
    //   "code": "224",
    //   "descr": "Patient identification compromised by identity theft. Identity verification required for processing this and future claims. "
    // },
    // {
    //   "code": "225",
    //   "descr": "Penalty or Interest Payment by Payer (Only used for plan to plan encounter reporting within the 837) "
    // },
    // {
    //   "code": "226",
    //   "descr": "Information requested from the Billing/Rendering Provider was not provided or not provided timely or was insufficient/incomplete. At least one Remark Code must be provided (may be comprised of either the NCPDP Reject Reason Code, or Remittance Advice Remark Code that is not an ALERT.) "
    // },
    // {
    //   "code": "227",
    //   "descr": "Information requested from the patient/insured/responsible party was not provided or was insufficient/incomplete. At least one Remark Code must be provided (may be comprised of either the NCPDP Reject Reason Code, or Remittance Advice Remark Code that is not an ALERT.) "
    // },
    // {
    //   "code": "228",
    //   "descr": "Denied for failure of this provider, another provider or the subscriber to supply requested information to a previous payer for their adjudication "
    // },
    // {
    //   "code": "229",
    //   "descr": "Partial charge amount not considered by Medicare due to the initial claim Type of Bill being 12X. Usage: This code can only be used in the 837 transaction to convey Coordination of Benefits information when the secondary payer's cost avoidance policy allows providers to bypass claim submission to a prior payer. (Use only with Group Code PR) "
    // },
    // {
    //   "code": "230",
    //   "descr": "No available or correlating CPT/HCPCS code to describe this service. Note: Used only by Property and Casualty. "
    // },
    // {
    //   "code": "231",
    //   "descr": "Mutually exclusive procedures cannot be done in the same day/setting. Usage: Refer to the 835 Healthcare Policy Identification Segment (loop 2110 Service Payment Information REF), if present. "
    // },
    // {
    //   "code": "232",
    //   "descr": "Institutional Transfer Amount. Usage: Applies to institutional claims only and explains the DRG amount difference when the patient care crosses multiple institutions. "
    // },
    // {
    //   "code": "233",
    //   "descr": "Services/charges related to the treatment of a hospital-acquired condition or preventable medical error. "
    // },
    // {
    //   "code": "234",
    //   "descr": "This procedure is not paid separately. At least one Remark Code must be provided (may be comprised of either the NCPDP Reject Reason Code, or Remittance Advice Remark Code that is not an ALERT.) "
    // },
    // {
    //   "code": "235",
    //   "descr": "Sales Tax "
    // },
    // {
    //   "code": "236",
    //   "descr": "This procedure or procedure/modifier combination is not compatible with another procedure or procedure/modifier combination provided on the same day according to the National Correct Coding Initiative or workers compensation state regulations/ fee schedule requirements. "
    // },
    // {
    //   "code": "237",
    //   "descr": "Legislated/Regulatory Penalty. At least one Remark Code must be provided (may be comprised of either the NCPDP Reject Reason Code, or Remittance Advice Remark Code that is not an ALERT.) "
    // },
    // {
    //   "code": "238",
    //   "descr": "Claim spans eligible and ineligible periods of coverage, this is the reduction for the ineligible period. (Use only with Group Code PR) "
    // },
    // {
    //   "code": "239",
    //   "descr": "Claim spans eligible and ineligible periods of coverage. Rebill separate claims. "
    // },
    // {
    //   "code": "240",
    //   "descr": "The diagnosis is inconsistent with the patient's birth weight. Usage: Refer to the 835 Healthcare Policy Identification Segment (loop 2110 Service Payment Information REF), if present. "
    // },
    // {
    //   "code": "241",
    //   "descr": "Low Income Subsidy (LIS) Co-payment Amount "
    // },
    // {
    //   "code": "242",
    //   "descr": "Services not provided by network/primary care providers. "
    // },
    // {
    //   "code": "243",
    //   "descr": "Services not authorized by network/primary care providers. "
    // },
    // {
    //   "code": "244",
    //   "descr": "Payment reduced to zero due to litigation. Additional information will be sent following the conclusion of litigation. To be used for Property & Casualty only."
    // },
    // {
    //   "code": "245",
    //   "descr": "Provider performance program withhold. "
    // },
    // {
    //   "code": "246",
    //   "descr": "This non-payable code is for required reporting only. "
    // },
    // {
    //   "code": "247",
    //   "descr": "Deductible for Professional service rendered in an Institutional setting and billed on an Institutional claim. "
    // },
    // {
    //   "code": "248",
    //   "descr": "Coinsurance for Professional service rendered in an Institutional setting and billed on an Institutional claim. "
    // },
    // {
    //   "code": "249",
    //   "descr": "This claim has been identified as a readmission. (Use only with Group Code CO) "
    // },
    // {
    //   "code": "250",
    //   "descr": "The attachment/other documentation that was received was the incorrect attachment/document. The expected attachment/document is still missing. At least one Remark Code must be provided (may be comprised of either the NCPDP Reject Reason Code, or Remittance Advice Remark Code that is not an ALERT). "
    // },
    // {
    //   "code": "251",
    //   "descr": "The attachment/other documentation that was received was incomplete or deficient. The necessary information is still needed to process the claim. At least one Remark Code must be provided (may be comprised of either the NCPDP Reject Reason Code, or Remittance Advice Remark Code that is not an ALERT). "
    // },
    // {
    //   "code": "252",
    //   "descr": "An attachment/other documentation is required to adjudicate this claim/service. At least one Remark Code must be provided (may be comprised of either the NCPDP Reject Reason Code, or Remittance Advice Remark Code that is not an ALERT). "
    // },
    // {
    //   "code": "253",
    //   "descr": "Sequestration - reduction in federal payment "
    // },
    // {
    //   "code": "254",
    //   "descr": "Claim received by the dental plan, but benefits not available under this plan.  Submit these services to the patient's medical plan for further consideration. "
    // },
    // {
    //   "code": "255",
    //   "descr": "The disposition of the related Property & Casualty claim (injury or illness) is pending due to litigation. (Use only with Group Code OA)"
    // },
    // {
    //   "code": "256",
    //   "descr": "Service not payable per managed care contract. "
    // },
    // {
    //   "code": "257",
    //   "descr": "The disposition of the claim/service is undetermined during the premium payment grace period, per Health Insurance Exchange requirements. This claim/service will be reversed and corrected when the grace period ends (due to premium payment or lack of premium payment). (Use only with Group Code OA) "
    // },
    // {
    //   "code": "258",
    //   "descr": "Claim/service not covered when patient is in custody/incarcerated. Applicable federal, state or local authority may cover the claim/service. "
    // },
    // {
    //   "code": "259",
    //   "descr": "Additional payment for Dental/Vision service utilization. "
    // },
    // {
    //   "code": "260",
    //   "descr": "Processed under Medicaid ACA Enhanced Fee Schedule "
    // },
    // {
    //   "code": "261",
    //   "descr": "The procedure or service is inconsistent with the patient's history. "
    // },
    // {
    //   "code": "262",
    //   "descr": "Adjustment for delivery cost. Usage: To be used for pharmaceuticals only. "
    // },
    // {
    //   "code": "263",
    //   "descr": "Adjustment for shipping cost. Usage: To be used for pharmaceuticals only. "
    // },
    // {
    //   "code": "264",
    //   "descr": "Adjustment for postage cost. Usage: To be used for pharmaceuticals only. "
    // },
    // {
    //   "code": "265",
    //   "descr": "Adjustment for administrative cost. Usage: To be used for pharmaceuticals only. "
    // },
    // {
    //   "code": "266",
    //   "descr": "Adjustment for compound preparation cost. Usage: To be used for pharmaceuticals only. "
    // },
    // {
    //   "code": "267",
    //   "descr": "Claim/service spans multiple months. At least one Remark Code must be provided (may be comprised of either the NCPDP Reject Reason Code, or Remittance Advice Remark Code that is not an ALERT.) "
    // },
    // {
    //   "code": "268",
    //   "descr": "The Claim spans two calendar years. Please resubmit one claim per calendar year. "
    // },
    // {
    //   "code": "269",
    //   "descr": "Anesthesia not covered for this service/procedure. Usage: Refer to the 835 Healthcare Policy Identification Segment (loop 2110 Service Payment Information REF), if present. "
    // },
    // {
    //   "code": "270",
    //   "descr": "Claim received by the medical plan, but benefits not available under this plan. Submit these services to the patient's dental plan for further consideration. "
    // },
    // {
    //   "code": "271",
    //   "descr": "Prior contractual reductions related to a current periodic payment as part of a contractual payment schedule when deferred amounts have been previously reported. (Use only with group code OA) "
    // },
    // {
    //   "code": "272",
    //   "descr": "Coverage/program guidelines were not met. "
    // },
    // {
    //   "code": "273",
    //   "descr": "Coverage/program guidelines were exceeded. "
    // },
    // {
    //   "code": "274",
    //   "descr": "Fee/Service not payable per patient Care Coordination arrangement. "
    // },
    // {
    //   "code": "275",
    //   "descr": "Prior payer's (or payers') patient responsibility (deductible, coinsurance, co-payment) not covered. (Use only with Group Code PR) "
    // },
    // {
    //   "code": "276",
    //   "descr": "Services denied by the prior payer(s) are not covered by this payer. "
    // },
    // {
    //   "code": "277",
    //   "descr": "The disposition of the claim/service is undetermined during the premium payment grace period, per Health Insurance SHOP Exchange requirements. This claim/service will be reversed and corrected when the grace period ends (due to premium payment or lack of premium payment). (Use only with Group Code OA) "
    // },
    // {
    //   "code": "278",
    //   "descr": "Performance program proficiency requirements not met. (Use only with Group Codes CO or PI) Usage: Refer to the 835 Healthcare Policy Identification Segment (loop 2110 Service Payment Information REF), if present. "
    // },
    // {
    //   "code": "279",
    //   "descr": "Services not provided by Preferred network providers. Usage: Use this code when there are member network limitations. For example, using contracted providers not in the member's narrow network. "
    // },
    // {
    //   "code": "280",
    //   "descr": "Claim received by the medical plan, but benefits not available under this plan. Submit these services to the patient's Pharmacy plan for further consideration. "
    // },
    // {
    //   "code": "281",
    //   "descr": "Deductible waived per contractual agreement. Use only with Group Code CO. "
    // },
    // {
    //   "code": "282",
    //   "descr": "The procedure/revenue code is inconsistent with the type of bill. Usage: Refer to the 835 Healthcare Policy Identification Segment (loop 2110 Service Payment Information REF), if present. "
    // },
    // {
    //   "code": "A0",
    //   "descr": "Patient refund amount. "
    // },
    // {
    //   "code": "A1",
    //   "descr": "Claim/Service denied. At least one Remark Code must be provided (may be comprised of either the NCPDP Reject Reason Code, or Remittance Advice Remark Code that is not an ALERT.) "
    // },
    // {
    //   "code": "A2",
    //   "descr": "Contractual adjustment. "
    // },
    // {
    //   "code": "A3",
    //   "descr": "Medicare Secondary Payer liability met. "
    // },
    // {
    //   "code": "A4",
    //   "descr": "Medicare Claim PPS Capital Day Outlier Amount. "
    // },
    // {
    //   "code": "A5",
    //   "descr": "Medicare Claim PPS Capital Cost Outlier Amount. "
    // },
    // {
    //   "code": "A6",
    //   "descr": "Prior hospitalization or 30 day transfer requirement not met. "
    // },
    // {
    //   "code": "A7",
    //   "descr": "Presumptive Payment Adjustment "
    // },
    // {
    //   "code": "A8",
    //   "descr": "Ungroupable DRG. "
    // },
    // {
    //   "code": "B1",
    //   "descr": "Non-covered visits. "
    // },
    // {
    //   "code": "B2",
    //   "descr": "Covered visits. "
    // },
    // {
    //   "code": "B3",
    //   "descr": "Covered charges. "
    // },
    // {
    //   "code": "B4",
    //   "descr": "Late filing penalty. "
    // },
    // {
    //   "code": "B5",
    //   "descr": "Coverage/program guidelines were not met or were exceeded. "
    // },
    // {
    //   "code": "B6",
    //   "descr": "This payment is adjusted when performed/billed by this type of provider, by this type of provider in this type of facility, or by a provider of this specialty. "
    // },
    // {
    //   "code": "B7",
    //   "descr": "This provider was not certified/eligible to be paid for this procedure/service on this date of service. Usage: Refer to the 835 Healthcare Policy Identification Segment (loop 2110 Service Payment Information REF), if present. "
    // },
    // {
    //   "code": "B8",
    //   "descr": "Alternative services were available, and should have been utilized. Usage: Refer to the 835 Healthcare Policy Identification Segment (loop 2110 Service Payment Information REF), if present. "
    // },
    // {
    //   "code": "B9",
    //   "descr": "Patient is enrolled in a Hospice. "
    // },
    // {
    //   "code": "B10",
    //   "descr": "Allowed amount has been reduced because a component of the basic procedure/test was paid. The beneficiary is not liable for more than the charge limit for the basic procedure/test. "
    // },
    // {
    //   "code": "B11",
    //   "descr": "The claim/service has been transferred to the proper payer/processor for processing. Claim/service not covered by this payer/processor. "
    // },
    // {
    //   "code": "B12",
    //   "descr": "Services not documented in patients' medical records. "
    // },
    // {
    //   "code": "B13",
    //   "descr": "Previously paid. Payment for this claim/service may have been provided in a previous payment. "
    // },
    // {
    //   "code": "B14",
    //   "descr": "Only one visit or consultation per physician per day is covered. "
    // },
    // {
    //   "code": "B15",
    //   "descr": "This service/procedure requires that a qualifying service/procedure be received and covered. The qualifying other service/procedure has not been received/adjudicated. Usage: Refer to the 835 Healthcare Policy Identification Segment (loop 2110 Service Payment Information REF), if present. "
    // },
    // {
    //   "code": "B16",
    //   "descr": "'New Patient' qualifications were not met. "
    // },
    // {
    //   "code": "B17",
    //   "descr": "Payment adjusted because this service was not prescribed by a physician, not prescribed prior to delivery, the prescription is incomplete, or the prescription is not current. "
    // },
    // {
    //   "code": "B18",
    //   "descr": "This procedure code and modifier were invalid on the date of service. "
    // },
    // {
    //   "code": "B19",
    //   "descr": "Claim/service adjusted because of the finding of a Review Organization. "
    // },
    // {
    //   "code": "B20",
    //   "descr": "Procedure/service was partially or fully furnished by another provider. "
    // },
    // {
    //   "code": "B21",
    //   "descr": "The charges were reduced because the service/care was partially furnished by another physician. "
    // },
    // {
    //   "code": "B22",
    //   "descr": "This payment is adjusted based on the diagnosis. "
    // },
    // {
    //   "code": "B23",
    //   "descr": "Procedure billed is not authorized per your Clinical Laboratory Improvement Amendment (CLIA) proficiency test. "
    // },
    // {
    //   "code": "D1",
    //   "descr": "Claim/service denied. Level of subluxation is missing or inadequate. "
    // },
    // {
    //   "code": "D2",
    //   "descr": "Claim lacks the name, strength, or dosage of the drug furnished. "
    // },
    // {
    //   "code": "D3",
    //   "descr": "Claim/service denied because information to indicate if the patient owns the equipment that requires the part or supply was missing. "
    // },
    // {
    //   "code": "D4",
    //   "descr": "Claim/service does not indicate the period of time for which this will be needed. "
    // },
    // {
    //   "code": "D5",
    //   "descr": "Claim/service denied. Claim lacks individual lab codes included in the test. "
    // },
    // {
    //   "code": "D6",
    //   "descr": "Claim/service denied. Claim did not include patient's medical record for the service. "
    // },
    // {
    //   "code": "D7",
    //   "descr": "Claim/service denied. Claim lacks date of patient's most recent physician visit. "
    // },
    // {
    //   "code": "D8",
    //   "descr": "Claim/service denied. Claim lacks indicator that 'x-ray is available for review.' "
    // },
    // {
    //   "code": "D9",
    //   "descr": "Claim/service denied. Claim lacks invoice or statement certifying the actual cost of the lens, less discounts or the type of intraocular lens used. "
    // },
    // {
    //   "code": "D10",
    //   "descr": "Claim/service denied. Completed physician financial relationship form not on file. "
    // },
    // {
    //   "code": "D11",
    //   "descr": "Claim lacks completed pacemaker registration form. "
    // },
    // {
    //   "code": "D12",
    //   "descr": "Claim/service denied. Claim does not identify who performed the purchased diagnostic test or the amount you were charged for the test. "
    // },
    // {
    //   "code": "D13",
    //   "descr": "Claim/service denied. Performed by a facility/supplier in which the ordering/referring physician has a financial interest. "
    // },
    // {
    //   "code": "D14",
    //   "descr": "Claim lacks indication that plan of treatment is on file. "
    // },
    // {
    //   "code": "D15",
    //   "descr": "Claim lacks indication that service was supervised or evaluated by a physician. "
    // },
    // {
    //   "code": "D16",
    //   "descr": "Claim lacks prior payer payment information. "
    // },
    // {
    //   "code": "D17",
    //   "descr": "Claim/Service has invalid non-covered days. "
    // },
    // {
    //   "code": "D18",
    //   "descr": "Claim/Service has missing diagnosis information. "
    // },
    // {
    //   "code": "D19",
    //   "descr": "Claim/Service lacks Physician/Operative or other supporting documentation "
    // },
    // {
    //   "code": "D20",
    //   "descr": "Claim/Service missing service/product information. "
    // },
    // {
    //   "code": "D21",
    //   "descr": "This (these) diagnosis(es) is (are) missing or are invalid "
    // },
    // {
    //   "code": "D22",
    //   "descr": "Reimbursement was adjusted for the reasons to be provided in separate correspondence. (Note: To be used for Workers' Compensation only) - Temporary code to be added for timeframe only until 01/01/2009. Another code to be established and/or for 06/2008 meeting for a revised code to replace or strategy to use another existing code "
    // },
    // {
    //   "code": "D23",
    //   "descr": "This dual eligible patient is covered by Medicare Part D per Medicare Retro-Eligibility.  At least one Remark Code must be provided (may be comprised of either the NCPDP Reject Reason Code, or Remittance Advice Remark Code that is not an ALERT.) "
    // },
    // {
    //   "code": "P1",
    //   "descr": "State-mandated Requirement for Property and Casualty, see Claim Payment Remarks Code for specific explanation. To be used for Property and Casualty only. "
    // },
    // {
    //   "code": "P2",
    //   "descr": "Not a work related injury/illness and thus not the liability of the workers' compensation carrier Usage: If adjustment is at the Claim Level, the payer must send and the provider should refer to the 835 Insurance Policy Number Segment (Loop 2100 Other Claim Related Information REF qualifier 'IG') for the jurisdictional regulation. If adjustment is at the Line Level, the payer must send and the provider should refer to the 835 Healthcare Policy Identification Segment (loop 2110 Service Payment information REF). To be used for Workers' Compensation only. "
    // },
    // {
    //   "code": "P3",
    //   "descr": "Workers' Compensation case settled. Patient is responsible for amount of this claim/service through WC 'Medicare set aside arrangement' or other agreement. To be used for Workers' Compensation only. (Use only with Group Code PR) "
    // },
    // {
    //   "code": "P4",
    //   "descr": "Workers' Compensation claim adjudicated as non-compensable. This Payer not liable for claim or service/treatment. Usage: If adjustment is at the Claim Level, the payer must send and the provider should refer to the 835 Insurance Policy Number Segment (Loop 2100 Other Claim Related Information REF qualifier 'IG') for the jurisdictional regulation. If adjustment is at the Line Level, the payer must send and the provider should refer to the 835 Healthcare Policy Identification Segment (loop 2110 Service Payment information REF). To be used for Workers' Compensation only "
    // },
    // {
    //   "code": "P5",
    //   "descr": "Based on payer reasonable and customary fees. No maximum allowable defined by legislated fee arrangement. To be used for Property and Casualty only. "
    // },
    // {
    //   "code": "P6",
    //   "descr": "Based on entitlement to benefits. Usage: If adjustment is at the Claim Level, the payer must send and the provider should refer to the 835 Insurance Policy Number Segment (Loop 2100 Other Claim Related Information REF qualifier 'IG') for the jurisdictional regulation. If adjustment is at the Line Level, the payer must send and the provider should refer to the 835 Healthcare Policy Identification Segment (loop 2110 Service Payment information REF). To be used for Property and Casualty only. "
    // },
    // {
    //   "code": "P7",
    //   "descr": "The applicable fee schedule/fee database does not contain the billed code. Please resubmit a bill with the appropriate fee schedule/fee database code(s) that best describe the service(s) provided and supporting documentation if required. To be used for Property and Casualty only. "
    // },
    // {
    //   "code": "P8",
    //   "descr": "Claim is under investigation. Usage: If adjustment is at the Claim Level, the payer must send and the provider should refer to the 835 Insurance Policy Number Segment (Loop 2100 Other Claim Related Information REF qualifier 'IG') for the jurisdictional regulation. If adjustment is at the Line Level, the payer must send and the provider should refer to the 835 Healthcare Policy Identification Segment (loop 2110 Service Payment information REF). To be used for Property and Casualty only. "
    // },
    // {
    //   "code": "P9",
    //   "descr": "No available or correlating CPT/HCPCS code to describe this service. To be used for Property and Casualty only. "
    // },
    // {
    //   "code": "P10",
    //   "descr": "Payment reduced to zero due to litigation. Additional information will be sent following the conclusion of litigation. To be used for Property and Casualty only. "
    // },
    // {
    //   "code": "P11",
    //   "descr": "The disposition of the related Property & Casualty claim (injury or illness) is pending due to litigation. To be used for Property and Casualty only. (Use only with Group Code OA)"
    // },
    // {
    //   "code": "P12",
    //   "descr": "Workers' compensation jurisdictional fee schedule adjustment. Usage: If adjustment is at the Claim Level, the payer must send and the provider should refer to the 835 Class of Contract Code Identification Segment (Loop 2100 Other Claim Related Information REF). If adjustment is at the Line Level, the payer must send and the provider should refer to the 835 Healthcare Policy Identification Segment (loop 2110 Service Payment information REF) if the regulations apply. To be used for Workers' Compensation only. "
    // },
    // {
    //   "code": "P13",
    //   "descr": "Payment reduced or denied based on workers' compensation jurisdictional regulations or payment policies, use only if no other code is applicable. Usage: If adjustment is at the Claim Level, the payer must send and the provider should refer to the 835 Insurance Policy Number Segment (Loop 2100 Other Claim Related Information REF qualifier 'IG') if the jurisdictional regulation applies. If adjustment is at the Line Level, the payer must send and the provider should refer to the 835 Healthcare Policy Identification Segment (loop 2110 Service Payment information REF) if the regulations apply. To be used for Workers' Compensation only. "
    // },
    // {
    //   "code": "P14",
    //   "descr": "The Benefit for this Service is included in the payment/allowance for another service/procedure that has been performed on the same day. Usage: Refer to the 835 Healthcare Policy Identification Segment (loop 2110 Service Payment Information REF), if present. To be used for Property and Casualty only. "
    // },
    // {
    //   "code": "P15",
    //   "descr": "Workers' Compensation Medical Treatment Guideline Adjustment. To be used for Workers' Compensation only. "
    // },
    // {
    //   "code": "P16",
    //   "descr": "Medical provider not authorized/certified to provide treatment to injured workers in this jurisdiction. To be used for Workers' Compensation only. (Use with Group Code CO or OA) "
    // },
    // {
    //   "code": "P17",
    //   "descr": "Referral not authorized by attending physician per regulatory requirement. To be used for Property and Casualty only. "
    // },
    // {
    //   "code": "P18",
    //   "descr": "Procedure is not listed in the jurisdiction fee schedule.  An allowance has been made for a comparable service. To be used for Property and Casualty only. "
    // },
    // {
    //   "code": "P19",
    //   "descr": "Procedure has a relative value of zero in the jurisdiction fee schedule, therefore no payment is due. To be used for Property and Casualty only. "
    // },
    // {
    //   "code": "P20",
    //   "descr": "Service not paid under jurisdiction allowed outpatient facility fee schedule. To be used for Property and Casualty only. "
    // },
    // {
    //   "code": "P21",
    //   "descr": "Payment denied based on Medical Payments Coverage (MPC) or Personal Injury Protection (PIP) Benefits jurisdictional regulations or payment policies, use only if no other code is applicable. Usage: If adjustment is at the Claim Level, the payer must send and the provider should refer to the 835 Insurance Policy Number Segment (Loop 2100 Other Claim Related Information REF qualifier 'IG') if the jurisdictional regulation applies. If adjustment is at the Line Level, the payer must send and the provider should refer to the 835 Healthcare Policy Identification Segment (loop 2110 Service Payment information REF) if the regulations apply. To be used for Property and Casualty Auto only. "
    // },
    // {
    //   "code": "P22",
    //   "descr": "Payment adjusted based on Medical Payments Coverage (MPC) or Personal Injury Protection (PIP) Benefits jurisdictional regulations or payment policies, use only if no other code is applicable. Usage: If adjustment is at the Claim Level, the payer must send and the provider should refer to the 835 Insurance Policy Number Segment (Loop 2100 Other Claim Related Information REF qualifier 'IG') if the jurisdictional regulation applies. If adjustment is at the Line Level, the payer must send and the provider should refer to the 835 Healthcare Policy Identification Segment (loop 2110 Service Payment information REF) if the regulations apply. To be used for Property and Casualty Auto only. "
    // },
    // {
    //   "code": "P23",
    //   "descr": "Medical Payments Coverage (MPC) or Personal Injury Protection (PIP) Benefits jurisdictional fee schedule adjustment. Usage: If adjustment is at the Claim Level, the payer must send and the provider should refer to the 835 Class of Contract Code Identification Segment (Loop 2100 Other Claim Related Information REF). If adjustment is at the Line Level, the payer must send and the provider should refer to the 835 Healthcare Policy Identification Segment (loop 2110 Service Payment information REF) if the regulations apply. To be used for Property and Casualty Auto only. "
    // },
    // {
    //   "code": "W1",
    //   "descr": "Workers' compensation jurisdictional fee schedule adjustment.  Note: If adjustment is at the Claim Level, the payer must send and the provider should refer to the 835 Class of Contract Code Identification Segment (Loop 2100 Other Claim Related Information REF). If adjustment is at the Line Level, the payer must send and the provider should refer to the 835 Healthcare Policy Identification Segment (loop 2110 Service Payment information REF) if the regulations apply. "
    // },
    // {
    //   "code": "W2",
    //   "descr": "Payment reduced or denied based on workers' compensation jurisdictional regulations or payment policies, use only if no other code is applicable. Note: If adjustment is at the Claim Level, the payer must send and the provider should refer to the 835 Insurance Policy Number Segment (Loop 2100 Other Claim Related Information REF qualifier 'IG') if the jurisdictional regulation applies. If adjustment is at the Line Level, the payer must send and the provider should refer to the 835 Healthcare Policy Identification Segment (loop 2110 Service Payment information REF) if the regulations apply. To be used for Workers' Compensation only. "
    // },
    // {
    //   "code": "W3",
    //   "descr": "The Benefit for this Service is included in the payment/allowance for another service/procedure that has been performed on the same day. Note: Refer to the 835 Healthcare Policy Identification Segment (loop 2110 Service Payment Information REF), if present. For use by Property and Casualty only. "
    // },
    // {
    //   "code": "W4",
    //   "descr": "Workers' Compensation Medical Treatment Guideline Adjustment. "
    // },
    // {
    //   "code": "W5",
    //   "descr": "Medical provider not authorized/certified to provide treatment to injured workers in this jurisdiction. (Use with Group Code CO or OA) "
    // },
    // {
    //   "code": "W6",
    //   "descr": "Referral not authorized by attending physician per regulatory requirement. "
    // },
    // {
    //   "code": "W7",
    //   "descr": "Procedure is not listed in the jurisdiction fee schedule.  An allowance has been made for a comparable service. "
    // },
    // {
    //   "code": "W8",
    //   "descr": "Procedure has a relative value of zero in the jurisdiction fee schedule, therefore no payment is due. "
    // },
    // {
    //   "code": "W9",
    //   "descr": "Service not paid under jurisdiction allowed outpatient facility fee schedule. "
    // },
    // {
    //   "code": "Y1",
    //   "descr": "Payment denied based on Medical Payments Coverage (MPC) or Personal Injury Protection (PIP) Benefits jurisdictional regulations or payment policies, use only if no other code is applicable. Note: If adjustment is at the Claim Level, the payer must send and the provider should refer to the 835 Insurance Policy Number Segment (Loop 2100 Other Claim Related Information REF qualifier 'IG') if the jurisdictional regulation applies. If adjustment is at the Line Level, the payer must send and the provider should refer to the 835 Healthcare Policy Identification Segment (loop 2110 Service Payment information REF) if the regulations apply. To be used for Property and Casualty Auto only."
    // },
    // {
    //   "code": "Y2",
    //   "descr": "Payment adjusted based on Medical Payments Coverage (MPC) or Personal Injury Protection (PIP) Benefits jurisdictional regulations or payment policies, use only if no other code is applicable. Note: If adjustment is at the Claim Level, the payer must send and the provider should refer to the 835 Insurance Policy Number Segment (Loop 2100 Other Claim Related Information REF qualifier 'IG') if the jurisdictional regulation applies. If adjustment is at the Line Level, the payer must send and the provider should refer to the 835 Healthcare Policy Identification Segment (loop 2110 Service Payment information REF) if the regulations apply. To be used for Property and Casualty Auto only."
    // },
    // {
    //   "code": "Y3",
    //   "descr": "Medical Payments Coverage (MPC) or Personal Injury Protection (PIP) Benefits jurisdictional fee schedule adjustment. Note: If adjustment is at the Claim Level, the payer must send and the provider should refer to the 835 Class of Contract Code Identification Segment (Loop 2100 Other Claim Related Information REF). If adjustment is at the Line Level, the payer must send and the provider should refer to the 835 Healthcare Policy Identification Segment (loop 2110 Service Payment information REF) if the regulations apply. To be used for Property and Casualty Auto only."
    // },
    // {
    //   "code": "COc",
    //   "descr": "Contractural Obligations "
    // },
    // {
    //   "code": "CRc",
    //   "descr": "Correction and Reversals "
    // },
    // {
    //   "code": "OAc",
    //   "descr": "Other adjustments "
    // },
    // {
    //   "code": "PRc",
    //   "descr": "Patient Responsibility "
    // },
    // {
    //   "code": "50p",
    //   "descr": "Late Charge "
    // },
    // {
    //   "code": "51p",
    //   "descr": "Interest Penalty Charge "
    // },
    // {
    //   "code": "72p",
    //   "descr": "Authorized Return "
    // },
    // {
    //   "code": "90p",
    //   "descr": "Early Payment Allowance "
    // },
    // {
    //   "code": "AMp",
    //   "descr": "Applied to Borrower's Account "
    // },
    // {
    //   "code": "APp",
    //   "descr": "Acceleration of Benefits "
    // },
    // {
    //   "code": "B2p",
    //   "descr": "Rebate "
    // },
    // {
    //   "code": "B3p",
    //   "descr": "Recovery Allowance "
    // },
    // {
    //   "code": "BDp",
    //   "descr": "Bad Debt Adjustment "
    // },
    // {
    //   "code": "BNp",
    //   "descr": "Bonus "
    // },
    // {
    //   "code": "C5p",
    //   "descr": "Temporary Allowance "
    // },
    // {
    //   "code": "CRp",
    //   "descr": "Capitation Interest "
    // },
    // {
    //   "code": "CSp",
    //   "descr": "Adjustment "
    // },
    // {
    //   "code": "CTp",
    //   "descr": "Capitation Payment "
    // },
    // {
    //   "code": "CVp",
    //   "descr": "Capital Passthru "
    // },
    // {
    //   "code": "CWp",
    //   "descr": "Certified Registered Nurse Anesthetist Passthru "
    // },
    // {
    //   "code": "DMp",
    //   "descr": "Direct Medical Education Passthru "
    // },
    // {
    //   "code": "E3p",
    //   "descr": "Withholding "
    // },
    // {
    //   "code": "FBp",
    //   "descr": "Forwarding Balance "
    // },
    // {
    //   "code": "FCp",
    //   "descr": "Fund Allocation "
    // },
    // {
    //   "code": "GOp",
    //   "descr": "Graduate Medical Education Passthru "
    // },
    // {
    //   "code": "IPp",
    //   "descr": "Incentive Premium Payment "
    // },
    // {
    //   "code": "IRp",
    //   "descr": "Internal Revenue Service Withholding "
    // },
    // {
    //   "code": "ISp",
    //   "descr": "Interim Settlement "
    // },
    // {
    //   "code": "J1p",
    //   "descr": "Nonreimbursable "
    // },
    // {
    //   "code": "L3p",
    //   "descr": "Penalty "
    // },
    // {
    //   "code": "L6p",
    //   "descr": "Interest Owed "
    // },
    // {
    //   "code": "LEp",
    //   "descr": "Levy "
    // },
    // {
    //   "code": "LSp",
    //   "descr": "Lump Sum "
    // },
    // {
    //   "code": "OAp",
    //   "descr": "Organ Acquisition Passthru "
    // },
    // {
    //   "code": "OBp",
    //   "descr": "Offset for Affiliated Providers "
    // },
    // {
    //   "code": "PIp",
    //   "descr": "Periodic Interim Payment "
    // },
    // {
    //   "code": "PLp",
    //   "descr": "Payment Final "
    // },
    // {
    //   "code": "RAp",
    //   "descr": "Retro-activity Adjustment "
    // },
    // {
    //   "code": "REp",
    //   "descr": "Return on Equity "
    // },
    // {
    //   "code": "SLp",
    //   "descr": "Student Loan Repayment "
    // },
    // {
    //   "code": "TLp",
    //   "descr": "Third Party Liablility "
    // },
    // {
    //   "code": "WOp",
    //   "descr": "Overpayment Recovery "
    // },
    // {
    //   "code": "WUp",
    //   "descr": "Unspecified Recovery "
    // },
    // {
    //   "code": "ZZp",
    //   "descr": "Mutually Defined "
    // },
    // {
    //   "code": "1s",
    //   "descr": "Additional Information Required - Missing/Invalid/Incomplete Documentation "
    // },
    // {
    //   "code": "2s",
    //   "descr": "Additional Information Required - Missing/Invalid/Incomplete Data from Submitted Claim "
    // },
    // {
    //   "code": "3s",
    //   "descr": "Billed Service Not Covered by Health Plan "
    // },
    // {
    //   "code": "4s",
    //   "descr": "Benefit for Billed Service Not Separately Payable "
    // },
    // {
    //   "code": "M1",
    //   "descr": "X-ray not taken within the past 12 months or near enough to the start of treatment. "
    // },
    // {
    //   "code": "M2",
    //   "descr": "Not paid separately when the patient is an inpatient. "
    // },
    // {
    //   "code": "M3",
    //   "descr": "Equipment is the same or similar to equipment already being used. "
    // },
    // {
    //   "code": "M4",
    //   "descr": "Alert: This is the last monthly installment payment for this durable medical equipment. "
    // },
    // {
    //   "code": "M5",
    //   "descr": "Monthly rental payments can continue until the earlier of the 15th month from the first rental month, or the month when the equipment is no longer needed. "
    // },
    // {
    //   "code": "M6",
    //   "descr": "Alert: You must furnish and service this item for any period of medical need for the remainder of the reasonable useful lifetime of the equipment. "
    // },
    // {
    //   "code": "M7",
    //   "descr": "No rental payments after the item is purchased, returned or after the total of issued rental payments equals the purchase price. "
    // },
    // {
    //   "code": "M8",
    //   "descr": "We do not accept blood gas tests results when the test was conducted by a medical supplier or taken while the patient is on oxygen. "
    // },
    // {
    //   "code": "M9",
    //   "descr": "Alert: This is the tenth rental month. You must offer the patient the choice of changing the rental to a purchase agreement. "
    // },
    // {
    //   "code": "M10",
    //   "descr": "Equipment purchases are limited to the first or the tenth month of medical necessity. "
    // },
    // {
    //   "code": "M11",
    //   "descr": "DME, orthotics and prosthetics must be billed to the DME carrier who services the patient's zip code. "
    // },
    // {
    //   "code": "M12",
    //   "descr": "Diagnostic tests performed by a physician must indicate whether purchased services are included on the claim. "
    // },
    // {
    //   "code": "M13",
    //   "descr": "Only one initial visit is covered per specialty per medical group. "
    // },
    // {
    //   "code": "M14",
    //   "descr": "No separate payment for an injection administered during an office visit, and no payment for a full office visit if the patient only received an injection. "
    // },
    // {
    //   "code": "M15",
    //   "descr": "Separately billed services/tests have been bundled as they are considered components of the same procedure. Separate payment is not allowed. "
    // },
    // {
    //   "code": "M16",
    //   "descr": "Alert: Please see our web site, mailings, or bulletins for more details concerning this policy/procedure/decision. "
    // },
    // {
    //   "code": "M17",
    //   "descr": "Alert: Payment approved as you did not know, and could not reasonably have been expected to know, that this would not normally have been covered for this patient.  In the future, you will be liable for charges for the same service(s) under the same or similar conditions. "
    // },
    // {
    //   "code": "M18",
    //   "descr": "Certain services may be approved for home use.  Neither a hospital nor a Skilled Nursing Facility (SNF) is considered to be a patient's home. "
    // },
    // {
    //   "code": "M19",
    //   "descr": "Missing oxygen certification/re-certification. "
    // },
    // {
    //   "code": "M20",
    //   "descr": "Missing/incomplete/invalid HCPCS. "
    // },
    // {
    //   "code": "M21",
    //   "descr": "Missing/incomplete/invalid place of residence for this service/item provided in a home. "
    // },
    // {
    //   "code": "M22",
    //   "descr": "Missing/incomplete/invalid number of miles traveled. "
    // },
    // {
    //   "code": "M23",
    //   "descr": "Missing invoice. "
    // },
    // {
    //   "code": "M24",
    //   "descr": "Missing/incomplete/invalid number of doses per vial. "
    // },
    // {
    //   "code": "M25",
    //   "descr": "The information furnished does not substantiate the need for this level of service. If you believe the service should have been fully covered as billed, or if you did not know and could not reasonably have been expected to know that we would not pay for this level of service, or if you notified the patient in writing in advance that we would not pay for this level of service and he/she agreed in writing to pay, ask us to review your claim within 120 days of the date of this notice.  If you do not request an appeal, we will, upon application from the patient, reimburse him/her for the amount you have collected from him/her in excess of any deductible and coinsurance amounts. We will recover the reimbursement from you as an overpayment. "
    // },
    // {
    //   "code": "M26",
    //   "descr": "The information furnished does not substantiate the need for this level of service. If you have collected any amount from the patient for this level of service /any amount that exceeds the limiting charge for the less extensive service, the law requires you to refund that amount to the patient within 30 days of receiving this notice.    The requirements for refund are in 1824(I) of the Social Security Act and 42CFR411.408. The section specifies that physicians who knowingly and willfully fail to make appropriate refunds may be subject to civil monetary penalties and/or exclusion from the program. If you have any questions about this notice, please contact this office. "
    // },
    // {
    //   "code": "M27",
    //   "descr": "Alert: The patient has been relieved of liability of payment of these items and services under the limitation of liability provision of the law. The provider is ultimately liable for the patient's waived charges, including any charges for coinsurance, since the items or services were not reasonable and necessary or constituted custodial care, and you knew or could reasonably have been expected to know, that they were not covered. You may appeal this determination. You may ask for an appeal regarding both the coverage determination and the issue of whether you exercised due care. The appeal request must be filed within 120 days of the date you receive this notice. You must make the request through this office. "
    // },
    // {
    //   "code": "M28",
    //   "descr": "This does not qualify for payment under Part B when Part A coverage is exhausted or not otherwise available. "
    // },
    // {
    //   "code": "M29",
    //   "descr": "Missing operative note/report. "
    // },
    // {
    //   "code": "M30",
    //   "descr": "Missing pathology report. "
    // },
    // {
    //   "code": "M31",
    //   "descr": "Missing radiology report. "
    // },
    // {
    //   "code": "M32",
    //   "descr": "Alert: This is a conditional payment made pending a decision on this service by the patient's primary payer. This payment may be subject to refund upon your receipt of any additional payment for this service from another payer. You must contact this office immediately upon receipt of an additional payment for this service. "
    // },
    // {
    //   "code": "M33",
    //   "descr": "Missing/incomplete/invalid UPIN for the ordering/referring/performing provider. "
    // },
    // {
    //   "code": "M34",
    //   "descr": "Claim lacks the CLIA certification number. "
    // },
    // {
    //   "code": "M35",
    //   "descr": "Missing/incomplete/invalid pre-operative photos or visual field results. "
    // },
    // {
    //   "code": "M36",
    //   "descr": "This is the 11th rental month.  We cannot pay for this until you indicate that the patient has been given the option of changing the rental to a purchase. "
    // },
    // {
    //   "code": "M37",
    //   "descr": "Not covered when the patient is under age 35. "
    // },
    // {
    //   "code": "M38",
    //   "descr": "Alert: The patient is liable for the charges for this service as they were informed in writing before the service was furnished that we would not pay for it and the patient agreed to be responsible for the charges. "
    // },
    // {
    //   "code": "M39",
    //   "descr": "Alert: The patient is not liable for payment of this service as the advance notice of non-coverage you provided the patient did not comply with program requirements. "
    // },
    // {
    //   "code": "M40",
    //   "descr": "Claim must be assigned and must be filed by the practitioner's employer. "
    // },
    // {
    //   "code": "M41",
    //   "descr": "We do not pay for this as the patient has no legal obligation to pay for this. "
    // },
    // {
    //   "code": "M42",
    //   "descr": "The medical necessity form must be personally signed by the attending physician. "
    // },
    // {
    //   "code": "M43",
    //   "descr": "Payment for this service previously issued to you or another provider by another carrier/intermediary. "
    // },
    // {
    //   "code": "M44",
    //   "descr": "Missing/incomplete/invalid condition code. "
    // },
    // {
    //   "code": "M45",
    //   "descr": "Missing/incomplete/invalid occurrence code(s). "
    // },
    // {
    //   "code": "M46",
    //   "descr": "Missing/incomplete/invalid occurrence span code(s). "
    // },
    // {
    //   "code": "M47",
    //   "descr": "Missing/incomplete/invalid Payer Claim Control Number. Other terms exist for this element including, but not limited to, Internal Control Number (ICN), Claim Control Number (CCN), Document Control Number (DCN). "
    // },
    // {
    //   "code": "M48",
    //   "descr": "Payment for services furnished to hospital inpatients (other than professional services of physicians) can only be made to the hospital.  You must request payment from the hospital rather than the patient for this service. "
    // },
    // {
    //   "code": "M49",
    //   "descr": "Missing/incomplete/invalid value code(s) or amount(s). "
    // },
    // {
    //   "code": "M50",
    //   "descr": "Missing/incomplete/invalid revenue code(s). "
    // },
    // {
    //   "code": "M51",
    //   "descr": "Missing/incomplete/invalid procedure code(s). "
    // },
    // {
    //   "code": "M52",
    //   "descr": "Missing/incomplete/invalid 'from' date(s) of service."
    // },
    // {
    //   "code": "M53",
    //   "descr": "Missing/incomplete/invalid days or units of service. "
    // },
    // {
    //   "code": "M54",
    //   "descr": "Missing/incomplete/invalid total charges. "
    // },
    // {
    //   "code": "M55",
    //   "descr": "We do not pay for self-administered anti-emetic drugs that are not administered with a covered oral anti-cancer drug. "
    // },
    // {
    //   "code": "M56",
    //   "descr": "Missing/incomplete/invalid payer identifier. "
    // },
    // {
    //   "code": "M57",
    //   "descr": "Missing/incomplete/invalid provider identifier. "
    // },
    // {
    //   "code": "M58",
    //   "descr": "Missing/incomplete/invalid claim information.  Resubmit claim after corrections. "
    // },
    // {
    //   "code": "M59",
    //   "descr": "Missing/incomplete/invalid 'to' date(s) of service."
    // },
    // {
    //   "code": "M60",
    //   "descr": "Missing Certificate of Medical Necessity. "
    // },
    // {
    //   "code": "M61",
    //   "descr": "We cannot pay for this as the approval period for the FDA clinical trial has expired. "
    // },
    // {
    //   "code": "M62",
    //   "descr": "Missing/incomplete/invalid treatment authorization code. "
    // },
    // {
    //   "code": "M63",
    //   "descr": "We do not pay for more than one of these on the same day. "
    // },
    // {
    //   "code": "M64",
    //   "descr": "Missing/incomplete/invalid other diagnosis. "
    // },
    // {
    //   "code": "M65",
    //   "descr": "One interpreting physician charge can be submitted per claim when a purchased diagnostic test is indicated. Please submit a separate claim for each interpreting physician. "
    // },
    // {
    //   "code": "M66",
    //   "descr": "Our records indicate that you billed diagnostic tests subject to price limitations and the procedure code submitted includes a professional component. Only the technical component is subject to price limitations.  Please submit the technical and professional components of this service as separate line items. "
    // },
    // {
    //   "code": "M67",
    //   "descr": "Missing/incomplete/invalid other procedure code(s). "
    // },
    // {
    //   "code": "M68",
    //   "descr": "Missing/incomplete/invalid attending, ordering, rendering, supervising or referring physician identification. "
    // },
    // {
    //   "code": "M69",
    //   "descr": "Paid at the regular rate as you did not submit documentation to justify the modified procedure code. "
    // },
    // {
    //   "code": "M70",
    //   "descr": "Alert: The NDC code submitted for this service was translated to a HCPCS code for processing, but please continue to submit the NDC on future claims for this item. "
    // },
    // {
    //   "code": "M71",
    //   "descr": "Total payment reduced due to overlap of tests billed. "
    // },
    // {
    //   "code": "M72",
    //   "descr": "Did not enter full 8-digit date (MM/DD/CCYY). "
    // },
    // {
    //   "code": "M73",
    //   "descr": "The HPSA/Physician Scarcity bonus can only be paid on the professional component of this service. Rebill as separate professional and technical components.  "
    // },
    // {
    //   "code": "M74",
    //   "descr": "This service does not qualify for a HPSA/Physician Scarcity bonus payment. "
    // },
    // {
    //   "code": "M75",
    //   "descr": "Multiple automated multichannel tests performed on the same day combined for payment. "
    // },
    // {
    //   "code": "M76",
    //   "descr": "Missing/incomplete/invalid diagnosis or condition. "
    // },
    // {
    //   "code": "M77",
    //   "descr": "Missing/incomplete/invalid/inappropriate place of service. "
    // },
    // {
    //   "code": "M78",
    //   "descr": "Missing/incomplete/invalid HCPCS modifier. "
    // },
    // {
    //   "code": "M79",
    //   "descr": "Missing/incomplete/invalid charge. "
    // },
    // {
    //   "code": "M80",
    //   "descr": "Not covered when performed during the same session/date as a previously processed service for the patient. "
    // },
    // {
    //   "code": "M81",
    //   "descr": "You are required to code to the highest level of specificity. "
    // },
    // {
    //   "code": "M82",
    //   "descr": "Service is not covered when patient is under age 50. "
    // },
    // {
    //   "code": "M83",
    //   "descr": "Service is not covered unless the patient is classified as at high risk. "
    // },
    // {
    //   "code": "M84",
    //   "descr": "Medical code sets used must be the codes in effect at the time of service. "
    // },
    // {
    //   "code": "M85",
    //   "descr": "Subjected to review of physician evaluation and management services. "
    // },
    // {
    //   "code": "M86",
    //   "descr": "Service denied because payment already made for same/similar procedure within set time frame. "
    // },
    // {
    //   "code": "M87",
    //   "descr": "Claim/service(s) subjected to CFO-CAP prepayment review. "
    // },
    // {
    //   "code": "M88",
    //   "descr": "We cannot pay for laboratory tests unless billed by the laboratory that did the work. "
    // },
    // {
    //   "code": "M89",
    //   "descr": "Not covered more than once under age 40. "
    // },
    // {
    //   "code": "M90",
    //   "descr": "Not covered more than once in a 12 month period. "
    // },
    // {
    //   "code": "M91",
    //   "descr": "Lab procedures with different CLIA certification numbers must be billed on separate claims. "
    // },
    // {
    //   "code": "M92",
    //   "descr": "Services subjected to review under the Home Health Medical Review Initiative. "
    // },
    // {
    //   "code": "M93",
    //   "descr": "Information supplied supports a break in therapy.  A new capped rental period began with delivery of this equipment. "
    // },
    // {
    //   "code": "M94",
    //   "descr": "Information supplied does not support a break in therapy.  A new capped rental period will not begin. "
    // },
    // {
    //   "code": "M95",
    //   "descr": "Services subjected to Home Health Initiative medical review/cost report audit. "
    // },
    // {
    //   "code": "M96",
    //   "descr": "The technical component of a service furnished to an inpatient may only be billed by that inpatient facility. You must contact the inpatient facility for technical component reimbursement.  If not already billed, you should bill us for the professional component only. "
    // },
    // {
    //   "code": "M97",
    //   "descr": "Not paid to practitioner when provided to patient in this place of service.  Payment included in the reimbursement issued the facility. "
    // },
    // {
    //   "code": "M98",
    //   "descr": "Begin to report the Universal Product Number on claims for items of this type. We will soon begin to deny payment for items of this type if billed without the correct UPN. "
    // },
    // {
    //   "code": "M99",
    //   "descr": "Missing/incomplete/invalid Universal Product Number/Serial Number. "
    // },
    // {
    //   "code": "M100",
    //   "descr": "We do not pay for an oral anti-emetic drug that is not administered for use immediately before, at, or within 48 hours of administration of a covered chemotherapy drug. "
    // },
    // {
    //   "code": "M101",
    //   "descr": "Begin to report a G1-G5 modifier with this HCPCS.  We will soon begin to deny payment for this service if billed without a G1-G5 modifier. "
    // },
    // {
    //   "code": "M102",
    //   "descr": "Service not performed on equipment approved by the FDA for this purpose. "
    // },
    // {
    //   "code": "M103",
    //   "descr": "Information supplied supports a break in therapy.  However, the medical information we have for this patient does not support the need for this item as billed.  We have approved payment for this item at a reduced level, and a new capped rental period will begin with the delivery of this equipment. "
    // },
    // {
    //   "code": "M104",
    //   "descr": "Information supplied supports a break in therapy.  A new capped rental period will begin with delivery of the equipment.  This is the maximum approved under the fee schedule for this item or service. "
    // },
    // {
    //   "code": "M105",
    //   "descr": "Information supplied does not support a break in therapy.  The medical information we have for this patient does not support the need for this item as billed. We have approved payment for this item at a reduced level, and a new capped rental period will not begin. "
    // },
    // {
    //   "code": "M106",
    //   "descr": "Information supplied does not support a break in therapy.  A new capped rental period will not begin. This is the maximum approved under the fee schedule for this item or service. "
    // },
    // {
    //   "code": "M107",
    //   "descr": "Payment reduced as 90-day rolling average hematocrit for ESRD patient exceeded 36.5%."
    // },
    // {
    //   "code": "M108",
    //   "descr": "Missing/incomplete/invalid provider identifier for the provider who interpreted the diagnostic test. "
    // },
    // {
    //   "code": "M109",
    //   "descr": "We have provided you with a bundled payment for a teleconsultation. You must send 25 percent of the teleconsultation payment to the referring practitioner.  "
    // },
    // {
    //   "code": "M110",
    //   "descr": "Missing/incomplete/invalid provider identifier for the provider from whom you purchased interpretation services. "
    // },
    // {
    //   "code": "M111",
    //   "descr": "We do not pay for chiropractic manipulative treatment when the patient refuses to have an x-ray taken. "
    // },
    // {
    //   "code": "M112",
    //   "descr": "Reimbursement for this item is based on the single payment amount required under the DMEPOS Competitive Bidding Program for the area where the patient resides. "
    // },
    // {
    //   "code": "M113",
    //   "descr": "Our records indicate that this patient began using this item/service prior to the current contract period for the DMEPOS Competitive Bidding Program. "
    // },
    // {
    //   "code": "M114",
    //   "descr": "This service was processed in accordance with rules and guidelines under the DMEPOS Competitive Bidding Program or a Demonstration Project.  For more information regarding these projects, contact your local contractor. "
    // },
    // {
    //   "code": "M115",
    //   "descr": "This item is denied when provided to this patient by a non-contract or non-demonstration supplier. "
    // },
    // {
    //   "code": "M116",
    //   "descr": "Processed under a demonstration project or program. Project or program is ending and additional services may not be paid under this project or program. "
    // },
    // {
    //   "code": "M117",
    //   "descr": "Not covered unless submitted via electronic claim. "
    // },
    // {
    //   "code": "M118",
    //   "descr": "Letter to follow containing further information. "
    // },
    // {
    //   "code": "M119",
    //   "descr": "Missing/incomplete/invalid/ deactivated/withdrawn National Drug Code (NDC). "
    // },
    // {
    //   "code": "M120",
    //   "descr": "Missing/incomplete/invalid provider identifier for the substituting physician who furnished the service(s) under a reciprocal billing or locum tenens arrangement. "
    // },
    // {
    //   "code": "M121",
    //   "descr": "We pay for this service only when performed with a covered cryosurgical ablation. "
    // },
    // {
    //   "code": "M122",
    //   "descr": "Missing/incomplete/invalid level of subluxation. "
    // },
    // {
    //   "code": "M123",
    //   "descr": "Missing/incomplete/invalid name, strength, or dosage of the drug furnished. "
    // },
    // {
    //   "code": "M124",
    //   "descr": "Missing indication of whether the patient owns the equipment that requires the part or supply. "
    // },
    // {
    //   "code": "M125",
    //   "descr": "Missing/incomplete/invalid information on the period of time for which the service/supply/equipment will be needed. "
    // },
    // {
    //   "code": "M126",
    //   "descr": "Missing/incomplete/invalid individual lab codes included in the test. "
    // },
    // {
    //   "code": "M127",
    //   "descr": "Missing patient medical record for this service. "
    // },
    // {
    //   "code": "M128",
    //   "descr": "Missing/incomplete/invalid date of the patient's last physician visit. "
    // },
    // {
    //   "code": "M129",
    //   "descr": "Missing/incomplete/invalid indicator of x-ray availability for review. "
    // },
    // {
    //   "code": "M130",
    //   "descr": "Missing invoice or statement certifying the actual cost of the lens, less discounts, and/or the type of intraocular lens used. "
    // },
    // {
    //   "code": "M131",
    //   "descr": "Missing physician financial relationship form. "
    // },
    // {
    //   "code": "M132",
    //   "descr": "Missing pacemaker registration form. "
    // },
    // {
    //   "code": "M133",
    //   "descr": "Claim did not identify who performed the purchased diagnostic test or the amount you were charged for the test. "
    // },
    // {
    //   "code": "M134",
    //   "descr": "Performed by a facility/supplier in which the provider has a financial interest. "
    // },
    // {
    //   "code": "M135",
    //   "descr": "Missing/incomplete/invalid plan of treatment. "
    // },
    // {
    //   "code": "M136",
    //   "descr": "Missing/incomplete/invalid indication that the service was supervised or evaluated by a physician. "
    // },
    // {
    //   "code": "M137",
    //   "descr": "Part B coinsurance under a demonstration project or pilot program. "
    // },
    // {
    //   "code": "M138",
    //   "descr": "Patient identified as a demonstration participant but the patient was not enrolled in the demonstration at the time services were rendered.  Coverage is limited to demonstration participants. "
    // },
    // {
    //   "code": "M139",
    //   "descr": "Denied services exceed the coverage limit for the demonstration. "
    // },
    // {
    //   "code": "M140",
    //   "descr": "Service not covered until after the patient's 50th birthday, i.e., no coverage prior to the day after the 50th birthday "
    // },
    // {
    //   "code": "M141",
    //   "descr": "Missing physician certified plan of care. "
    // },
    // {
    //   "code": "M142",
    //   "descr": "Missing American Diabetes Association Certificate of Recognition. "
    // },
    // {
    //   "code": "M143",
    //   "descr": "The provider must update license information with the payer. "
    // },
    // {
    //   "code": "M144",
    //   "descr": "Pre-/post-operative care payment is included in the allowance for the surgery/procedure. "
    // },
    // {
    //   "code": "MA01",
    //   "descr": "Alert: If you do not agree with what we approved for these services, you may appeal our decision.  To make sure that we are fair to you, we require another individual that did not process your initial claim to conduct the appeal.  However, in order to be eligible for an appeal, you must write to us within 120 days of the date you received this notice, unless you have a good reason for being late. "
    // },
    // {
    //   "code": "MA02",
    //   "descr": "Alert: If you do not agree with this determination, you have the right to appeal. You must file a written request for an appeal within 180 days of the date you receive this notice. "
    // },
    // {
    //   "code": "MA03",
    //   "descr": "If you do not agree with the approved amounts and $100 or more is in dispute (less deductible and coinsurance), you may ask for a hearing within six months of the date of this notice. To meet the $100, you may combine amounts on other claims that have been denied, including reopened appeals if you received a revised decision. You must appeal each claim on time."
    // },
    // {
    //   "code": "MA04",
    //   "descr": "Secondary payment cannot be considered without the identity of or payment information from the primary payer.  The information was either not reported or was illegible. "
    // },
    // {
    //   "code": "MA05",
    //   "descr": "Incorrect admission date patient status or type of bill entry on claim.   "
    // },
    // {
    //   "code": "MA06",
    //   "descr": "Missing/incomplete/invalid beginning and/or ending date(s). "
    // },
    // {
    //   "code": "MA07",
    //   "descr": "Alert: The claim information has also been forwarded to Medicaid for review. "
    // },
    // {
    //   "code": "MA08",
    //   "descr": "Alert: Claim information was not forwarded because the supplemental coverage is not with a Medigap plan, or you do not participate in Medicare. "
    // },
    // {
    //   "code": "MA09",
    //   "descr": "Alert: Claim submitted as unassigned but processed as assigned in accordance with our current assignment/participation agreement. "
    // },
    // {
    //   "code": "MA10",
    //   "descr": "Alert: The patient's payment was in excess of the amount owed.  You must refund the overpayment to the patient. "
    // },
    // {
    //   "code": "MA11",
    //   "descr": "Payment is being issued on a conditional basis.  If no-fault insurance, liability insurance, Workers' Compensation, Department of Veterans Affairs, or a group health plan for employees and dependents also covers this claim, a refund may be due us.  Please contact us if the patient is covered by any of these sources. "
    // },
    // {
    //   "code": "MA12",
    //   "descr": "You have not established that you have the right under the law to bill for services furnished by the person(s) that furnished this (these) service(s). "
    // },
    // {
    //   "code": "MA13",
    //   "descr": "Alert: You may be subject to penalties if you bill the patient for amounts not reported with the PR (patient responsibility) group code. "
    // },
    // {
    //   "code": "MA14",
    //   "descr": "Alert: The patient is a member of an employer-sponsored prepaid health plan. Services from outside that health plan are not covered.  However, as you were not previously notified of this, we are paying this time.  In the future, we will not pay you for non-plan services. "
    // },
    // {
    //   "code": "MA15",
    //   "descr": "Alert: Your claim has been separated to expedite handling. You will receive a separate notice for the other services reported. "
    // },
    // {
    //   "code": "MA16",
    //   "descr": "The patient is covered by the Black Lung Program.  Send this claim to the Department of Labor, Federal Black Lung Program, P.O. Box 828, Lanham-Seabrook MD 20703. "
    // },
    // {
    //   "code": "MA17",
    //   "descr": "We are the primary payer and have paid at the primary rate.  You must contact the patient's other insurer to refund any excess it may have paid due to its erroneous primary payment. "
    // },
    // {
    //   "code": "MA18",
    //   "descr": "Alert: The claim information is also being forwarded to the patient's supplemental insurer. Send any questions regarding supplemental benefits to them. "
    // },
    // {
    //   "code": "MA19",
    //   "descr": "Alert:  Information was not sent to the Medigap insurer due to incorrect/invalid information you submitted concerning that insurer. Please verify your information and submit your secondary claim directly to that insurer. "
    // },
    // {
    //   "code": "MA20",
    //   "descr": "Skilled Nursing Facility (SNF) stay not covered when care is primarily related to the use of an urethral catheter for convenience or the control of incontinence. "
    // },
    // {
    //   "code": "MA21",
    //   "descr": "SSA records indicate mismatch with name and sex. "
    // },
    // {
    //   "code": "MA22",
    //   "descr": "Payment of less than $1.00 suppressed."
    // },
    // {
    //   "code": "MA23",
    //   "descr": "Demand bill approved as result of medical review. "
    // },
    // {
    //   "code": "MA24",
    //   "descr": "Christian Science Sanitarium/ Skilled Nursing Facility (SNF) bill in the same benefit period.  "
    // },
    // {
    //   "code": "MA25",
    //   "descr": "A patient may not elect to change a hospice provider more than once in a benefit period. "
    // },
    // {
    //   "code": "MA26",
    //   "descr": "Alert: Our records indicate that you were previously informed of this rule. "
    // },
    // {
    //   "code": "MA27",
    //   "descr": "Missing/incomplete/invalid entitlement number or name shown on the claim. "
    // },
    // {
    //   "code": "MA28",
    //   "descr": "Alert: Receipt of this notice by a physician or supplier who did not accept assignment is for information only and does not make the physician or supplier a party to the determination.  No additional rights to appeal this decision, above those rights already provided for by regulation/instruction, are conferred by receipt of this notice. "
    // },
    // {
    //   "code": "MA29",
    //   "descr": "Missing/incomplete/invalid provider name, city, state, or zip code. "
    // },
    // {
    //   "code": "MA30",
    //   "descr": "Missing/incomplete/invalid type of bill. "
    // },
    // {
    //   "code": "MA31",
    //   "descr": "Missing/incomplete/invalid beginning and ending dates of the period billed. "
    // },
    // {
    //   "code": "MA32",
    //   "descr": "Missing/incomplete/invalid number of covered days during the billing period. "
    // },
    // {
    //   "code": "MA33",
    //   "descr": "Missing/incomplete/invalid noncovered days during the billing period. "
    // },
    // {
    //   "code": "MA34",
    //   "descr": "Missing/incomplete/invalid number of coinsurance days during the billing period. "
    // },
    // {
    //   "code": "MA35",
    //   "descr": "Missing/incomplete/invalid number of lifetime reserve days. "
    // },
    // {
    //   "code": "MA36",
    //   "descr": "Missing/incomplete/invalid patient name. "
    // },
    // {
    //   "code": "MA37",
    //   "descr": "Missing/incomplete/invalid patient's address. "
    // },
    // {
    //   "code": "MA38",
    //   "descr": "Missing/incomplete/invalid birth date. "
    // },
    // {
    //   "code": "MA39",
    //   "descr": "Missing/incomplete/invalid gender. "
    // },
    // {
    //   "code": "MA40",
    //   "descr": "Missing/incomplete/invalid admission date. "
    // },
    // {
    //   "code": "MA41",
    //   "descr": "Missing/incomplete/invalid admission type. "
    // },
    // {
    //   "code": "MA42",
    //   "descr": "Missing/incomplete/invalid admission source. "
    // },
    // {
    //   "code": "MA43",
    //   "descr": "Missing/incomplete/invalid patient status. "
    // },
    // {
    //   "code": "MA44",
    //   "descr": "Alert: No appeal rights. Adjudicative decision based on law. "
    // },
    // {
    //   "code": "MA45",
    //   "descr": "Alert: As previously advised, a portion or all of your payment is being held in a special account. "
    // },
    // {
    //   "code": "MA46",
    //   "descr": "Alert: The new information was considered but additional payment will not be issued. "
    // },
    // {
    //   "code": "MA47",
    //   "descr": "Our records show you have opted out of Medicare, agreeing with the patient not to bill Medicare for services/tests/supplies furnished.  As result, we cannot pay this claim. The patient is responsible for payment. "
    // },
    // {
    //   "code": "MA48",
    //   "descr": "Missing/incomplete/invalid name or address of responsible party or primary payer. "
    // },
    // {
    //   "code": "MA49",
    //   "descr": "Missing/incomplete/invalid six-digit provider identifier for home health agency or hospice for physician(s) performing care plan oversight services. "
    // },
    // {
    //   "code": "MA50",
    //   "descr": "Missing/incomplete/invalid Investigational Device Exemption number or Clinical Trial number. "
    // },
    // {
    //   "code": "MA51",
    //   "descr": "Missing/incomplete/invalid CLIA certification number for laboratory services billed by physician office laboratory. "
    // },
    // {
    //   "code": "MA52",
    //   "descr": "Missing/incomplete/invalid date. "
    // },
    // {
    //   "code": "MA53",
    //   "descr": "Missing/incomplete/invalid Competitive Bidding Demonstration Project identification.  "
    // },
    // {
    //   "code": "MA54",
    //   "descr": "Physician certification or election consent for hospice care not received timely. "
    // },
    // {
    //   "code": "MA55",
    //   "descr": "Not covered as patient received medical health care services, automatically revoking his/her election to receive religious non-medical health care services. "
    // },
    // {
    //   "code": "MA56",
    //   "descr": "Our records show you have opted out of Medicare, agreeing with the patient not to bill Medicare for services/tests/supplies furnished.  As result, we cannot pay this claim. The patient is responsible for payment, but under Federal law, you cannot charge the patient more than the limiting charge amount. "
    // },
    // {
    //   "code": "MA57",
    //   "descr": "Patient submitted written request to revoke his/her election for religious non-medical health care services. "
    // },
    // {
    //   "code": "MA58",
    //   "descr": "Missing/incomplete/invalid release of information indicator. "
    // },
    // {
    //   "code": "MA59",
    //   "descr": "Alert: The patient overpaid you for these services. You must issue the patient a refund within 30 days for the difference between his/her payment and the total amount shown as patient responsibility on this notice.  "
    // },
    // {
    //   "code": "MA60",
    //   "descr": "Missing/incomplete/invalid patient relationship to insured. "
    // },
    // {
    //   "code": "MA61",
    //   "descr": "Missing/incomplete/invalid social security number or health insurance claim number. "
    // },
    // {
    //   "code": "MA62",
    //   "descr": "Alert: This is a telephone review decision. "
    // },
    // {
    //   "code": "MA63",
    //   "descr": "Missing/incomplete/invalid principal diagnosis. "
    // },
    // {
    //   "code": "MA64",
    //   "descr": "Our records indicate that we should be the third payer for this claim.  We cannot process this claim until we have received payment information from the primary and secondary payers. "
    // },
    // {
    //   "code": "MA65",
    //   "descr": "Missing/incomplete/invalid admitting diagnosis. "
    // },
    // {
    //   "code": "MA66",
    //   "descr": "Missing/incomplete/invalid principal procedure code. "
    // },
    // {
    //   "code": "MA67",
    //   "descr": "Alert: Correction to a prior claim. "
    // },
    // {
    //   "code": "MA68",
    //   "descr": "Alert: We did not crossover this claim because the secondary insurance information on the claim was incomplete. Please supply complete information or use the PLANID of the insurer to assure correct and timely routing of the claim. "
    // },
    // {
    //   "code": "MA69",
    //   "descr": "Missing/incomplete/invalid remarks. "
    // },
    // {
    //   "code": "MA70",
    //   "descr": "Missing/incomplete/invalid provider representative signature. "
    // },
    // {
    //   "code": "MA71",
    //   "descr": "Missing/incomplete/invalid provider representative signature date. "
    // },
    // {
    //   "code": "MA72",
    //   "descr": "Alert: The patient overpaid you for these assigned services.  You must issue the patient a refund within 30 days for the difference between his/her payment to you and the total of the amount shown as patient responsibility and as paid to the patient on this notice. "
    // },
    // {
    //   "code": "MA73",
    //   "descr": "Informational remittance associated with a Medicare demonstration.  No payment issued under fee-for-service Medicare as patient has elected managed care. "
    // },
    // {
    //   "code": "MA74",
    //   "descr": "Alert: This payment replaces an earlier payment for this claim that was either lost, damaged or returned. "
    // },
    // {
    //   "code": "MA75",
    //   "descr": "Missing/incomplete/invalid patient or authorized representative signature. "
    // },
    // {
    //   "code": "MA76",
    //   "descr": "Missing/incomplete/invalid provider identifier for home health agency or hospice when physician is performing care plan oversight services. "
    // },
    // {
    //   "code": "MA77",
    //   "descr": "Alert: The patient overpaid you. You must issue the patient a refund within 30 days for the difference between the patient's payment less the total of our and other payer payments and the amount shown as patient responsibility on this notice. "
    // },
    // {
    //   "code": "MA78",
    //   "descr": "The patient overpaid you.  You must issue the patient a refund within 30 days for the difference between our allowed amount total and the amount paid by the patient. "
    // },
    // {
    //   "code": "MA79",
    //   "descr": "Billed in excess of interim rate. "
    // },
    // {
    //   "code": "MA80",
    //   "descr": "Informational notice. No payment issued for this claim with this notice. Payment issued to the hospital by its intermediary for all services for this encounter under a demonstration project. "
    // },
    // {
    //   "code": "MA81",
    //   "descr": "Missing/incomplete/invalid provider/supplier signature. "
    // },
    // {
    //   "code": "MA82",
    //   "descr": "Missing/incomplete/invalid provider/supplier billing number/identifier or billing name, address, city, state, zip code, or phone number. "
    // },
    // {
    //   "code": "MA83",
    //   "descr": "Did not indicate whether we are the primary or secondary payer. "
    // },
    // {
    //   "code": "MA84",
    //   "descr": "Patient identified as participating in the National Emphysema Treatment Trial but our records indicate that this patient is either not a participant, or has not yet been approved for this phase of the study.  Contact Johns Hopkins University, the study coordinator, to resolve if there was a discrepancy. "
    // },
    // {
    //   "code": "MA85",
    //   "descr": "Our records indicate that a primary payer exists (other than ourselves); however, you did not complete or enter accurately the insurance plan/group/program name or identification number.  Enter the PlanID when effective. "
    // },
    // {
    //   "code": "MA86",
    //   "descr": "Missing/incomplete/invalid group or policy number of the insured for the primary coverage. "
    // },
    // {
    //   "code": "MA87",
    //   "descr": "Missing/incomplete/invalid insured's name for the primary payer. "
    // },
    // {
    //   "code": "MA88",
    //   "descr": "Missing/incomplete/invalid insured's address and/or telephone number for the primary payer. "
    // },
    // {
    //   "code": "MA89",
    //   "descr": "Missing/incomplete/invalid patient's relationship to the insured for the primary payer. "
    // },
    // {
    //   "code": "MA90",
    //   "descr": "Missing/incomplete/invalid employment status code for the primary insured. "
    // },
    // {
    //   "code": "MA91",
    //   "descr": "Alert: This determination is the result of the appeal you filed. "
    // },
    // {
    //   "code": "MA92",
    //   "descr": "Missing plan information for other insurance. "
    // },
    // {
    //   "code": "MA93",
    //   "descr": "Non-PIP (Periodic Interim Payment) claim. "
    // },
    // {
    //   "code": "MA94",
    //   "descr": "Did not enter the statement 'Attending physician not hospice employee' on the claim form to certify that the rendering physician is not an employee of the hospice."
    // },
    // {
    //   "code": "MA95",
    //   "descr": "A not otherwise classified or unlisted procedure code(s) was billed but a narrative description of the procedure was not entered on the claim.  Refer to item 19 on the HCFA-1500. "
    // },
    // {
    //   "code": "MA96",
    //   "descr": "Claim rejected. Coded as a Medicare Managed Care Demonstration but patient is not enrolled in a Medicare managed care plan. "
    // },
    // {
    //   "code": "MA97",
    //   "descr": "Missing/incomplete/invalid Medicare Managed Care Demonstration contract number or clinical trial registry number. "
    // },
    // {
    //   "code": "MA98",
    //   "descr": "Claim Rejected. Does not contain the correct Medicare Managed Care Demonstration contract number for this beneficiary. "
    // },
    // {
    //   "code": "MA99",
    //   "descr": "Missing/incomplete/invalid Medigap information. "
    // },
    // {
    //   "code": "MA100",
    //   "descr": "Missing/incomplete/invalid date of current illness or symptoms. "
    // },
    // {
    //   "code": "MA101",
    //   "descr": "A Skilled Nursing Facility (SNF) is responsible for payment of outside providers who furnish these services/supplies to residents. "
    // },
    // {
    //   "code": "MA102",
    //   "descr": "Missing/incomplete/invalid name or provider identifier for the rendering/referring/ ordering/ supervising provider. "
    // },
    // {
    //   "code": "MA103",
    //   "descr": "Hemophilia Add On. "
    // },
    // {
    //   "code": "MA104",
    //   "descr": "Missing/incomplete/invalid date the patient was last seen or the provider identifier of the attending physician. "
    // },
    // {
    //   "code": "MA105",
    //   "descr": "Missing/incomplete/invalid provider number for this place of service. "
    // },
    // {
    //   "code": "MA106",
    //   "descr": "PIP (Periodic Interim Payment) claim. "
    // },
    // {
    //   "code": "MA107",
    //   "descr": "Paper claim contains more than three separate data items in field 19. "
    // },
    // {
    //   "code": "MA108",
    //   "descr": "Paper claim contains more than one data item in field 23.   "
    // },
    // {
    //   "code": "MA109",
    //   "descr": "Claim processed in accordance with ambulatory surgical guidelines.   "
    // },
    // {
    //   "code": "MA110",
    //   "descr": "Missing/incomplete/invalid information on whether the diagnostic test(s) were performed by an outside entity or if no purchased tests are included on the claim. "
    // },
    // {
    //   "code": "MA111",
    //   "descr": "Missing/incomplete/invalid purchase price of the test(s) and/or the performing laboratory's name and address. "
    // },
    // {
    //   "code": "MA112",
    //   "descr": "Missing/incomplete/invalid group practice information. "
    // },
    // {
    //   "code": "MA113",
    //   "descr": "Incomplete/invalid taxpayer identification number (TIN) submitted by you per the Internal Revenue Service. Your claims cannot be processed without your correct TIN, and you may not bill the patient pending correction of your TIN.  There are no appeal rights for unprocessable claims, but you may resubmit this claim after you have notified this office of your correct TIN. "
    // },
    // {
    //   "code": "MA114",
    //   "descr": "Missing/incomplete/invalid information on where the services were furnished. "
    // },
    // {
    //   "code": "MA115",
    //   "descr": "Missing/incomplete/invalid physical location (name and address, or PIN) where the service(s) were rendered in a Health Professional Shortage Area (HPSA). "
    // },
    // {
    //   "code": "MA116",
    //   "descr": "Did not complete the statement 'Homebound' on the claim to validate whether laboratory services were performed at home or in an institution. "
    // },
    // {
    //   "code": "MA117",
    //   "descr": "This claim has been assessed a $1.00 user fee."
    // },
    // {
    //   "code": "MA118",
    //   "descr": "Alert: No Medicare payment issued for this claim for services or supplies furnished to a Medicare-eligible veteran through a facility of the Department of Veterans Affairs. Coinsurance and/or deductible are applicable. "
    // },
    // {
    //   "code": "MA119",
    //   "descr": "Provider level adjustment for late claim filing applies to this claim. "
    // },
    // {
    //   "code": "MA120",
    //   "descr": "Missing/incomplete/invalid CLIA certification number. "
    // },
    // {
    //   "code": "MA121",
    //   "descr": "Missing/incomplete/invalid x-ray date. "
    // },
    // {
    //   "code": "MA122",
    //   "descr": "Missing/incomplete/invalid initial treatment date. "
    // },
    // {
    //   "code": "MA123",
    //   "descr": "Your center was not selected to participate in this study, therefore, we cannot pay for these services. "
    // },
    // {
    //   "code": "MA124",
    //   "descr": "Processed for IME only. "
    // },
    // {
    //   "code": "MA125",
    //   "descr": "Per legislation governing this program, payment constitutes payment in full.  "
    // },
    // {
    //   "code": "MA126",
    //   "descr": "Pancreas transplant not covered unless kidney transplant performed. "
    // },
    // {
    //   "code": "MA127",
    //   "descr": "Reserved for future use. "
    // },
    // {
    //   "code": "MA128",
    //   "descr": "Missing/incomplete/invalid FDA approval number. "
    // },
    // {
    //   "code": "MA129",
    //   "descr": "This provider was not certified for this procedure on this date of service. "
    // },
    // {
    //   "code": "MA130",
    //   "descr": "Your claim contains incomplete and/or invalid information, and no appeal rights are afforded because the claim is unprocessable.  Please submit a new claim with the complete/correct information. "
    // },
    // {
    //   "code": "MA131",
    //   "descr": "Physician already paid for services in conjunction with this demonstration claim.  You must have the physician withdraw that claim and refund the payment before we can process your claim. "
    // },
    // {
    //   "code": "MA132",
    //   "descr": "Adjustment to the pre-demonstration rate. "
    // },
    // {
    //   "code": "MA133",
    //   "descr": "Claim overlaps inpatient stay. Rebill only those services rendered outside the inpatient stay. "
    // },
    // {
    //   "code": "MA134",
    //   "descr": "Missing/incomplete/invalid provider number of the facility where the patient resides.  "
    // },
    // {
    //   "code": "N1",
    //   "descr": "Alert: You may appeal this decision in writing within the required time limits following receipt of this notice by following the instructions included in your contract, plan benefit documents or jurisdiction statutes. "
    // },
    // {
    //   "code": "N2",
    //   "descr": "This allowance has been made in accordance with the most appropriate course of treatment provision of the plan. "
    // },
    // {
    //   "code": "N3",
    //   "descr": "Missing consent form. "
    // },
    // {
    //   "code": "N4",
    //   "descr": "Missing/Incomplete/Invalid prior Insurance Carrier(s) EOB.  "
    // },
    // {
    //   "code": "N5",
    //   "descr": "EOB received from previous payer.  Claim not on file. "
    // },
    // {
    //   "code": "N6",
    //   "descr": "Under FEHB law (U.S.C. 8904(b)), we cannot pay more for covered care than the amount Medicare would have allowed if the patient were enrolled in Medicare Part A and/or Medicare Part B. "
    // },
    // {
    //   "code": "N7",
    //   "descr": "Alert: Processing of this claim/service has included consideration under Major Medical provisions. "
    // },
    // {
    //   "code": "N8",
    //   "descr": "Crossover claim denied by previous payer and complete claim data not forwarded. Resubmit this claim to this payer to provide adequate data for adjudication. "
    // },
    // {
    //   "code": "N9",
    //   "descr": "Adjustment represents the estimated amount a previous payer may pay. "
    // },
    // {
    //   "code": "N10",
    //   "descr": "Adjustment based on the findings of a review organization/professional consult/manual adjudication/medical advisor/dental advisor/peer review. "
    // },
    // {
    //   "code": "N11",
    //   "descr": "Denial reversed because of medical review. "
    // },
    // {
    //   "code": "N12",
    //   "descr": "Policy provides coverage supplemental to Medicare. As the member does not appear to be enrolled in the applicable part of Medicare, the member is responsible for payment of the portion of the charge that would have been covered by Medicare. "
    // },
    // {
    //   "code": "N13",
    //   "descr": "Payment based on professional/technical component modifier(s). "
    // },
    // {
    //   "code": "N14",
    //   "descr": "Payment based on a contractual amount or agreement, fee schedule, or maximum allowable amount. "
    // },
    // {
    //   "code": "N15",
    //   "descr": "Services for a newborn must be billed separately. "
    // },
    // {
    //   "code": "N16",
    //   "descr": "Family/member Out-of-Pocket maximum has been met. Payment based on a higher percentage. "
    // },
    // {
    //   "code": "N17",
    //   "descr": "Per admission deductible. "
    // },
    // {
    //   "code": "N18",
    //   "descr": "Payment based on the Medicare allowed amount. "
    // },
    // {
    //   "code": "N19",
    //   "descr": "Procedure code incidental to primary procedure. "
    // },
    // {
    //   "code": "N20",
    //   "descr": "Service not payable with other service rendered on the same date. "
    // },
    // {
    //   "code": "N21",
    //   "descr": "Alert: Your line item has been separated into multiple lines to expedite handling. "
    // },
    // {
    //   "code": "N22",
    //   "descr": "Alert: This procedure code was added/changed because it more accurately describes the services rendered. "
    // },
    // {
    //   "code": "N23",
    //   "descr": "Alert: Patient liability may be affected due to coordination of benefits with other carriers and/or maximum benefit provisions. "
    // },
    // {
    //   "code": "N24",
    //   "descr": "Missing/incomplete/invalid Electronic Funds Transfer (EFT) banking information. "
    // },
    // {
    //   "code": "N25",
    //   "descr": "This company has been contracted by your benefit plan to provide administrative claims payment services only.  This company does not assume financial risk or obligation with respect to claims processed on behalf of your benefit plan. "
    // },
    // {
    //   "code": "N26",
    //   "descr": "Missing itemized bill/statement. "
    // },
    // {
    //   "code": "N27",
    //   "descr": "Missing/incomplete/invalid treatment number. "
    // },
    // {
    //   "code": "N28",
    //   "descr": "Consent form requirements not fulfilled. "
    // },
    // {
    //   "code": "N29",
    //   "descr": "Missing documentation/orders/notes/summary/report/chart. "
    // },
    // {
    //   "code": "N30",
    //   "descr": "Patient ineligible for this service. "
    // },
    // {
    //   "code": "N31",
    //   "descr": "Missing/incomplete/invalid prescribing provider identifier. "
    // },
    // {
    //   "code": "N32",
    //   "descr": "Claim must be submitted by the provider who rendered the service. "
    // },
    // {
    //   "code": "N33",
    //   "descr": "No record of health check prior to initiation of treatment. "
    // },
    // {
    //   "code": "N34",
    //   "descr": "Incorrect claim form/format for this service. "
    // },
    // {
    //   "code": "N35",
    //   "descr": "Program integrity/utilization review decision. "
    // },
    // {
    //   "code": "N36",
    //   "descr": "Claim must meet primary payer's processing requirements before we can consider payment. "
    // },
    // {
    //   "code": "N37",
    //   "descr": "Missing/incomplete/invalid tooth number/letter. "
    // },
    // {
    //   "code": "N38",
    //   "descr": "Missing/incomplete/invalid place of service. "
    // },
    // {
    //   "code": "N39",
    //   "descr": "Procedure code is not compatible with tooth number/letter. "
    // },
    // {
    //   "code": "N40",
    //   "descr": "Missing radiology film(s)/image(s). "
    // },
    // {
    //   "code": "N41",
    //   "descr": "Authorization request denied. "
    // },
    // {
    //   "code": "N42",
    //   "descr": "Missing mental health assessment. "
    // },
    // {
    //   "code": "N43",
    //   "descr": "Bed hold or leave days exceeded. "
    // },
    // {
    //   "code": "N44",
    //   "descr": "Payer's share of regulatory surcharges, assessments, allowances or health care-related taxes paid directly to the regulatory authority. "
    // },
    // {
    //   "code": "N45",
    //   "descr": "Payment based on authorized amount. "
    // },
    // {
    //   "code": "N46",
    //   "descr": "Missing/incomplete/invalid admission hour. "
    // },
    // {
    //   "code": "N47",
    //   "descr": "Claim conflicts with another inpatient stay. "
    // },
    // {
    //   "code": "N48",
    //   "descr": "Claim information does not agree with information received from other insurance carrier. "
    // },
    // {
    //   "code": "N49",
    //   "descr": "Court ordered coverage information needs validation. "
    // },
    // {
    //   "code": "N50",
    //   "descr": "Missing/incomplete/invalid discharge information. "
    // },
    // {
    //   "code": "N51",
    //   "descr": "Electronic interchange agreement not on file for provider/submitter. "
    // },
    // {
    //   "code": "N52",
    //   "descr": "Patient not enrolled in the billing provider's managed care plan on the date of service. "
    // },
    // {
    //   "code": "N53",
    //   "descr": "Missing/incomplete/invalid point of pick-up address. "
    // },
    // {
    //   "code": "N54",
    //   "descr": "Claim information is inconsistent with pre-certified/authorized services. "
    // },
    // {
    //   "code": "N55",
    //   "descr": "Procedures for billing with group/referring/performing providers were not followed. "
    // },
    // {
    //   "code": "N56",
    //   "descr": "Procedure code billed is not correct/valid for the services billed or the date of service billed. "
    // },
    // {
    //   "code": "N57",
    //   "descr": "Missing/incomplete/invalid prescribing date. "
    // },
    // {
    //   "code": "N58",
    //   "descr": "Missing/incomplete/invalid patient liability amount. "
    // },
    // {
    //   "code": "N59",
    //   "descr": "Alert: Please refer to your provider manual for additional program and provider information. "
    // },
    // {
    //   "code": "N60",
    //   "descr": "A valid NDC is required for payment of drug claims effective October 02. "
    // },
    // {
    //   "code": "N61",
    //   "descr": "Rebill services on separate claims. "
    // },
    // {
    //   "code": "N62",
    //   "descr": "Dates of service span multiple rate periods. Resubmit separate claims. "
    // },
    // {
    //   "code": "N63",
    //   "descr": "Rebill services on separate claim lines. "
    // },
    // {
    //   "code": "N64",
    //   "descr": "The 'from' and 'to' dates must be different."
    // },
    // {
    //   "code": "N65",
    //   "descr": "Procedure code or procedure rate count cannot be determined, or was not on file, for the date of service/provider. "
    // },
    // {
    //   "code": "N66",
    //   "descr": "Missing/incomplete/invalid documentation. "
    // },
    // {
    //   "code": "N67",
    //   "descr": "Professional provider services not paid separately.  Included in facility payment under a demonstration project.  Apply to that facility for payment, or resubmit your claim if: the facility notifies you the patient was excluded from this demonstration; or if you furnished these services in another location on the date of the patient's admission or discharge from a demonstration hospital. If services were furnished in a facility not involved in the demonstration on the same date the patient was discharged from or admitted to a demonstration facility, you must report the provider ID number for the non-demonstration facility on the new claim. "
    // },
    // {
    //   "code": "N68",
    //   "descr": "Prior payment being cancelled as we were subsequently notified this patient was covered by a demonstration project in this site of service.  Professional services were included in the payment made to the facility. You must contact the facility for your payment.  Prior payment made to you by the patient or another insurer for this claim must be refunded to the payer within 30 days. "
    // },
    // {
    //   "code": "N69",
    //   "descr": "Alert: PPS (Prospective Payment System) code changed by claims processing system.  "
    // },
    // {
    //   "code": "N70",
    //   "descr": "Consolidated billing and payment applies. "
    // },
    // {
    //   "code": "N71",
    //   "descr": "Your unassigned claim for a drug or biological, clinical diagnostic laboratory services or ambulance service was processed as an assigned claim. You are required by law to accept assignment for these types of claims. "
    // },
    // {
    //   "code": "N72",
    //   "descr": "PPS (Prospective Payment System)  code changed by medical reviewers.  Not supported by clinical records.  "
    // },
    // {
    //   "code": "N73",
    //   "descr": "A Skilled Nursing Facility is responsible for payment of outside providers who furnish these services/supplies under arrangement to its residents. "
    // },
    // {
    //   "code": "N74",
    //   "descr": "Resubmit with multiple claims, each claim covering services provided in only one calendar month. "
    // },
    // {
    //   "code": "N75",
    //   "descr": "Missing/incomplete/invalid tooth surface information. "
    // },
    // {
    //   "code": "N76",
    //   "descr": "Missing/incomplete/invalid number of riders. "
    // },
    // {
    //   "code": "N77",
    //   "descr": "Missing/incomplete/invalid designated provider number. "
    // },
    // {
    //   "code": "N78",
    //   "descr": "The necessary components of the child and teen checkup (EPSDT) were not completed.   "
    // },
    // {
    //   "code": "N79",
    //   "descr": "Service billed is not compatible with patient location information. "
    // },
    // {
    //   "code": "N80",
    //   "descr": "Missing/incomplete/invalid prenatal screening information. "
    // },
    // {
    //   "code": "N81",
    //   "descr": "Procedure billed is not compatible with tooth surface code. "
    // },
    // {
    //   "code": "N82",
    //   "descr": "Provider must accept insurance payment as payment in full when a third party payer contract specifies full reimbursement. "
    // },
    // {
    //   "code": "N83",
    //   "descr": "No appeal rights. Adjudicative decision based on the provisions of a demonstration project. "
    // },
    // {
    //   "code": "N84",
    //   "descr": "Alert: Further installment payments are forthcoming. "
    // },
    // {
    //   "code": "N85",
    //   "descr": "Alert: This is the final installment payment. "
    // },
    // {
    //   "code": "N86",
    //   "descr": "A failed trial of pelvic muscle exercise training is required in order for biofeedback training for the treatment of urinary incontinence to be covered. "
    // },
    // {
    //   "code": "N87",
    //   "descr": "Home use of biofeedback therapy is not covered. "
    // },
    // {
    //   "code": "N88",
    //   "descr": "Alert: This payment is being made conditionally.  An HHA episode of care notice has been filed for this patient. When a patient is treated under a HHA episode of care, consolidated billing requires that certain therapy services and supplies, such as this, be included in the HHA's payment.  This payment will need to be recouped from you if we establish that the patient is concurrently receiving treatment under a HHA episode of care. "
    // },
    // {
    //   "code": "N89",
    //   "descr": "Alert: Payment information for this claim has been forwarded to more than one other payer, but format limitations permit only one of the secondary payers to be identified in this remittance advice. "
    // },
    // {
    //   "code": "N90",
    //   "descr": "Covered only when performed by the attending physician. "
    // },
    // {
    //   "code": "N91",
    //   "descr": "Services not included in the appeal review. "
    // },
    // {
    //   "code": "N92",
    //   "descr": "This facility is not certified for digital mammography. "
    // },
    // {
    //   "code": "N93",
    //   "descr": "A separate claim must be submitted for each place of service. Services furnished at multiple sites may not be billed in the same claim. "
    // },
    // {
    //   "code": "N94",
    //   "descr": "Claim/Service denied because a more specific taxonomy code is required for adjudication. "
    // },
    // {
    //   "code": "N95",
    //   "descr": "This provider type/provider specialty may not bill this service. "
    // },
    // {
    //   "code": "N96",
    //   "descr": "Patient must be refractory to conventional therapy (documented behavioral, pharmacologic and/or surgical corrective therapy) and be an appropriate surgical candidate such that implantation with anesthesia can occur. "
    // },
    // {
    //   "code": "N97",
    //   "descr": "Patients with stress incontinence, urinary obstruction, and specific neurologic diseases (e.g., diabetes with peripheral nerve involvement) which are associated with secondary manifestations of the above three indications are excluded. "
    // },
    // {
    //   "code": "N98",
    //   "descr": "Patient must have had a successful test stimulation in order to support subsequent implantation. Before a patient is eligible for permanent implantation, he/she must demonstrate a 50 percent or greater improvement through test stimulation. Improvement is measured through voiding diaries. "
    // },
    // {
    //   "code": "N99",
    //   "descr": "Patient must be able to demonstrate adequate ability to record voiding diary data such that clinical results of the implant procedure can be properly evaluated. "
    // },
    // {
    //   "code": "N100",
    //   "descr": "PPS (Prospect Payment System) code corrected during adjudication. "
    // },
    // {
    //   "code": "N101",
    //   "descr": "Additional information is needed in order to process this claim. Please resubmit the claim with the identification number of the provider where this service took place. The Medicare number of the site of service provider should be preceded with the letters 'HSP' and entered into item #32 on the claim form. You may bill only one site of service provider number per claim."
    // },
    // {
    //   "code": "N102",
    //   "descr": "This claim has been denied without reviewing the medical/dental record because the requested records were not received or were not received timely. "
    // },
    // {
    //   "code": "N103",
    //   "descr": "Records indicate this patient was a prisoner or in custody of a Federal, State, or local authority when the service was rendered. This  payer does not cover items and services furnished to an individual while he or she is in custody under a penal statute or rule, unless under State or local law, the individual is personally liable for the cost of his or her health care while in custody and the State or local government pursues the collection of such debt in the same way and with the same vigor as the collection of its other debts. The provider can collect from the Federal/State/ Local Authority as appropriate. "
    // },
    // {
    //   "code": "N104",
    //   "descr": "This claim/service is not payable under our claims jurisdiction area. You can identify the correct Medicare contractor to process this claim/service through the CMS website at www.cms.gov. "
    // },
    // {
    //   "code": "N105",
    //   "descr": "This is a misdirected claim/service for an RRB beneficiary. Submit paper claims to the RRB carrier: Palmetto GBA, P.O. Box 10066, Augusta, GA 30999. Call 888-355-9165 for RRB EDI information for electronic claims processing. "
    // },
    // {
    //   "code": "N106",
    //   "descr": "Payment for services furnished to Skilled Nursing Facility (SNF) inpatients (except for excluded services) can only be made to the SNF. You must request payment from the SNF rather than the patient for this service. "
    // },
    // {
    //   "code": "N107",
    //   "descr": "Services furnished to Skilled Nursing Facility (SNF) inpatients must be billed on the inpatient claim. They cannot be billed separately as outpatient services. "
    // },
    // {
    //   "code": "N108",
    //   "descr": "Missing/incomplete/invalid upgrade information. "
    // },
    // {
    //   "code": "N109",
    //   "descr": "Alert: This claim/service was chosen for complex review. "
    // },
    // {
    //   "code": "N110",
    //   "descr": "This facility is not certified for film mammography. "
    // },
    // {
    //   "code": "N111",
    //   "descr": "No appeal right except duplicate claim/service issue. This service was included in a claim that has been previously billed and adjudicated. "
    // },
    // {
    //   "code": "N112",
    //   "descr": "This claim is excluded from your electronic remittance advice. "
    // },
    // {
    //   "code": "N113",
    //   "descr": "Only one initial visit is covered per physician, group practice or provider. "
    // },
    // {
    //   "code": "N114",
    //   "descr": "During the transition to the Ambulance Fee Schedule, payment is based on the lesser of a blended amount calculated using a percentage of the reasonable charge/cost and fee schedule amounts, or the submitted charge for the service.  You will be notified yearly what the percentages for the blended payment calculation will be. "
    // },
    // {
    //   "code": "N115",
    //   "descr": "This decision was based on a Local Coverage Determination (LCD).  An LCD provides a guide to assist in determining whether a particular item or service is covered. A copy of this policy is available at www.cms.gov/mcd, or if you do not have web access, you may contact the contractor to request a copy of the LCD. "
    // },
    // {
    //   "code": "N116",
    //   "descr": "Alert: This payment is being made conditionally because the service was provided in the home, and it is possible that the patient is under a home health episode of care. When a patient is treated under a home health episode of care, consolidated billing requires that certain therapy services and supplies, such as this, be included in the home health agency's (HHA's) payment. This payment will need to be recouped from you if we establish that the patient is concurrently receiving treatment under an HHA episode of care. "
    // },
    // {
    //   "code": "N117",
    //   "descr": "This service is paid only once in a patient's lifetime. "
    // },
    // {
    //   "code": "N118",
    //   "descr": "This service is not paid if billed more than once every 28 days. "
    // },
    // {
    //   "code": "N119",
    //   "descr": "This service is not paid if billed once every 28 days, and the patient has spent 5 or more consecutive days in any inpatient or Skilled /nursing Facility (SNF) within those 28 days. "
    // },
    // {
    //   "code": "N120",
    //   "descr": "Payment is subject to home health prospective payment system partial episode payment adjustment. Patient was transferred/discharged/readmitted during payment episode. "
    // },
    // {
    //   "code": "N121",
    //   "descr": "Medicare Part B does not pay for items or services provided by this type of practitioner for beneficiaries in a Medicare Part A covered Skilled Nursing Facility (SNF) stay. "
    // },
    // {
    //   "code": "N122",
    //   "descr": "Add-on code cannot be billed by itself. "
    // },
    // {
    //   "code": "N123",
    //   "descr": "Alert: This is a split service and represents a portion of the units from the originally submitted service. "
    // },
    // {
    //   "code": "N124",
    //   "descr": "Payment has been denied for the/made only for a less extensive service/item because the information furnished does not substantiate the need for the (more extensive) service/item. The patient is liable for the charges for this service/item as you informed the patient in writing before the service/item was furnished that we would not pay for it, and the patient agreed to pay. "
    // },
    // {
    //   "code": "N125",
    //   "descr": "Payment has been (denied for the/made only for a less extensive) service/item because the information furnished does not substantiate the need for the (more extensive) service/item. If you have collected any amount from the patient, you must refund that amount to the patient within 30 days of receiving this notice.    The requirements for a refund are in §1834(a)(18) of the Social Security Act (and in §§1834(j)(4) and 1879(h) by cross-reference to §1834(a)(18)). Section 1834(a)(18)(B) specifies that suppliers which knowingly and willfully fail to make appropriate refunds may be subject to civil money penalties and/or exclusion from the Medicare program. If you have any questions about this notice, please contact this office."
    // },
    // {
    //   "code": "N126",
    //   "descr": "Social Security Records indicate that this individual has been deported. This payer does not cover items and services furnished to individuals who have been deported. "
    // },
    // {
    //   "code": "N127",
    //   "descr": "This is a misdirected claim/service for a United Mine Workers of America (UMWA) beneficiary. Please submit claims to them. "
    // },
    // {
    //   "code": "N128",
    //   "descr": "This amount represents the prior to coverage portion of the allowance. "
    // },
    // {
    //   "code": "N129",
    //   "descr": "Not eligible due to the patient's age. "
    // },
    // {
    //   "code": "N130",
    //   "descr": "Consult plan benefit documents/guidelines for information about restrictions for this service. "
    // },
    // {
    //   "code": "N131",
    //   "descr": "Total payments under multiple contracts cannot exceed the allowance for this service. "
    // },
    // {
    //   "code": "N132",
    //   "descr": "Alert: Payments will cease for services rendered by this US Government debarred or excluded provider after the 30 day grace period as previously notified. "
    // },
    // {
    //   "code": "N133",
    //   "descr": "Alert: Services for predetermination and services requesting payment are being processed separately. "
    // },
    // {
    //   "code": "N134",
    //   "descr": "Alert: This represents your scheduled payment for this service. If treatment has been discontinued, please contact Customer Service. "
    // },
    // {
    //   "code": "N135",
    //   "descr": "Record fees are the patient's responsibility and limited to the specified co-payment. "
    // },
    // {
    //   "code": "N136",
    //   "descr": "Alert: To obtain information on the process to file an appeal in Arizona, call the Department's Consumer Assistance Office at (602) 912-8444 or (800) 325-2548. "
    // },
    // {
    //   "code": "N137",
    //   "descr": "Alert: The provider acting on the Member's behalf, may file an appeal with the Payer. The provider, acting on the Member's behalf, may file a complaint with the State Insurance Regulatory Authority without first filing an appeal, if the coverage decision involves an urgent condition for which care has not been rendered. The address may be obtained from the State Insurance Regulatory Authority. "
    // },
    // {
    //   "code": "N138",
    //   "descr": "Alert: In the event you disagree with the Dental Advisor's opinion and have additional information relative to the case, you may submit radiographs to the Dental Advisor Unit at the subscriber's dental insurance carrier for a second Independent Dental Advisor Review. "
    // },
    // {
    //   "code": "N139",
    //   "descr": "Alert: Under 32 CFR 199.13, a non-participating provider is not an appropriate appealing party. Therefore, if you disagree with the Dental Advisor's opinion, you may appeal the determination if appointed in writing, by the beneficiary, to act as his/her representative. Should you be appointed as a representative, submit a copy of this letter, a signed statement explaining the matter in which you disagree, and any radiographs and relevant information to the subscriber's Dental insurance carrier within 90 days from the date of this letter. "
    // },
    // {
    //   "code": "N140",
    //   "descr": "Alert: You have not been designated as an authorized OCONUS provider therefore are not considered an appropriate appealing party. If the beneficiary has appointed you, in writing, to act as his/her representative and you disagree with the Dental Advisor's opinion, you may appeal by submitting a copy of this letter, a signed statement explaining the matter in which you disagree, and any relevant information to the subscriber's Dental insurance carrier within 90 days from the date of this letter. "
    // },
    // {
    //   "code": "N141",
    //   "descr": "The patient was not residing in a long-term care facility during all or part of the service dates billed. "
    // },
    // {
    //   "code": "N142",
    //   "descr": "The original claim was denied.  Resubmit a new claim, not a replacement claim. "
    // },
    // {
    //   "code": "N143",
    //   "descr": "The patient was not in a hospice program during all or part of the service dates billed. "
    // },
    // {
    //   "code": "N144",
    //   "descr": "The rate changed during the dates of service billed. "
    // },
    // {
    //   "code": "N145",
    //   "descr": "Missing/incomplete/invalid provider identifier for this place of service. "
    // },
    // {
    //   "code": "N146",
    //   "descr": "Missing screening document. "
    // },
    // {
    //   "code": "N147",
    //   "descr": "Long term care case mix or per diem rate cannot be determined because the patient ID number is missing, incomplete, or invalid on the assignment request. "
    // },
    // {
    //   "code": "N148",
    //   "descr": "Missing/incomplete/invalid date of last menstrual period. "
    // },
    // {
    //   "code": "N149",
    //   "descr": "Rebill all applicable services on a single claim. "
    // },
    // {
    //   "code": "N150",
    //   "descr": "Missing/incomplete/invalid model number. "
    // },
    // {
    //   "code": "N151",
    //   "descr": "Telephone contact services will not be paid until the face-to-face contact requirement has been met. "
    // },
    // {
    //   "code": "N152",
    //   "descr": "Missing/incomplete/invalid replacement claim information. "
    // },
    // {
    //   "code": "N153",
    //   "descr": "Missing/incomplete/invalid room and board rate. "
    // },
    // {
    //   "code": "N154",
    //   "descr": "Alert: This payment was delayed for correction of provider's mailing address. "
    // },
    // {
    //   "code": "N155",
    //   "descr": "Alert: Our records do not indicate that other insurance is on file.  Please submit other insurance information for our records. "
    // },
    // {
    //   "code": "N156",
    //   "descr": "Alert: The patient is responsible for the difference between the approved treatment and the elective treatment. "
    // },
    // {
    //   "code": "N157",
    //   "descr": "Transportation to/from this destination is not covered. "
    // },
    // {
    //   "code": "N158",
    //   "descr": "Transportation in a vehicle other than an ambulance is not covered. "
    // },
    // {
    //   "code": "N159",
    //   "descr": "Payment denied/reduced because mileage is not covered when the patient is not in the ambulance. "
    // },
    // {
    //   "code": "N160",
    //   "descr": "The patient must choose an option before a payment can be made for this procedure/ equipment/ supply/ service. "
    // },
    // {
    //   "code": "N161",
    //   "descr": "This drug/service/supply is covered only when the associated service is covered. "
    // },
    // {
    //   "code": "N162",
    //   "descr": "Alert: Although your claim was paid, you have billed for a test/specialty not included in your Laboratory Certification.  Your failure to correct the laboratory certification information will result in a denial of payment in the near future. "
    // },
    // {
    //   "code": "N163",
    //   "descr": "Medical record does not support code billed per the code definition. "
    // },
    // {
    //   "code": "N164",
    //   "descr": "Transportation to/from this destination is not covered. "
    // },
    // {
    //   "code": "N165",
    //   "descr": "Transportation in a vehicle other than an ambulance is not covered. "
    // },
    // {
    //   "code": "N166",
    //   "descr": "Payment denied/reduced because mileage is not covered when the patient is not in the ambulance. "
    // },
    // {
    //   "code": "N167",
    //   "descr": "Charges exceed the post-transplant coverage limit. "
    // },
    // {
    //   "code": "N168",
    //   "descr": "The patient must choose an option before a payment can be made for this procedure/ equipment/ supply/ service. "
    // },
    // {
    //   "code": "N169",
    //   "descr": "This drug/service/supply is covered only when the associated service is covered. "
    // },
    // {
    //   "code": "N170",
    //   "descr": "A new/revised/renewed certificate of medical necessity is needed. "
    // },
    // {
    //   "code": "N171",
    //   "descr": "Payment for repair or replacement is not covered or has exceeded the purchase price. "
    // },
    // {
    //   "code": "N172",
    //   "descr": "The patient is not liable for the denied/adjusted charge(s) for receiving any updated service/item. "
    // },
    // {
    //   "code": "N173",
    //   "descr": "No qualifying hospital stay dates were provided for this episode of care. "
    // },
    // {
    //   "code": "N174",
    //   "descr": "This is not a covered service/procedure/ equipment/bed, however patient liability is limited to amounts shown in the adjustments under group 'PR'. "
    // },
    // {
    //   "code": "N175",
    //   "descr": "Missing review organization approval. "
    // },
    // {
    //   "code": "N176",
    //   "descr": "Services provided aboard a ship are covered only when the ship is of United States registry and is in United States waters. In addition, a doctor licensed to practice in the United States must provide the service. "
    // },
    // {
    //   "code": "N177",
    //   "descr": "Alert: We did not send this claim to patient's other insurer. They have indicated no additional payment can be made. "
    // },
    // {
    //   "code": "N178",
    //   "descr": "Missing pre-operative images/visual field results. "
    // },
    // {
    //   "code": "N179",
    //   "descr": "Additional information has been requested from the member.  The charges will be reconsidered upon receipt of that information. "
    // },
    // {
    //   "code": "N180",
    //   "descr": "This item or service does not meet the criteria for the category under which it was billed. "
    // },
    // {
    //   "code": "N181",
    //   "descr": "Additional information is required from another provider involved in this service. "
    // },
    // {
    //   "code": "N182",
    //   "descr": "This claim/service must be billed according to the schedule for this plan. "
    // },
    // {
    //   "code": "N183",
    //   "descr": "Alert: This is a predetermination advisory message, when this service is submitted for payment additional documentation as specified in plan documents will be required to process benefits. "
    // },
    // {
    //   "code": "N184",
    //   "descr": "Rebill technical and professional components separately. "
    // },
    // {
    //   "code": "N185",
    //   "descr": "Alert: Do not resubmit this claim/service. "
    // },
    // {
    //   "code": "N186",
    //   "descr": "Non-Availability Statement (NAS) required for this service. Contact the nearest Military Treatment Facility (MTF) for assistance. "
    // },
    // {
    //   "code": "N187",
    //   "descr": "Alert: You may request a review in writing within the required time limits following receipt of this notice by following the instructions included in your contract or plan benefit documents. "
    // },
    // {
    //   "code": "N188",
    //   "descr": "The approved level of care does not match the procedure code submitted. "
    // },
    // {
    //   "code": "N189",
    //   "descr": "Alert: This service has been paid as a one-time exception to the plan's benefit restrictions. "
    // },
    // {
    //   "code": "N190",
    //   "descr": "Missing contract indicator. "
    // },
    // {
    //   "code": "N191",
    //   "descr": "The provider must update insurance information directly with payer. "
    // },
    // {
    //   "code": "N192",
    //   "descr": "Patient is a Medicaid/Qualified Medicare Beneficiary. "
    // },
    // {
    //   "code": "N193",
    //   "descr": "Alert: Specific federal/state/local program may cover this service through another payer. "
    // },
    // {
    //   "code": "N194",
    //   "descr": "Technical component not paid if provider does not own the equipment used. "
    // },
    // {
    //   "code": "N195",
    //   "descr": "The technical component must be billed separately. "
    // },
    // {
    //   "code": "N196",
    //   "descr": "Alert: Patient eligible to apply for other coverage which may be primary. "
    // },
    // {
    //   "code": "N197",
    //   "descr": "The subscriber must update insurance information directly with payer. "
    // },
    // {
    //   "code": "N198",
    //   "descr": "Rendering provider must be affiliated with the pay-to provider. "
    // },
    // {
    //   "code": "N199",
    //   "descr": "Additional payment/recoupment approved based on payer-initiated review/audit. "
    // },
    // {
    //   "code": "N200",
    //   "descr": "The professional component must be billed separately. "
    // },
    // {
    //   "code": "N201",
    //   "descr": "A mental health facility is responsible for payment of outside providers who furnish these services/supplies to residents. "
    // },
    // {
    //   "code": "N202",
    //   "descr": "Alert: Additional information/explanation will be sent separately. "
    // },
    // {
    //   "code": "N203",
    //   "descr": "Missing/incomplete/invalid anesthesia time/units. "
    // },
    // {
    //   "code": "N204",
    //   "descr": "Services under review for possible pre-existing condition. Send medical records for prior 12 months "
    // },
    // {
    //   "code": "N205",
    //   "descr": "Information provided was illegible. "
    // },
    // {
    //   "code": "N206",
    //   "descr": "The supporting documentation does not match the information sent on the claim.  "
    // },
    // {
    //   "code": "N207",
    //   "descr": "Missing/incomplete/invalid weight. "
    // },
    // {
    //   "code": "N208",
    //   "descr": "Missing/incomplete/invalid DRG code. "
    // },
    // {
    //   "code": "N209",
    //   "descr": "Missing/incomplete/invalid taxpayer identification number (TIN). "
    // },
    // {
    //   "code": "N210",
    //   "descr": "Alert: You may appeal this decision. "
    // },
    // {
    //   "code": "N211",
    //   "descr": "Alert: You may not appeal this decision. "
    // },
    // {
    //   "code": "N212",
    //   "descr": "Charges processed under a Point of Service benefit . "
    // },
    // {
    //   "code": "N213",
    //   "descr": "Missing/incomplete/invalid facility/discrete unit DRG/DRG exempt status information. "
    // },
    // {
    //   "code": "N214",
    //   "descr": "Missing/incomplete/invalid history of the related initial surgical procedure(s). "
    // },
    // {
    //   "code": "N215",
    //   "descr": "Alert: A payer providing supplemental or secondary coverage shall not require a claims determination for this service from a primary payer as a condition of making its own claims determination. "
    // },
    // {
    //   "code": "N216",
    //   "descr": "We do not offer coverage for this type of service or the patient is not enrolled in this portion of our benefit package. "
    // },
    // {
    //   "code": "N217",
    //   "descr": "We pay only one site of service per provider per claim. "
    // },
    // {
    //   "code": "N218",
    //   "descr": "You must furnish and service this item for as long as the patient continues to need it.  We can pay for maintenance and/or servicing for the time period specified in the contract or coverage manual. "
    // },
    // {
    //   "code": "N219",
    //   "descr": "Payment based on previous payer's allowed amount. "
    // },
    // {
    //   "code": "N220",
    //   "descr": "Alert: See the payer's web site or contact the payer's Customer Service department to obtain forms and instructions for filing a provider dispute. "
    // },
    // {
    //   "code": "N221",
    //   "descr": "Missing Admitting History and Physical report. "
    // },
    // {
    //   "code": "N222",
    //   "descr": "Incomplete/invalid Admitting History and Physical report. "
    // },
    // {
    //   "code": "N223",
    //   "descr": "Missing documentation of benefit to the patient during initial treatment period. "
    // },
    // {
    //   "code": "N224",
    //   "descr": "Incomplete/invalid documentation of benefit to the patient during initial treatment period. "
    // },
    // {
    //   "code": "N225",
    //   "descr": "Incomplete/invalid documentation/orders/notes/summary/report/chart. "
    // },
    // {
    //   "code": "N226",
    //   "descr": "Incomplete/invalid American Diabetes Association Certificate of Recognition. "
    // },
    // {
    //   "code": "N227",
    //   "descr": "Incomplete/invalid Certificate of Medical Necessity. "
    // },
    // {
    //   "code": "N228",
    //   "descr": "Incomplete/invalid consent form. "
    // },
    // {
    //   "code": "N229",
    //   "descr": "Incomplete/invalid contract indicator. "
    // },
    // {
    //   "code": "N230",
    //   "descr": "Incomplete/invalid indication of whether the patient owns the equipment that requires the part or supply. "
    // },
    // {
    //   "code": "N231",
    //   "descr": "Incomplete/invalid invoice or statement certifying the actual cost of the lens, less discounts, and/or the type of intraocular lens used. "
    // },
    // {
    //   "code": "N232",
    //   "descr": "Incomplete/invalid itemized bill/statement. "
    // },
    // {
    //   "code": "N233",
    //   "descr": "Incomplete/invalid operative note/report. "
    // },
    // {
    //   "code": "N234",
    //   "descr": "Incomplete/invalid oxygen certification/re-certification. "
    // },
    // {
    //   "code": "N235",
    //   "descr": "Incomplete/invalid pacemaker registration form. "
    // },
    // {
    //   "code": "N236",
    //   "descr": "Incomplete/invalid pathology report. "
    // },
    // {
    //   "code": "N237",
    //   "descr": "Incomplete/invalid patient medical record for this service. "
    // },
    // {
    //   "code": "N238",
    //   "descr": "Incomplete/invalid physician certified plan of care. "
    // },
    // {
    //   "code": "N239",
    //   "descr": "Incomplete/invalid physician financial relationship form. "
    // },
    // {
    //   "code": "N240",
    //   "descr": "Incomplete/invalid radiology report. "
    // },
    // {
    //   "code": "N241",
    //   "descr": "Incomplete/invalid review organization approval. "
    // },
    // {
    //   "code": "N242",
    //   "descr": "Incomplete/invalid radiology film(s)/image(s). "
    // },
    // {
    //   "code": "N243",
    //   "descr": "Incomplete/invalid/not approved screening document. "
    // },
    // {
    //   "code": "N244",
    //   "descr": "Incomplete/Invalid pre-operative  images/visual field results. "
    // },
    // {
    //   "code": "N245",
    //   "descr": "Incomplete/invalid plan information for other insurance . "
    // },
    // {
    //   "code": "N246",
    //   "descr": "State regulated patient payment limitations apply to this service. "
    // },
    // {
    //   "code": "N247",
    //   "descr": "Missing/incomplete/invalid assistant surgeon taxonomy. "
    // },
    // {
    //   "code": "N248",
    //   "descr": "Missing/incomplete/invalid assistant surgeon name. "
    // },
    // {
    //   "code": "N249",
    //   "descr": "Missing/incomplete/invalid assistant surgeon primary identifier. "
    // },
    // {
    //   "code": "N250",
    //   "descr": "Missing/incomplete/invalid assistant surgeon secondary identifier. "
    // },
    // {
    //   "code": "N251",
    //   "descr": "Missing/incomplete/invalid attending provider taxonomy. "
    // },
    // {
    //   "code": "N252",
    //   "descr": "Missing/incomplete/invalid attending provider name. "
    // },
    // {
    //   "code": "N253",
    //   "descr": "Missing/incomplete/invalid attending provider primary identifier. "
    // },
    // {
    //   "code": "N254",
    //   "descr": "Missing/incomplete/invalid attending provider secondary identifier. "
    // },
    // {
    //   "code": "N255",
    //   "descr": "Missing/incomplete/invalid billing provider taxonomy. "
    // },
    // {
    //   "code": "N256",
    //   "descr": "Missing/incomplete/invalid billing provider/supplier name. "
    // },
    // {
    //   "code": "N257",
    //   "descr": "Missing/incomplete/invalid billing provider/supplier primary identifier. "
    // },
    // {
    //   "code": "N258",
    //   "descr": "Missing/incomplete/invalid billing provider/supplier address. "
    // },
    // {
    //   "code": "N259",
    //   "descr": "Missing/incomplete/invalid billing provider/supplier secondary identifier. "
    // },
    // {
    //   "code": "N260",
    //   "descr": "Missing/incomplete/invalid billing provider/supplier contact information. "
    // },
    // {
    //   "code": "N261",
    //   "descr": "Missing/incomplete/invalid operating provider name. "
    // },
    // {
    //   "code": "N262",
    //   "descr": "Missing/incomplete/invalid operating provider primary identifier. "
    // },
    // {
    //   "code": "N263",
    //   "descr": "Missing/incomplete/invalid operating provider secondary identifier. "
    // },
    // {
    //   "code": "N264",
    //   "descr": "Missing/incomplete/invalid ordering provider name. "
    // },
    // {
    //   "code": "N265",
    //   "descr": "Missing/incomplete/invalid ordering provider primary identifier. "
    // },
    // {
    //   "code": "N266",
    //   "descr": "Missing/incomplete/invalid ordering provider address. "
    // },
    // {
    //   "code": "N267",
    //   "descr": "Missing/incomplete/invalid ordering provider secondary identifier. "
    // },
    // {
    //   "code": "N268",
    //   "descr": "Missing/incomplete/invalid ordering provider contact information. "
    // },
    // {
    //   "code": "N269",
    //   "descr": "Missing/incomplete/invalid other provider name. "
    // },
    // {
    //   "code": "N270",
    //   "descr": "Missing/incomplete/invalid other provider primary identifier. "
    // },
    // {
    //   "code": "N271",
    //   "descr": "Missing/incomplete/invalid other provider secondary identifier. "
    // },
    // {
    //   "code": "N272",
    //   "descr": "Missing/incomplete/invalid other payer attending provider identifier. "
    // },
    // {
    //   "code": "N273",
    //   "descr": "Missing/incomplete/invalid other payer operating provider identifier. "
    // },
    // {
    //   "code": "N274",
    //   "descr": "Missing/incomplete/invalid other payer other provider identifier. "
    // },
    // {
    //   "code": "N275",
    //   "descr": "Missing/incomplete/invalid other payer purchased service provider identifier. "
    // },
    // {
    //   "code": "N276",
    //   "descr": "Missing/incomplete/invalid other payer referring provider identifier. "
    // },
    // {
    //   "code": "N277",
    //   "descr": "Missing/incomplete/invalid other payer rendering provider identifier. "
    // },
    // {
    //   "code": "N278",
    //   "descr": "Missing/incomplete/invalid other payer service facility provider identifier. "
    // },
    // {
    //   "code": "N279",
    //   "descr": "Missing/incomplete/invalid pay-to provider name. "
    // },
    // {
    //   "code": "N280",
    //   "descr": "Missing/incomplete/invalid pay-to provider primary identifier. "
    // },
    // {
    //   "code": "N281",
    //   "descr": "Missing/incomplete/invalid pay-to provider address. "
    // },
    // {
    //   "code": "N282",
    //   "descr": "Missing/incomplete/invalid pay-to provider secondary identifier. "
    // },
    // {
    //   "code": "N283",
    //   "descr": "Missing/incomplete/invalid purchased service provider identifier. "
    // },
    // {
    //   "code": "N284",
    //   "descr": "Missing/incomplete/invalid referring provider taxonomy. "
    // },
    // {
    //   "code": "N285",
    //   "descr": "Missing/incomplete/invalid referring provider name. "
    // },
    // {
    //   "code": "N286",
    //   "descr": "Missing/incomplete/invalid referring provider primary identifier. "
    // },
    // {
    //   "code": "N287",
    //   "descr": "Missing/incomplete/invalid referring provider secondary identifier. "
    // },
    // {
    //   "code": "N288",
    //   "descr": "Missing/incomplete/invalid rendering provider taxonomy. "
    // },
    // {
    //   "code": "N289",
    //   "descr": "Missing/incomplete/invalid rendering provider name. "
    // },
    // {
    //   "code": "N290",
    //   "descr": "Missing/incomplete/invalid rendering provider primary identifier. "
    // },
    // {
    //   "code": "N291",
    //   "descr": "Missing/incomplete/invalid rendering provider secondary identifier. "
    // },
    // {
    //   "code": "N292",
    //   "descr": "Missing/incomplete/invalid service facility name. "
    // },
    // {
    //   "code": "N293",
    //   "descr": "Missing/incomplete/invalid service facility primary identifier. "
    // },
    // {
    //   "code": "N294",
    //   "descr": "Missing/incomplete/invalid service facility primary address. "
    // },
    // {
    //   "code": "N295",
    //   "descr": "Missing/incomplete/invalid service facility secondary identifier. "
    // },
    // {
    //   "code": "N296",
    //   "descr": "Missing/incomplete/invalid supervising provider name. "
    // },
    // {
    //   "code": "N297",
    //   "descr": "Missing/incomplete/invalid supervising provider primary identifier. "
    // },
    // {
    //   "code": "N298",
    //   "descr": "Missing/incomplete/invalid supervising provider secondary identifier. "
    // },
    // {
    //   "code": "N299",
    //   "descr": "Missing/incomplete/invalid occurrence date(s). "
    // },
    // {
    //   "code": "N300",
    //   "descr": "Missing/incomplete/invalid occurrence span date(s). "
    // },
    // {
    //   "code": "N301",
    //   "descr": "Missing/incomplete/invalid procedure date(s). "
    // },
    // {
    //   "code": "N302",
    //   "descr": "Missing/incomplete/invalid other procedure date(s). "
    // },
    // {
    //   "code": "N303",
    //   "descr": "Missing/incomplete/invalid principal procedure date. "
    // },
    // {
    //   "code": "N304",
    //   "descr": "Missing/incomplete/invalid dispensed date. "
    // },
    // {
    //   "code": "N305",
    //   "descr": "Missing/incomplete/invalid injury/accident date. "
    // },
    // {
    //   "code": "N306",
    //   "descr": "Missing/incomplete/invalid acute manifestation date. "
    // },
    // {
    //   "code": "N307",
    //   "descr": "Missing/incomplete/invalid adjudication or payment date. "
    // },
    // {
    //   "code": "N308",
    //   "descr": "Missing/incomplete/invalid appliance placement date. "
    // },
    // {
    //   "code": "N309",
    //   "descr": "Missing/incomplete/invalid assessment date. "
    // },
    // {
    //   "code": "N310",
    //   "descr": "Missing/incomplete/invalid assumed or relinquished care date. "
    // },
    // {
    //   "code": "N311",
    //   "descr": "Missing/incomplete/invalid authorized to return to work date. "
    // },
    // {
    //   "code": "N312",
    //   "descr": "Missing/incomplete/invalid begin therapy date. "
    // },
    // {
    //   "code": "N313",
    //   "descr": "Missing/incomplete/invalid certification revision date. "
    // },
    // {
    //   "code": "N314",
    //   "descr": "Missing/incomplete/invalid diagnosis date. "
    // },
    // {
    //   "code": "N315",
    //   "descr": "Missing/incomplete/invalid disability from date. "
    // },
    // {
    //   "code": "N316",
    //   "descr": "Missing/incomplete/invalid disability to date. "
    // },
    // {
    //   "code": "N317",
    //   "descr": "Missing/incomplete/invalid discharge hour. "
    // },
    // {
    //   "code": "N318",
    //   "descr": "Missing/incomplete/invalid discharge or end of care date. "
    // },
    // {
    //   "code": "N319",
    //   "descr": "Missing/incomplete/invalid hearing or vision prescription date. "
    // },
    // {
    //   "code": "N320",
    //   "descr": "Missing/incomplete/invalid Home Health Certification Period. "
    // },
    // {
    //   "code": "N321",
    //   "descr": "Missing/incomplete/invalid last admission period. "
    // },
    // {
    //   "code": "N322",
    //   "descr": "Missing/incomplete/invalid last certification date. "
    // },
    // {
    //   "code": "N323",
    //   "descr": "Missing/incomplete/invalid last contact date. "
    // },
    // {
    //   "code": "N324",
    //   "descr": "Missing/incomplete/invalid last seen/visit date. "
    // },
    // {
    //   "code": "N325",
    //   "descr": "Missing/incomplete/invalid last worked date. "
    // },
    // {
    //   "code": "N326",
    //   "descr": "Missing/incomplete/invalid last x-ray date. "
    // },
    // {
    //   "code": "N327",
    //   "descr": "Missing/incomplete/invalid other insured birth date. "
    // },
    // {
    //   "code": "N328",
    //   "descr": "Missing/incomplete/invalid Oxygen Saturation Test date. "
    // },
    // {
    //   "code": "N329",
    //   "descr": "Missing/incomplete/invalid patient birth date. "
    // },
    // {
    //   "code": "N330",
    //   "descr": "Missing/incomplete/invalid patient death date. "
    // },
    // {
    //   "code": "N331",
    //   "descr": "Missing/incomplete/invalid physician order date. "
    // },
    // {
    //   "code": "N332",
    //   "descr": "Missing/incomplete/invalid prior hospital discharge date. "
    // },
    // {
    //   "code": "N333",
    //   "descr": "Missing/incomplete/invalid prior placement date. "
    // },
    // {
    //   "code": "N334",
    //   "descr": "Missing/incomplete/invalid re-evaluation date. "
    // },
    // {
    //   "code": "N335",
    //   "descr": "Missing/incomplete/invalid referral date. "
    // },
    // {
    //   "code": "N336",
    //   "descr": "Missing/incomplete/invalid replacement date. "
    // },
    // {
    //   "code": "N337",
    //   "descr": "Missing/incomplete/invalid secondary diagnosis date. "
    // },
    // {
    //   "code": "N338",
    //   "descr": "Missing/incomplete/invalid shipped date. "
    // },
    // {
    //   "code": "N339",
    //   "descr": "Missing/incomplete/invalid similar illness or symptom date. "
    // },
    // {
    //   "code": "N340",
    //   "descr": "Missing/incomplete/invalid subscriber birth date. "
    // },
    // {
    //   "code": "N341",
    //   "descr": "Missing/incomplete/invalid surgery date. "
    // },
    // {
    //   "code": "N342",
    //   "descr": "Missing/incomplete/invalid test performed date. "
    // },
    // {
    //   "code": "N343",
    //   "descr": "Missing/incomplete/invalid Transcutaneous Electrical Nerve Stimulator (TENS) trial start date. "
    // },
    // {
    //   "code": "N344",
    //   "descr": "Missing/incomplete/invalid Transcutaneous Electrical Nerve Stimulator (TENS) trial end date. "
    // },
    // {
    //   "code": "N345",
    //   "descr": "Date range not valid with units submitted.  "
    // },
    // {
    //   "code": "N346",
    //   "descr": "Missing/incomplete/invalid oral cavity designation code. "
    // },
    // {
    //   "code": "N347",
    //   "descr": "Your claim for a referred or purchased service cannot be paid because payment has already been made for this same service to another provider by a payment contractor representing the payer.  "
    // },
    // {
    //   "code": "N348",
    //   "descr": "You chose that this service/supply/drug would be rendered/supplied and billed by a different practitioner/supplier. "
    // },
    // {
    //   "code": "N349",
    //   "descr": "The administration method and drug must be reported to adjudicate this service.  "
    // },
    // {
    //   "code": "N350",
    //   "descr": "Missing/incomplete/invalid description of service for a Not Otherwise Classified (NOC) code or for an Unlisted/By Report procedure. "
    // },
    // {
    //   "code": "N351",
    //   "descr": "Service date outside of the approved treatment plan service dates. "
    // },
    // {
    //   "code": "N352",
    //   "descr": "Alert: There are no scheduled payments for this service. Submit a claim for each patient visit. "
    // },
    // {
    //   "code": "N353",
    //   "descr": "Alert: Benefits have been estimated, when the actual services have been rendered, additional payment will be considered based on the submitted claim. "
    // },
    // {
    //   "code": "N354",
    //   "descr": "Incomplete/invalid invoice. "
    // },
    // {
    //   "code": "N355",
    //   "descr": "Alert: The law permits exceptions to the refund requirement in two cases: - If you did not know, and could not have reasonably been expected to know, that we would not pay for this service; or - If you notified the patient in writing before providing the service that you believed that we were likely to deny the service, and the patient signed a statement agreeing to pay for the service.    If you come within either exception, or if you believe the carrier was wrong in its determination that we do not pay for this service, you should request appeal of this determination within 30 days of the date of this notice. Your request for review should include any additional information necessary to support your position.    If you request an appeal within 30 days of receiving this notice, you may delay refunding the amount to the patient until you receive the results of the review. If the review decision is favorable to you, you do not need to make any refund. If, however, the review is unfavorable, the law specifies that you must make the refund within 15 days of receiving the unfavorable review decision.    The law also permits you to request an appeal at any time within 120 days of the date you receive this notice. However, an appeal request that is received more than 30 days after the date of this notice, does not permit you to delay making the refund. Regardless of when a review is requested, the patient will be notified that you have requested one, and will receive a copy of the determination.    The patient has received a separate notice of this denial decision. The notice advises that he/she may be entitled to a refund of any amounts paid, if you should have known that we would not pay and did not tell him/her. It also instructs the patient to contact our office if he/she does not hear anything about a refund within 30 days "
    // },
    // {
    //   "code": "N356",
    //   "descr": "Not covered when performed with, or subsequent to, a non-covered service. "
    // },
    // {
    //   "code": "N357",
    //   "descr": "Time frame requirements between this service/procedure/supply and a related service/procedure/supply have not been met. "
    // },
    // {
    //   "code": "N358",
    //   "descr": "Alert: This decision may be reviewed if additional documentation as described in the contract or plan benefit documents is submitted. "
    // },
    // {
    //   "code": "N359",
    //   "descr": "Missing/incomplete/invalid height. "
    // },
    // {
    //   "code": "N360",
    //   "descr": "Alert: Coordination of benefits has not been calculated when estimating benefits for this pre-determination. Submit payment information from the primary payer with the secondary claim. "
    // },
    // {
    //   "code": "N361",
    //   "descr": "Payment adjusted based on multiple diagnostic imaging procedure rules "
    // },
    // {
    //   "code": "N362",
    //   "descr": "The number of Days or Units of Service exceeds our acceptable maximum. "
    // },
    // {
    //   "code": "N363",
    //   "descr": "Alert: in the near future we are implementing new policies/procedures that would affect this determination. "
    // },
    // {
    //   "code": "N364",
    //   "descr": "Alert: According to our agreement, you must waive the deductible and/or coinsurance amounts. "
    // },
    // {
    //   "code": "N365",
    //   "descr": "This procedure code is not payable. It is for reporting/information purposes only. "
    // },
    // {
    //   "code": "N366",
    //   "descr": "Requested information not provided. The claim will be reopened if the information previously requested is submitted within one year after the date of this denial notice. "
    // },
    // {
    //   "code": "N367",
    //   "descr": "Alert: The claim information has been forwarded to a Consumer Spending Account processor for review; for example, flexible spending account or health savings account. "
    // },
    // {
    //   "code": "N368",
    //   "descr": "You must appeal the determination of the previously adjudicated claim. "
    // },
    // {
    //   "code": "N369",
    //   "descr": "Alert: Although this claim has been processed, it is deficient according to state legislation/regulation. "
    // },
    // {
    //   "code": "N370",
    //   "descr": "Billing exceeds the rental months covered/approved by the payer. "
    // },
    // {
    //   "code": "N371",
    //   "descr": "Alert: title of this equipment must be transferred to the patient. "
    // },
    // {
    //   "code": "N372",
    //   "descr": "Only reasonable and necessary maintenance/service charges are covered. "
    // },
    // {
    //   "code": "N373",
    //   "descr": "It has been determined that another payer paid the services as primary when they were not the primary payer. Therefore, we are refunding to the payer that paid as primary on your behalf. "
    // },
    // {
    //   "code": "N374",
    //   "descr": "Primary Medicare Part A insurance has been exhausted and a Part B Remittance Advice is required. "
    // },
    // {
    //   "code": "N375",
    //   "descr": "Missing/incomplete/invalid questionnaire/information required to determine dependent eligibility. "
    // },
    // {
    //   "code": "N376",
    //   "descr": "Subscriber/patient is assigned to active military duty, therefore primary coverage may be TRICARE. "
    // },
    // {
    //   "code": "N377",
    //   "descr": "Payment based on a processed replacement claim. "
    // },
    // {
    //   "code": "N378",
    //   "descr": "Missing/incomplete/invalid prescription quantity. "
    // },
    // {
    //   "code": "N379",
    //   "descr": "Claim level information does not match line level information. "
    // },
    // {
    //   "code": "N380",
    //   "descr": "The original claim  has been processed, submit a corrected claim. "
    // },
    // {
    //   "code": "N381",
    //   "descr": "Alert: Consult our contractual agreement for restrictions/billing/payment information related to these charges. "
    // },
    // {
    //   "code": "N382",
    //   "descr": "Missing/incomplete/invalid patient identifier. "
    // },
    // {
    //   "code": "N383",
    //   "descr": "Not covered when deemed cosmetic. "
    // },
    // {
    //   "code": "N384",
    //   "descr": "Records indicate that the referenced body part/tooth has been removed in a previous procedure.  "
    // },
    // {
    //   "code": "N385",
    //   "descr": "Notification of admission was not timely according to published plan procedures. "
    // },
    // {
    //   "code": "N386",
    //   "descr": "This decision was based on a National Coverage Determination (NCD). An NCD provides a coverage determination as to whether a particular item or service is covered. A copy of this policy is available at www.cms.gov/mcd/search.asp. If you do not have web access, you may contact the contractor to request a copy of the NCD. "
    // },
    // {
    //   "code": "N387",
    //   "descr": "Alert: Submit this claim to the patient's other insurer for potential payment of supplemental benefits. We did not forward the claim information. "
    // },
    // {
    //   "code": "N388",
    //   "descr": "Missing/incomplete/invalid prescription number. "
    // },
    // {
    //   "code": "N389",
    //   "descr": "Duplicate prescription number submitted. "
    // },
    // {
    //   "code": "N390",
    //   "descr": "This service/report cannot be billed separately. "
    // },
    // {
    //   "code": "N391",
    //   "descr": "Missing emergency department records. "
    // },
    // {
    //   "code": "N392",
    //   "descr": "Incomplete/invalid emergency department records. "
    // },
    // {
    //   "code": "N393",
    //   "descr": "Missing progress notes/report. "
    // },
    // {
    //   "code": "N394",
    //   "descr": "Incomplete/invalid progress notes/report. "
    // },
    // {
    //   "code": "N395",
    //   "descr": "Missing laboratory report. "
    // },
    // {
    //   "code": "N396",
    //   "descr": "Incomplete/invalid laboratory report. "
    // },
    // {
    //   "code": "N397",
    //   "descr": "Benefits are not available for incomplete service(s)/undelivered item(s). "
    // },
    // {
    //   "code": "N398",
    //   "descr": "Missing elective consent form. "
    // },
    // {
    //   "code": "N399",
    //   "descr": "Incomplete/invalid elective consent form. "
    // },
    // {
    //   "code": "N400",
    //   "descr": "Alert: Electronically enabled providers should submit claims electronically. "
    // },
    // {
    //   "code": "N401",
    //   "descr": "Missing periodontal charting.  "
    // },
    // {
    //   "code": "N402",
    //   "descr": "Incomplete/invalid periodontal charting. "
    // },
    // {
    //   "code": "N403",
    //   "descr": "Missing facility certification. "
    // },
    // {
    //   "code": "N404",
    //   "descr": "Incomplete/invalid facility certification. "
    // },
    // {
    //   "code": "N405",
    //   "descr": "This service is only covered when the donor's insurer(s) do not provide coverage for the service. "
    // },
    // {
    //   "code": "N406",
    //   "descr": "This service is only covered when the recipient's insurer(s) do not provide coverage for the service. "
    // },
    // {
    //   "code": "N407",
    //   "descr": "You are not an approved submitter for this transmission format. "
    // },
    // {
    //   "code": "N408",
    //   "descr": "This payer does not cover deductibles assessed by a previous payer.  "
    // },
    // {
    //   "code": "N409",
    //   "descr": "This service is related to an accidental injury and is not covered unless provided within a specific time frame from the date of the accident.  "
    // },
    // {
    //   "code": "N410",
    //   "descr": "Not covered unless the prescription changes. "
    // },
    // {
    //   "code": "N411",
    //   "descr": "This service is allowed one time in a 6-month period. "
    // },
    // {
    //   "code": "N412",
    //   "descr": "This service is allowed 2 times in a 12-month period. "
    // },
    // {
    //   "code": "N413",
    //   "descr": "This service is allowed 2 times in a benefit year. "
    // },
    // {
    //   "code": "N414",
    //   "descr": "This service is allowed 4 times in a 12-month period. "
    // },
    // {
    //   "code": "N415",
    //   "descr": "This service is allowed 1 time in an 18-month period. "
    // },
    // {
    //   "code": "N416",
    //   "descr": "This service is allowed 1 time in a 3-year period. "
    // },
    // {
    //   "code": "N417",
    //   "descr": "This service is allowed 1 time in a 5-year period. "
    // },
    // {
    //   "code": "N418",
    //   "descr": "Misrouted claim.  See the payer's claim submission instructions. "
    // },
    // {
    //   "code": "N419",
    //   "descr": "Claim payment was the result of a payer's retroactive adjustment due to a retroactive rate change. "
    // },
    // {
    //   "code": "N420",
    //   "descr": "Claim payment was the result of a payer's retroactive adjustment due to a Coordination of Benefits or Third Party Liability Recovery. "
    // },
    // {
    //   "code": "N421",
    //   "descr": "Claim payment was the result of a payer's retroactive adjustment due to a review organization decision. "
    // },
    // {
    //   "code": "N422",
    //   "descr": "Claim payment was the result of a payer's retroactive adjustment due to a payer's contract incentive program. "
    // },
    // {
    //   "code": "N423",
    //   "descr": "Claim payment was the result of a payer's retroactive adjustment due to a non standard program. "
    // },
    // {
    //   "code": "N424",
    //   "descr": "Patient does not reside in the geographic area required for this type of payment. "
    // },
    // {
    //   "code": "N425",
    //   "descr": "Statutorily excluded service(s). "
    // },
    // {
    //   "code": "N426",
    //   "descr": "No coverage when self-administered. "
    // },
    // {
    //   "code": "N427",
    //   "descr": "Payment for eyeglasses or contact lenses can be made only after cataract surgery. "
    // },
    // {
    //   "code": "N428",
    //   "descr": "Not covered when performed in this place of service. "
    // },
    // {
    //   "code": "N429",
    //   "descr": "Not covered when considered routine. "
    // },
    // {
    //   "code": "N430",
    //   "descr": "Procedure code is inconsistent with the units billed. "
    // },
    // {
    //   "code": "N431",
    //   "descr": "Not covered with this procedure. "
    // },
    // {
    //   "code": "N432",
    //   "descr": "Alert: Adjustment based on a Recovery Audit. "
    // },
    // {
    //   "code": "N433",
    //   "descr": "Resubmit this claim using only your National Provider Identifier (NPI). "
    // },
    // {
    //   "code": "N434",
    //   "descr": "Missing/Incomplete/Invalid Present on Admission indicator. "
    // },
    // {
    //   "code": "N435",
    //   "descr": "Exceeds number/frequency approved /allowed within time period without support documentation. "
    // },
    // {
    //   "code": "N436",
    //   "descr": "The injury claim has not been accepted and a mandatory medical reimbursement has been made. "
    // },
    // {
    //   "code": "N437",
    //   "descr": "Alert: If the injury claim is accepted, these charges will be reconsidered. "
    // },
    // {
    //   "code": "N438",
    //   "descr": "This jurisdiction only accepts paper claims. "
    // },
    // {
    //   "code": "N439",
    //   "descr": "Missing anesthesia physical status report/indicators. "
    // },
    // {
    //   "code": "N440",
    //   "descr": "Incomplete/invalid anesthesia physical status report/indicators. "
    // },
    // {
    //   "code": "N441",
    //   "descr": "This missed/cancelled appointment is not covered. "
    // },
    // {
    //   "code": "N442",
    //   "descr": "Payment based on an alternate fee schedule. "
    // },
    // {
    //   "code": "N443",
    //   "descr": "Missing/incomplete/invalid total time or begin/end time. "
    // },
    // {
    //   "code": "N444",
    //   "descr": "Alert: This facility has not filed the Election for High Cost Outlier form with the Division of Workers' Compensation. "
    // },
    // {
    //   "code": "N445",
    //   "descr": "Missing document for actual cost or paid amount. "
    // },
    // {
    //   "code": "N446",
    //   "descr": "Incomplete/invalid document for actual cost or paid amount. "
    // },
    // {
    //   "code": "N447",
    //   "descr": "Payment is based on a generic equivalent as required documentation was not provided. "
    // },
    // {
    //   "code": "N448",
    //   "descr": "This drug/service/supply is not included in the fee schedule or contracted/legislated fee arrangement. "
    // },
    // {
    //   "code": "N449",
    //   "descr": "Payment based on a comparable drug/service/supply. "
    // },
    // {
    //   "code": "N450",
    //   "descr": "Covered only when performed by the primary treating physician or the designee. "
    // },
    // {
    //   "code": "N451",
    //   "descr": "Missing Admission Summary Report. "
    // },
    // {
    //   "code": "N452",
    //   "descr": "Incomplete/invalid Admission Summary Report. "
    // },
    // {
    //   "code": "N453",
    //   "descr": "Missing Consultation Report. "
    // },
    // {
    //   "code": "N454",
    //   "descr": "Incomplete/invalid Consultation Report. "
    // },
    // {
    //   "code": "N455",
    //   "descr": "Missing Physician Order. "
    // },
    // {
    //   "code": "N456",
    //   "descr": "Incomplete/invalid Physician Order. "
    // },
    // {
    //   "code": "N457",
    //   "descr": "Missing Diagnostic Report. "
    // },
    // {
    //   "code": "N458",
    //   "descr": "Incomplete/invalid Diagnostic Report. "
    // },
    // {
    //   "code": "N459",
    //   "descr": "Missing Discharge Summary. "
    // },
    // {
    //   "code": "N460",
    //   "descr": "Incomplete/invalid Discharge Summary. "
    // },
    // {
    //   "code": "N461",
    //   "descr": "Missing Nursing Notes. "
    // },
    // {
    //   "code": "N462",
    //   "descr": "Incomplete/invalid Nursing Notes. "
    // },
    // {
    //   "code": "N463",
    //   "descr": "Missing support data for claim. "
    // },
    // {
    //   "code": "N464",
    //   "descr": "Incomplete/invalid support data for claim. "
    // },
    // {
    //   "code": "N465",
    //   "descr": "Missing Physical Therapy Notes/Report. "
    // },
    // {
    //   "code": "N466",
    //   "descr": "Incomplete/invalid Physical Therapy Notes/Report. "
    // },
    // {
    //   "code": "N467",
    //   "descr": "Missing Tests and Analysis Report. "
    // },
    // {
    //   "code": "N468",
    //   "descr": "Incomplete/invalid Report of Tests and Analysis Report. "
    // },
    // {
    //   "code": "N469",
    //   "descr": "Alert: Claim/Service(s) subject to appeal process, see section 935 of Medicare Prescription Drug, Improvement, and Modernization Act of 2003 (MMA). "
    // },
    // {
    //   "code": "N470",
    //   "descr": "This payment will complete the mandatory medical reimbursement limit. "
    // },
    // {
    //   "code": "N471",
    //   "descr": "Missing/incomplete/invalid HIPPS Rate Code. "
    // },
    // {
    //   "code": "N472",
    //   "descr": "Payment for this service has been issued to another provider. "
    // },
    // {
    //   "code": "N473",
    //   "descr": "Missing certification. "
    // },
    // {
    //   "code": "N474",
    //   "descr": "Incomplete/invalid certification. "
    // },
    // {
    //   "code": "N475",
    //   "descr": "Missing completed referral form. "
    // },
    // {
    //   "code": "N476",
    //   "descr": "Incomplete/invalid completed referral form. "
    // },
    // {
    //   "code": "N477",
    //   "descr": "Missing Dental Models. "
    // },
    // {
    //   "code": "N478",
    //   "descr": "Incomplete/invalid Dental Models. "
    // },
    // {
    //   "code": "N479",
    //   "descr": "Missing Explanation of Benefits (Coordination of Benefits or Medicare Secondary Payer). "
    // },
    // {
    //   "code": "N480",
    //   "descr": "Incomplete/invalid Explanation of Benefits (Coordination of Benefits or Medicare Secondary Payer). "
    // },
    // {
    //   "code": "N481",
    //   "descr": "Missing Models. "
    // },
    // {
    //   "code": "N482",
    //   "descr": "Incomplete/invalid Models. "
    // },
    // {
    //   "code": "N483",
    //   "descr": "Missing Periodontal Charts. "
    // },
    // {
    //   "code": "N484",
    //   "descr": "Incomplete/invalid Periodontal Charts. "
    // },
    // {
    //   "code": "N485",
    //   "descr": "Missing Physical Therapy Certification. "
    // },
    // {
    //   "code": "N486",
    //   "descr": "Incomplete/invalid Physical Therapy Certification. "
    // },
    // {
    //   "code": "N487",
    //   "descr": "Missing Prosthetics or Orthotics Certification. "
    // },
    // {
    //   "code": "N488",
    //   "descr": "Incomplete/invalid Prosthetics or Orthotics Certification. "
    // },
    // {
    //   "code": "N489",
    //   "descr": "Missing referral form. "
    // },
    // {
    //   "code": "N490",
    //   "descr": "Incomplete/invalid referral form. "
    // },
    // {
    //   "code": "N491",
    //   "descr": "Missing/Incomplete/Invalid Exclusionary Rider Condition. "
    // },
    // {
    //   "code": "N492",
    //   "descr": "Alert: A network provider may bill the member for this service if the member requested the service and agreed in writing, prior to receiving the service, to be financially responsible for the billed charge. "
    // },
    // {
    //   "code": "N493",
    //   "descr": "Missing Doctor First Report of Injury. "
    // },
    // {
    //   "code": "N494",
    //   "descr": "Incomplete/invalid Doctor First Report of Injury. "
    // },
    // {
    //   "code": "N495",
    //   "descr": "Missing Supplemental Medical Report. "
    // },
    // {
    //   "code": "N496",
    //   "descr": "Incomplete/invalid Supplemental Medical Report. "
    // },
    // {
    //   "code": "N497",
    //   "descr": "Missing Medical Permanent Impairment or Disability Report. "
    // },
    // {
    //   "code": "N498",
    //   "descr": "Incomplete/invalid Medical Permanent Impairment or Disability Report. "
    // },
    // {
    //   "code": "N499",
    //   "descr": "Missing Medical Legal Report. "
    // },
    // {
    //   "code": "N500",
    //   "descr": "Incomplete/invalid Medical Legal Report. "
    // },
    // {
    //   "code": "N501",
    //   "descr": "Missing Vocational Report. "
    // },
    // {
    //   "code": "N502",
    //   "descr": "Incomplete/invalid Vocational Report. "
    // },
    // {
    //   "code": "N503",
    //   "descr": "Missing Work Status Report. "
    // },
    // {
    //   "code": "N504",
    //   "descr": "Incomplete/invalid Work Status Report. "
    // },
    // {
    //   "code": "N505",
    //   "descr": "Alert: This response includes only services that could be estimated in real-time. No estimate will be provided for the services that could not be estimated in real-time. "
    // },
    // {
    //   "code": "N506",
    //   "descr": "Alert: This is an estimate of the member's liability based on the information available at the time the estimate was processed. Actual coverage and member liability amounts will be determined when the claim is processed. This is not a pre-authorization or a guarantee of payment. "
    // },
    // {
    //   "code": "N507",
    //   "descr": "Plan distance requirements have not been met. "
    // },
    // {
    //   "code": "N508",
    //   "descr": "Alert: This real-time claim adjudication response represents the member responsibility to the provider for services reported. The member will receive an Explanation of Benefits electronically or in the mail. Contact the insurer if there are any questions. "
    // },
    // {
    //   "code": "N509",
    //   "descr": "Alert: A current inquiry shows the member's Consumer Spending Account contains sufficient funds to cover the member liability for this claim/service.  Actual payment from the Consumer Spending Account will depend on the availability of funds and determination of eligible services at the time of payment processing. "
    // },
    // {
    //   "code": "N510",
    //   "descr": "Alert: A current inquiry shows the member's Consumer Spending Account does not contain sufficient funds to cover the member's liability for this claim/service. Actual payment from the Consumer Spending Account will depend on the availability of funds and determination of eligible services at the time of payment processing. "
    // },
    // {
    //   "code": "N511",
    //   "descr": "Alert: Information on the availability of Consumer Spending Account funds to cover the member liability on this claim/service is not available at this time. "
    // },
    // {
    //   "code": "N512",
    //   "descr": "Alert: This is the initial remit of a non-NCPDP claim originally submitted real-time without change to the adjudication. "
    // },
    // {
    //   "code": "N513",
    //   "descr": "Alert: This is the initial remit of a non-NCPDP claim originally submitted real-time with a change to the adjudication. "
    // },
    // {
    //   "code": "N514",
    //   "descr": "Consult plan benefit documents/guidelines for information about restrictions for this service. "
    // },
    // {
    //   "code": "N515",
    //   "descr": "Alert: Submit this claim to the patient's other insurer for potential payment of supplemental benefits. We did not forward the claim information. (use N387 instead) "
    // },
    // {
    //   "code": "N516",
    //   "descr": "Records indicate a mismatch between the submitted NPI and EIN. "
    // },
    // {
    //   "code": "N517",
    //   "descr": "Resubmit a new claim with the requested information. "
    // },
    // {
    //   "code": "N518",
    //   "descr": "No separate payment for accessories when furnished for use with oxygen equipment. "
    // },
    // {
    //   "code": "N519",
    //   "descr": "Invalid combination of HCPCS modifiers. "
    // },
    // {
    //   "code": "N520",
    //   "descr": "Alert: Payment made from a Consumer Spending Account. "
    // },
    // {
    //   "code": "N521",
    //   "descr": "Mismatch between the submitted provider information and the provider information stored in our system. "
    // },
    // {
    //   "code": "N522",
    //   "descr": "Duplicate of a claim processed, or to be processed, as a crossover claim. "
    // },
    // {
    //   "code": "N523",
    //   "descr": "The limitation on outlier payments defined by this payer for this service period has been met. The outlier payment otherwise applicable to this claim has not been paid. "
    // },
    // {
    //   "code": "N524",
    //   "descr": "Based on policy this payment constitutes payment in full. "
    // },
    // {
    //   "code": "N525",
    //   "descr": "These services are not covered when performed within the global period of another service. "
    // },
    // {
    //   "code": "N526",
    //   "descr": "Not qualified for recovery based on employer size. "
    // },
    // {
    //   "code": "N527",
    //   "descr": "We processed this claim as the primary payer prior to receiving the recovery demand. "
    // },
    // {
    //   "code": "N528",
    //   "descr": "Patient is entitled to benefits for Institutional Services only. "
    // },
    // {
    //   "code": "N529",
    //   "descr": "Patient is entitled to benefits for Professional Services only. "
    // },
    // {
    //   "code": "N530",
    //   "descr": "Not Qualified for Recovery based on enrollment information. "
    // },
    // {
    //   "code": "N531",
    //   "descr": "Not qualified for recovery based on direct payment of premium. "
    // },
    // {
    //   "code": "N532",
    //   "descr": "Not qualified for recovery based on disability and working status. "
    // },
    // {
    //   "code": "N533",
    //   "descr": "Services performed in an Indian Health Services facility under a self-insured tribal Group Health Plan. "
    // },
    // {
    //   "code": "N534",
    //   "descr": "This is an individual policy, the employer does not participate in plan sponsorship. "
    // },
    // {
    //   "code": "N535",
    //   "descr": "Payment is adjusted when procedure is performed in this place of service based on the submitted procedure code and place of service. "
    // },
    // {
    //   "code": "N536",
    //   "descr": "We are not changing the prior payer's determination of patient responsibility, which you may collect, as this service is not covered by us. "
    // },
    // {
    //   "code": "N537",
    //   "descr": "We have examined claims history and no records of the services have been found. "
    // },
    // {
    //   "code": "N538",
    //   "descr": "A facility is responsible for payment to outside providers who furnish these services/supplies/drugs to its patients/residents. "
    // },
    // {
    //   "code": "N539",
    //   "descr": "Alert: We processed appeals/waiver requests on your behalf and that request has been denied. "
    // },
    // {
    //   "code": "N540",
    //   "descr": "Payment adjusted based on the interrupted stay policy. "
    // },
    // {
    //   "code": "N541",
    //   "descr": "Mismatch between the submitted insurance type code and the information stored in our system. "
    // },
    // {
    //   "code": "N542",
    //   "descr": "Missing income verification. "
    // },
    // {
    //   "code": "N543",
    //   "descr": "Incomplete/invalid income verification. "
    // },
    // {
    //   "code": "N544",
    //   "descr": "Alert: Although this was paid, you have billed with a referring/ordering provider that does not match our system record. Unless corrected this will not be paid in the future. "
    // },
    // {
    //   "code": "N545",
    //   "descr": "Payment reduced based on status as an unsuccessful eprescriber per the Electronic Prescribing (eRx) Incentive Program. "
    // },
    // {
    //   "code": "N546",
    //   "descr": "Payment represents a previous reduction based on the Electronic Prescribing (eRx) Incentive Program. "
    // },
    // {
    //   "code": "N547",
    //   "descr": "A refund request (Frequency Type Code 8) was processed previously. "
    // },
    // {
    //   "code": "N548",
    //   "descr": "Alert: Patient's calendar year deductible has been met. "
    // },
    // {
    //   "code": "N549",
    //   "descr": "Alert: Patient's calendar year out-of-pocket maximum has been met. "
    // },
    // {
    //   "code": "N550",
    //   "descr": "Alert: You have not responded to requests to revalidate your provider/supplier enrollment information. Your failure to revalidate your enrollment information will result in a payment hold in the near future. "
    // },
    // {
    //   "code": "N551",
    //   "descr": "Payment adjusted based on the Ambulatory Surgical Center (ASC) Quality Reporting Program. "
    // },
    // {
    //   "code": "N552",
    //   "descr": "Payment adjusted to reverse a previous withhold/bonus amount.  "
    // },
    // {
    //   "code": "N553",
    //   "descr": "Payment adjusted based on a Low Income Subsidy (LIS) retroactive coverage or status change. "
    // },
    // {
    //   "code": "N554",
    //   "descr": "Missing/Incomplete/Invalid Family Planning Indicator. "
    // },
    // {
    //   "code": "N555",
    //   "descr": "Missing medication list.  "
    // },
    // {
    //   "code": "N556",
    //   "descr": "Incomplete/invalid medication list.  "
    // },
    // {
    //   "code": "N557",
    //   "descr": "This claim/service is not payable under our service area. The claim must be filed to the Payer/Plan in whose service area the specimen was collected.  "
    // },
    // {
    //   "code": "N558",
    //   "descr": "This claim/service is not payable under our service area. The claim must be filed to the Payer/Plan in whose service area the equipment was received.  "
    // },
    // {
    //   "code": "N559",
    //   "descr": "This claim/service is not payable under our service area. The claim must be filed to the Payer/Plan in whose service area the Ordering Physician is located.  "
    // },
    // {
    //   "code": "N560",
    //   "descr": "The pilot program requires an interim or final claim within 60 days of the Notice of  Admission. A claim was not received. "
    // },
    // {
    //   "code": "N561",
    //   "descr": "The bundled claim originally submitted for this episode of care includes related readmissions. You may resubmit the original claim to receive a corrected payment based on this readmission. "
    // },
    // {
    //   "code": "N562",
    //   "descr": "The provider number of your incoming claim does not match the provider number on the processed Notice of Admission (NOA) for this bundled payment. "
    // },
    // {
    //   "code": "N563",
    //   "descr": "Alert: Missing required provider/supplier issuance of advance patient notice of non-coverage. The patient is not liable for payment for this service. "
    // },
    // {
    //   "code": "N564",
    //   "descr": "Patient did not meet the inclusion criteria for the demonstration project or pilot program. "
    // },
    // {
    //   "code": "N565",
    //   "descr": "Alert: This non-payable reporting code requires a modifier. Future claims containing this non-payable reporting code must include an appropriate modifier for the claim to be processed. "
    // },
    // {
    //   "code": "N566",
    //   "descr": "Alert: This procedure code requires functional reporting. Future claims containing this procedure code must include an applicable non-payable code and appropriate modifiers for the claim to be processed. "
    // },
    // {
    //   "code": "N567",
    //   "descr": "Not covered when considered preventative. "
    // },
    // {
    //   "code": "N568",
    //   "descr": "Alert: Initial payment based on the Notice of Admission (NOA) under the Bundled Payment Model IV initiative. "
    // },
    // {
    //   "code": "N569",
    //   "descr": "Not covered when performed for the reported diagnosis. "
    // },
    // {
    //   "code": "N570",
    //   "descr": "Missing/incomplete/invalid credentialing data. "
    // },
    // {
    //   "code": "N571",
    //   "descr": "Alert: Payment will be issued quarterly by another payer/contractor. "
    // },
    // {
    //   "code": "N572",
    //   "descr": "This procedure is not payable unless appropriate non-payable reporting codes and associated modifiers are submitted. "
    // },
    // {
    //   "code": "N573",
    //   "descr": "Alert: You have been overpaid and must refund the overpayment. The refund will be requested separately by another payer/contractor. "
    // },
    // {
    //   "code": "N574",
    //   "descr": "Our records indicate the ordering/referring provider is of a type/specialty that cannot order or refer. Please verify that the claim ordering/referring provider information is accurate or contact the ordering/referring provider. "
    // },
    // {
    //   "code": "N575",
    //   "descr": "Mismatch between the submitted ordering/referring provider name and the ordering/referring provider name stored in our records. "
    // },
    // {
    //   "code": "N576",
    //   "descr": "Services not related to the specific incident/claim/accident/loss being reported. "
    // },
    // {
    //   "code": "N577",
    //   "descr": "Personal Injury Protection (PIP) Coverage. "
    // },
    // {
    //   "code": "N578",
    //   "descr": "Coverages do not apply to this loss. "
    // },
    // {
    //   "code": "N579",
    //   "descr": "Medical Payments Coverage (MPC). "
    // },
    // {
    //   "code": "N580",
    //   "descr": "Determination based on the provisions of the insurance policy. "
    // },
    // {
    //   "code": "N581",
    //   "descr": "Investigation of coverage eligibility is pending. "
    // },
    // {
    //   "code": "N582",
    //   "descr": "Benefits suspended pending the patient's cooperation. "
    // },
    // {
    //   "code": "N583",
    //   "descr": "Patient was not an occupant of our insured vehicle and therefore, is not an eligible injured person. "
    // },
    // {
    //   "code": "N584",
    //   "descr": "Not covered based on the insured's noncompliance with policy or statutory conditions. "
    // },
    // {
    //   "code": "N585",
    //   "descr": "Benefits are no longer available based on a final injury settlement. "
    // },
    // {
    //   "code": "N586",
    //   "descr": "The injured party does not qualify for benefits. "
    // },
    // {
    //   "code": "N587",
    //   "descr": "Policy benefits have been exhausted. "
    // },
    // {
    //   "code": "N588",
    //   "descr": "The patient has instructed that medical claims/bills are not to be paid. "
    // },
    // {
    //   "code": "N589",
    //   "descr": "Coverage is excluded to any person injured as a result of operating a motor vehicle while in an intoxicated condition or while the ability to operate such a vehicle is impaired by the use of a drug. "
    // },
    // {
    //   "code": "N590",
    //   "descr": "Missing independent medical exam detailing the cause of injuries sustained and medical necessity of services rendered. "
    // },
    // {
    //   "code": "N591",
    //   "descr": "Payment based on an Independent Medical Examination (IME) or Utilization Review (UR). "
    // },
    // {
    //   "code": "N592",
    //   "descr": "Adjusted because this is not the initial prescription or exceeds the amount allowed for the initial prescription. "
    // },
    // {
    //   "code": "N593",
    //   "descr": "Not covered based on failure to attend  a scheduled Independent Medical Exam (IME). "
    // },
    // {
    //   "code": "N594",
    //   "descr": "Records reflect the injured party did not complete an Application for Benefits for this loss. "
    // },
    // {
    //   "code": "N595",
    //   "descr": "Records reflect the injured party did not complete an Assignment of Benefits for this loss. "
    // },
    // {
    //   "code": "N596",
    //   "descr": "Records reflect the injured party did not complete a Medical Authorization for this loss. "
    // },
    // {
    //   "code": "N597",
    //   "descr": "Adjusted based on a medical/dental provider's apportionment of care between related injuries and other unrelated medical/dental conditions/injuries. "
    // },
    // {
    //   "code": "N598",
    //   "descr": "Health care policy coverage is primary. "
    // },
    // {
    //   "code": "N599",
    //   "descr": "Our payment for this service is based upon a reasonable amount pursuant to both the terms and conditions of the policy of insurance under which the subject claim is being made as well as the Florida No-Fault Statute, which permits, when determining a reasonable charge for a service, an insurer to consider usual and customary charges and payments accepted by the provider, reimbursement levels in the community and various federal and state fee schedules applicable to automobile and other insurance coverages, and other information relevant to the reasonableness of the reimbursement for the service. The payment for this service is based upon 200% of the Participating Level of Medicare Part B fee schedule for the locale in which the services were rendered."
    // },
    // {
    //   "code": "N600",
    //   "descr": "Adjusted based on the applicable fee schedule for the region in which the service was rendered. "
    // },
    // {
    //   "code": "N601",
    //   "descr": "In accordance with Hawaii Administrative Rules, Title 16, Chapter 23 Motor Vehicle Insurance Law payment is recommended based on Medicare Resource Based Relative Value Scale System applicable to Hawaii. "
    // },
    // {
    //   "code": "N602",
    //   "descr": "Adjusted based on the Redbook maximum allowance. "
    // },
    // {
    //   "code": "N603",
    //   "descr": "This fee is calculated according to the New Jersey medical fee schedules for Automobile Personal Injury Protection and Motor Bus Medical Expense Insurance Coverage. "
    // },
    // {
    //   "code": "N604",
    //   "descr": "In accordance with New York No-Fault Law, Regulation 68, this base fee was calculated according to the New York Workers' Compensation Board Schedule of Medical Fees, pursuant to Regulation 83 and / or Appendix 17-C of 11 NYCRR. "
    // },
    // {
    //   "code": "N605",
    //   "descr": "This fee was calculated based upon New York All Patients Refined Diagnosis Related Groups (APR-DRG), pursuant to Regulation 68. "
    // },
    // {
    //   "code": "N606",
    //   "descr": "The Oregon allowed amount for this procedure is based upon the Workers Compensation Fee Schedule (OAR 436-009).  The allowed amount has been calculated in accordance with Section 4 of ORS 742.524. "
    // },
    // {
    //   "code": "N607",
    //   "descr": "Service provided for non-compensable condition(s). "
    // },
    // {
    //   "code": "N608",
    //   "descr": "The fee schedule amount allowed is calculated at 110% of the Medicare Fee Schedule for this region, specialty and type of service.  This fee is calculated in compliance with Act 6."
    // },
    // {
    //   "code": "N609",
    //   "descr": "80% of the provider's billed amount is being recommended for payment according to Act 6."
    // },
    // {
    //   "code": "N610",
    //   "descr": "Alert: Payment based on an appropriate level of care. "
    // },
    // {
    //   "code": "N611",
    //   "descr": "Claim in litigation.  Contact insurer for more information. "
    // },
    // {
    //   "code": "N612",
    //   "descr": "Medical provider not authorized/certified to provide treatment to  injured workers in this jurisdiction. "
    // },
    // {
    //   "code": "N613",
    //   "descr": "Alert: Although this was paid, you have billed with an ordering provider that needs to update their enrollment record. Please verify that the ordering provider information you submitted on the claim is accurate and if it is, contact the ordering provider instructing them to update their enrollment record. Unless corrected, a claim with this ordering provider will not be paid in the future. "
    // },
    // {
    //   "code": "N614",
    //   "descr": "Alert: Additional information is included in the 835 Healthcare Policy Identification Segment (loop 2110 Service Payment Information). "
    // },
    // {
    //   "code": "N615",
    //   "descr": "Alert: This enrollee receiving advance payments of the premium tax credit is in the grace period of three consecutive months for non-payment of premium. Under 45 CFR 156.270, a Qualified Health Plan issuer must pay all appropriate claims for services rendered to the enrollee during the first month of the grace period and may pend claims for services rendered to the enrollee in the second and third months of the grace period. "
    // },
    // {
    //   "code": "N616",
    //   "descr": "Alert: This enrollee is in the first month of the advance premium tax credit grace period. "
    // },
    // {
    //   "code": "N617",
    //   "descr": "This enrollee is in the second or third month of the advance premium tax credit grace period. "
    // },
    // {
    //   "code": "N618",
    //   "descr": "Alert: This claim will automatically be reprocessed if the enrollee pays their premiums. "
    // },
    // {
    //   "code": "N619",
    //   "descr": "Coverage terminated for non-payment of premium. "
    // },
    // {
    //   "code": "N620",
    //   "descr": "Alert: This procedure code is for quality reporting/informational purposes only. "
    // },
    // {
    //   "code": "N621",
    //   "descr": "Charges for Jurisdiction required forms, reports, or chart notes are not payable. "
    // },
    // {
    //   "code": "N622",
    //   "descr": "Not covered based on the date of injury/accident. "
    // },
    // {
    //   "code": "N623",
    //   "descr": "Not covered when deemed unscientific/unproven/outmoded/experimental/excessive/inappropriate. "
    // },
    // {
    //   "code": "N624",
    //   "descr": "The associated Workers' Compensation claim has been withdrawn. "
    // },
    // {
    //   "code": "N625",
    //   "descr": "Missing/Incomplete/Invalid Workers' Compensation Claim Number. "
    // },
    // {
    //   "code": "N626",
    //   "descr": "New or established patient E/M codes are not payable with chiropractic care codes. "
    // },
    // {
    //   "code": "N627",
    //   "descr": "Service not payable per managed care contract. "
    // },
    // {
    //   "code": "N628",
    //   "descr": "Out-patient follow up visits on the same date of service as a scheduled test or treatment is disallowed. "
    // },
    // {
    //   "code": "N629",
    //   "descr": "Reviews/documentation/notes/summaries/reports/charts not requested. "
    // },
    // {
    //   "code": "N630",
    //   "descr": "Referral not authorized by attending physician. "
    // },
    // {
    //   "code": "N631",
    //   "descr": "Medical Fee Schedule does not list this code. An allowance was made for a comparable service. "
    // },
    // {
    //   "code": "N632",
    //   "descr": "According to the Official Medical Fee Schedule this service has a relative value of zero and therefore no payment is due. "
    // },
    // {
    //   "code": "N633",
    //   "descr": "Additional anesthesia time units are not allowed. "
    // },
    // {
    //   "code": "N634",
    //   "descr": "The allowance is calculated based on anesthesia time units. "
    // },
    // {
    //   "code": "N635",
    //   "descr": "The Allowance is calculated based on the anesthesia base units plus time. "
    // },
    // {
    //   "code": "N636",
    //   "descr": "Adjusted because this is reimbursable only once per injury. "
    // },
    // {
    //   "code": "N637",
    //   "descr": "Consultations are not allowed once treatment has been rendered by the same provider. "
    // },
    // {
    //   "code": "N638",
    //   "descr": "Reimbursement has been made according to the home health fee schedule. "
    // },
    // {
    //   "code": "N639",
    //   "descr": "Reimbursement has been made according to the inpatient rehabilitation facilities fee schedule. "
    // },
    // {
    //   "code": "N640",
    //   "descr": "Exceeds number/frequency approved/allowed within time period. "
    // },
    // {
    //   "code": "N641",
    //   "descr": "Reimbursement has been based on the number of body areas rated. "
    // },
    // {
    //   "code": "N642",
    //   "descr": "Adjusted when billed as individual tests instead of as a panel. "
    // },
    // {
    //   "code": "N643",
    //   "descr": "The services billed are considered Not Covered or Non-Covered (NC) in the applicable state fee schedule. "
    // },
    // {
    //   "code": "N644",
    //   "descr": "Reimbursement has been made according to the bilateral procedure rule. "
    // },
    // {
    //   "code": "N645",
    //   "descr": "Mark-up allowance. "
    // },
    // {
    //   "code": "N646",
    //   "descr": "Reimbursement has been adjusted based on the guidelines for an assistant. "
    // },
    // {
    //   "code": "N647",
    //   "descr": "Adjusted based on diagnosis-related group (DRG). "
    // },
    // {
    //   "code": "N648",
    //   "descr": "Adjusted based on Stop Loss. "
    // },
    // {
    //   "code": "N649",
    //   "descr": "Payment based on invoice. "
    // },
    // {
    //   "code": "N650",
    //   "descr": "This policy was not in effect for this date of loss. No coverage is available. "
    // },
    // {
    //   "code": "N651",
    //   "descr": "No Personal Injury Protection/Medical Payments Coverage on the policy at the time of the loss. "
    // },
    // {
    //   "code": "N652",
    //   "descr": "The date of service is before the date of loss. "
    // },
    // {
    //   "code": "N653",
    //   "descr": "The date of injury does not match the reported date of loss. "
    // },
    // {
    //   "code": "N654",
    //   "descr": "Adjusted based on achievement of maximum medical improvement (MMI). "
    // },
    // {
    //   "code": "N655",
    //   "descr": "Payment based on provider's geographic region. "
    // },
    // {
    //   "code": "N656",
    //   "descr": "An interest payment is being made because benefits are being paid outside the statutory requirement. "
    // },
    // {
    //   "code": "N657",
    //   "descr": "This should be billed with the appropriate code for these services. "
    // },
    // {
    //   "code": "N658",
    //   "descr": "The billed service(s) are not considered medical expenses. "
    // },
    // {
    //   "code": "N659",
    //   "descr": "This item is exempt from sales tax. "
    // },
    // {
    //   "code": "N660",
    //   "descr": "Sales tax has been included in the reimbursement. "
    // },
    // {
    //   "code": "N661",
    //   "descr": "Documentation does not support that the services rendered were medically necessary. "
    // },
    // {
    //   "code": "N662",
    //   "descr": "Alert: Consideration of payment will be made upon receipt of a final bill. "
    // },
    // {
    //   "code": "N663",
    //   "descr": "Adjusted based on an agreed amount. "
    // },
    // {
    //   "code": "N664",
    //   "descr": "Adjusted based on a legal settlement. "
    // },
    // {
    //   "code": "N665",
    //   "descr": "Services by an unlicensed provider are not reimbursable. "
    // },
    // {
    //   "code": "N666",
    //   "descr": "Only one evaluation and management code at this service level is covered during the course of care. "
    // },
    // {
    //   "code": "N667",
    //   "descr": "Missing prescription. "
    // },
    // {
    //   "code": "N668",
    //   "descr": "Incomplete/invalid prescription. "
    // },
    // {
    //   "code": "N669",
    //   "descr": "Adjusted based on the Medicare fee schedule. "
    // },
    // {
    //   "code": "N670",
    //   "descr": "This service code has been identified as the primary procedure code subject to the Medicare Multiple Procedure Payment Reduction (MPPR) rule. "
    // },
    // {
    //   "code": "N671",
    //   "descr": "Payment based on a jurisdiction cost-charge ratio. "
    // },
    // {
    //   "code": "N672",
    //   "descr": "Alert: Amount applied to Health Insurance Offset. "
    // },
    // {
    //   "code": "N673",
    //   "descr": "Reimbursement has been calculated based on an outpatient per diem or an outpatient factor and/or fee schedule amount. "
    // },
    // {
    //   "code": "N674",
    //   "descr": "Not covered unless a pre-requisite procedure/service has been provided. "
    // },
    // {
    //   "code": "N675",
    //   "descr": "Additional information is required from the injured party. "
    // },
    // {
    //   "code": "N676",
    //   "descr": "Service does not qualify for payment under the Outpatient Facility Fee Schedule. "
    // },
    // {
    //   "code": "N677",
    //   "descr": "Alert: Films/Images will not be returned. "
    // },
    // {
    //   "code": "N678",
    //   "descr": "Missing post-operative images/visual field results. "
    // },
    // {
    //   "code": "N679",
    //   "descr": "Incomplete/Invalid post-operative images/visual field results. "
    // },
    // {
    //   "code": "N680",
    //   "descr": "Missing/Incomplete/Invalid date of previous dental extractions. "
    // },
    // {
    //   "code": "N681",
    //   "descr": "Missing/Incomplete/Invalid full arch series. "
    // },
    // {
    //   "code": "N682",
    //   "descr": "Missing/Incomplete/Invalid history of prior periodontal therapy/maintenance. "
    // },
    // {
    //   "code": "N683",
    //   "descr": "Missing/Incomplete/Invalid prior treatment documentation. "
    // },
    // {
    //   "code": "N684",
    //   "descr": "Payment denied as this is a specialty claim submitted as a general claim. "
    // },
    // {
    //   "code": "N685",
    //   "descr": "Missing/Incomplete/Invalid Prosthesis, Crown or Inlay Code. "
    // },
    // {
    //   "code": "N686",
    //   "descr": "Missing/incomplete/Invalid questionnaire needed to complete payment determination. "
    // },
    // {
    //   "code": "N687",
    //   "descr": "Alert: This reversal is due to a retroactive disenrollment. "
    // },
    // {
    //   "code": "N688",
    //   "descr": "Alert: This reversal is due to a medical or utilization review decision. "
    // },
    // {
    //   "code": "N689",
    //   "descr": "Alert: This reversal is due to a retroactive rate change. "
    // },
    // {
    //   "code": "N690",
    //   "descr": "Alert: This reversal is due to a provider submitted appeal. "
    // },
    // {
    //   "code": "N691",
    //   "descr": "Alert: This reversal is due to a patient submitted appeal. "
    // },
    // {
    //   "code": "N692",
    //   "descr": "Alert: This reversal is due to an incorrect rate on the initial adjudication. "
    // },
    // {
    //   "code": "N693",
    //   "descr": "Alert: This reversal is due to a cancellation of the claim by the provider. "
    // },
    // {
    //   "code": "N694",
    //   "descr": "Alert: This reversal is due to a resubmission/change to the claim by the provider. "
    // },
    // {
    //   "code": "N695",
    //   "descr": "Alert: This reversal is due to incorrect patient financial responsibility information on the initial adjudication. "
    // },
    // {
    //   "code": "N696",
    //   "descr": "Alert: This reversal is due to a Coordination of Benefits or Third Party Liability Recovery retroactive adjustment. "
    // },
    // {
    //   "code": "N697",
    //   "descr": "Alert: This reversal is due to a payer's retroactive contract incentive program adjustment. "
    // },
    // {
    //   "code": "N698",
    //   "descr": "Alert: This reversal is due to non-payment of the health insurance premiums (Health Insurance Exchange or other) by the end of the premium payment grace period, resulting in loss of coverage. "
    // },
    // {
    //   "code": "N699",
    //   "descr": "Payment adjusted based on the Physician Quality Reporting System (PQRS) Incentive Program. "
    // },
    // {
    //   "code": "N700",
    //   "descr": "Payment adjusted based on the Electronic Health Records (EHR) Incentive Program. "
    // },
    // {
    //   "code": "N701",
    //   "descr": "Payment adjusted based on the Value-based Payment Modifier. "
    // },
    // {
    //   "code": "N702",
    //   "descr": "Decision based on review of previously adjudicated claims or for claims in process for the same/similar type of services. "
    // },
    // {
    //   "code": "N703",
    //   "descr": "This service is incompatible with previously  adjudicated claims or claims in process. "
    // },
    // {
    //   "code": "N704",
    //   "descr": "Alert: You may not appeal this decision but can resubmit this claim/service with corrected information if warranted. "
    // },
    // {
    //   "code": "N705",
    //   "descr": "Incomplete/invalid documentation. "
    // },
    // {
    //   "code": "N706",
    //   "descr": "Missing documentation. "
    // },
    // {
    //   "code": "N707",
    //   "descr": "Incomplete/invalid orders. "
    // },
    // {
    //   "code": "N708",
    //   "descr": "Missing orders. "
    // },
    // {
    //   "code": "N709",
    //   "descr": "Incomplete/invalid notes. "
    // },
    // {
    //   "code": "N710",
    //   "descr": "Missing notes. "
    // },
    // {
    //   "code": "N711",
    //   "descr": "Incomplete/invalid summary. "
    // },
    // {
    //   "code": "N712",
    //   "descr": "Missing summary. "
    // },
    // {
    //   "code": "N713",
    //   "descr": "Incomplete/invalid report. "
    // },
    // {
    //   "code": "N714",
    //   "descr": "Missing report. "
    // },
    // {
    //   "code": "N715",
    //   "descr": "Incomplete/invalid chart. "
    // },
    // {
    //   "code": "N716",
    //   "descr": "Missing chart. "
    // },
    // {
    //   "code": "N717",
    //   "descr": "Incomplete/Invalid documentation of face-to-face examination. "
    // },
    // {
    //   "code": "N718",
    //   "descr": "Missing documentation of face-to-face examination. "
    // },
    // {
    //   "code": "N719",
    //   "descr": "Penalty applied based on plan requirements not being met. "
    // },
    // {
    //   "code": "N720",
    //   "descr": "Alert: The patient overpaid you. You may need to issue the patient a refund for the difference between the patient's payment and the amount shown as patient responsibility on this notice. "
    // },
    // {
    //   "code": "N721",
    //   "descr": "This service is only covered when performed as part of a clinical trial. "
    // },
    // {
    //   "code": "N722",
    //   "descr": "Patient must use Workers' Compensation Set-Aside (WCSA) funds to pay for the medical service or item. "
    // },
    // {
    //   "code": "N723",
    //   "descr": "Patient must use Liability set-aside (LSA) funds to pay for the medical service or item. "
    // },
    // {
    //   "code": "N724",
    //   "descr": "Patient must use No-Fault set-aside (NFSA) funds to pay for the medical service or item. "
    // },
    // {
    //   "code": "N725",
    //   "descr": "A liability insurer has reported having ongoing responsibility for medical services (ORM) for this diagnosis. "
    // },
    // {
    //   "code": "N726",
    //   "descr": "A conditional payment is not allowed. "
    // },
    // {
    //   "code": "N727",
    //   "descr": "A no-fault insurer has reported having ongoing responsibility for medical services (ORM) for this diagnosis. "
    // },
    // {
    //   "code": "N728",
    //   "descr": "A workers' compensation insurer has reported having ongoing responsibility for medical services (ORM) for this diagnosis. "
    // },
    // {
    //   "code": "N729",
    //   "descr": "Missing patient medical/dental record for this service. "
    // },
    // {
    //   "code": "N730",
    //   "descr": "Incomplete/invalid patient medical/dental record for this service. "
    // },
    // {
    //   "code": "N731",
    //   "descr": "Incomplete/Invalid mental health assessment. "
    // },
    // {
    //   "code": "N732",
    //   "descr": "Services performed at an unlicensed facility are not reimbursable. "
    // },
    // {
    //   "code": "N733",
    //   "descr": "Regulatory surcharges are paid directly to the state. "
    // },
    // {
    //   "code": "N734",
    //   "descr": "The patient is eligible for these medical services only when unable to work or perform normal activities due to an illness or injury. "
    // },
    // {
    //   "code": "N735",
    //   "descr": "Adjustment without review of medical/dental record because the requested records were not received or were not received timely. "
    // },
    // {
    //   "code": "N736",
    //   "descr": "Incomplete/invalid Sleep Study Report. "
    // },
    // {
    //   "code": "N737",
    //   "descr": "Missing Sleep Study Report. "
    // },
    // {
    //   "code": "N738",
    //   "descr": "Incomplete/invalid Vein Study Report. "
    // },
    // {
    //   "code": "N739",
    //   "descr": "Missing Vein Study Report. "
    // },
    // {
    //   "code": "N740",
    //   "descr": "The member's Consumer Spending Account does not contain sufficient funds to cover the member's liability for this claim/service. "
    // },
    // {
    //   "code": "N741",
    //   "descr": "This is a site neutral payment. "
    // },
    // {
    //   "code": "N742",
    //   "descr": "Alert: This claim was processed based on one or more ICD-9 codes. The transition to ICD-10 is required by October 1, 2015, for health care providers, health plans, and clearinghouses. More information can be found at http://www.cms.gov/Medicare/Coding/ICD10/ProviderResources.html "
    // },
    // {
    //   "code": "N743",
    //   "descr": "Adjusted because the services may be related to an employment accident. "
    // },
    // {
    //   "code": "N744",
    //   "descr": "Adjusted because the services may be related to an auto/other accident. "
    // },
    // {
    //   "code": "N745",
    //   "descr": "Missing Ambulance Report. "
    // },
    // {
    //   "code": "N746",
    //   "descr": "Incomplete/invalid Ambulance Report. "
    // },
    // {
    //   "code": "N747",
    //   "descr": "This is a misdirected claim/service. Submit the claim to the payer/plan where the patient resides. "
    // },
    // {
    //   "code": "N748",
    //   "descr": "Adjusted because the related hospital charges have not been received. "
    // },
    // {
    //   "code": "N749",
    //   "descr": "Missing Blood Gas Report. "
    // },
    // {
    //   "code": "N750",
    //   "descr": "Incomplete/invalid Blood Gas Report. "
    // },
    // {
    //   "code": "N751",
    //   "descr": "Adjusted because the patient is covered under a Medicare Part D plan. "
    // },
    // {
    //   "code": "N752",
    //   "descr": "Missing/incomplete/invalid HIPPS Treatment Authorization Code (TAC). "
    // },
    // {
    //   "code": "N753",
    //   "descr": "Missing/incomplete/invalid Attachment Control Number. "
    // },
    // {
    //   "code": "N754",
    //   "descr": "Missing/incomplete/invalid Referring Provider or Other Source Qualifier on the 1500 Claim Form. "
    // },
    // {
    //   "code": "N755",
    //   "descr": "Missing/incomplete/invalid ICD Indicator. "
    // },
    // {
    //   "code": "N756",
    //   "descr": "Missing/incomplete/invalid point of drop-off address. "
    // },
    // {
    //   "code": "N757",
    //   "descr": "Adjusted based on the Federal Indian Fees schedule (MLR). "
    // },
    // {
    //   "code": "N758",
    //   "descr": "Adjusted based on the prior authorization decision. "
    // },
    // {
    //   "code": "N759",
    //   "descr": "Payment adjusted based on the National Electrical Manufacturers Association (NEMA) Standard XR-29-2013. "
    // },
    // {
    //   "code": "N760",
    //   "descr": "This facility is not authorized to receive payment for the service(s). "
    // },
    // {
    //   "code": "N761",
    //   "descr": "This provider is not authorized to receive payment for the service(s). "
    // },
    // {
    //   "code": "N762",
    //   "descr": "This facility is not certified for Tomosynthesis (3-D) mammography. "
    // },
    // {
    //   "code": "N763",
    //   "descr": "The demonstration code is not appropriate for this claim; resubmit without a demonstration code. "
    // },
    // {
    //   "code": "N764",
    //   "descr": "Missing/incomplete/invalid Hematocrit (HCT) value. "
    // },
    // {
    //   "code": "N765",
    //   "descr": "This payer does not cover co-insurance assessed by a previous payer. "
    // },
    // {
    //   "code": "N766",
    //   "descr": "This payer does not cover co-payment assessed by a previous payer. "
    // },
    // {
    //   "code": "N767",
    //   "descr": "The Medicaid state requires provider to be enrolled in the member's Medicaid state program prior to any claim benefits being processed. "
    // },
    // {
    //   "code": "N768",
    //   "descr": "Incomplete/invalid initial evaluation report. "
    // },
    // {
    //   "code": "N769",
    //   "descr": "A lateral diagnosis is required. "
    // },
    // {
    //   "code": "N770",
    //   "descr": "The adjustment request received from the provider has been processed. Your original claim has been adjusted based on the information received. "
    // },
    // {
    //   "code": "N771",
    //   "descr": "Alert: Under Federal law you cannot charge more than the limiting charge amount. "
    // },
    // {
    //   "code": "N772",
    //   "descr": "Alert: Rebill urgent/emergent and ancillary services separately. "
    // },
    // {
    //   "code": "N773",
    //   "descr": "Drug supplied not obtained from specialty vendor. "
    // },
    // {
    //   "code": "N774",
    //   "descr": "Alert: Refer to your Third Party Processor Agreement for specific information on fees associated with this payment type. "
    // },
    // {
    //   "code": "N775",
    //   "descr": "Payment adjusted based on x-ray radiograph on film. "
    // },
    // {
    //   "code": "N776",
    //   "descr": "This service is not a covered Telehealth service. "
    // },
    // {
    //   "code": "N777",
    //   "descr": "Missing Assignment of Benefits Indicator. "
    // },
    // {
    //   "code": "N778",
    //   "descr": "Missing Primary Care Physician Information. "
    // },
    // {
    //   "code": "N779",
    //   "descr": "Replacement/Void claims cannot be submitted until the original claim has finalized. Please resubmit once payment or denial is received. "
    // },
    // {
    //   "code": "N780",
    //   "descr": "Missing/incomplete/invalid end therapy date. "
    // },
    // {
    //   "code": "N781",
    //   "descr": "Alert: No deductible may be collected as patient is a Medicaid/Qualified Medicare Beneficiary. Review your records for any wrongfully collected deductible. "
    // },
    // {
    //   "code": "N782",
    //   "descr": "Alert: No coinsurance may be collected as patient is a Medicaid/Qualified Medicare Beneficiary. Review your records for any wrongfully collected coinsurance. "
    // },
    // {
    //   "code": "N783",
    //   "descr": "Alert: No co-payment may be collected as patient is a Medicaid/Qualified Medicare Beneficiary. Review your records for any wrongfully collected co-payment. "
    // },
    // {
    //   "code": "N784",
    //   "descr": "Missing comprehensive procedure code. "
    // },
    // {
    //   "code": "N785",
    //   "descr": "Missing current radiology film/images. "
    // },
    // {
    //   "code": "N786",
    //   "descr": "Benefit limitation for the orthodontic active and/or retention phase of treatment. "
    // },
    // {
    //   "code": "N787",
    //   "descr": "Alert: Under 42 CFR 410.43, an eligible Partial Hospitalization Program (PHP) patient/beneficiary requires a minimum of 20 hours of PHP services per week, as evidenced in the plan of care. PHP services must be furnished in accordance with the plan of care. "
    // },
    // {
    //   "code": "N788",
    //   "descr": "The third party administrator/review organization did not receive the requested information. "
    // },
    // {
    //   "code": "N789",
    //   "descr": "Clinical Trial is not a covered benefit. "
    // },
    // {
    //   "code": "N790",
    //   "descr": "Provider/supplier not accredited for product/service. "
    // },
    // {
    //   "code": "N791",
    //   "descr": "Missing history & physical report."
    // },
    // {
    //   "code": "N792",
    //   "descr": "Incomplete/invalid history & physical report."
    // },
    // {
    //   "code": "N793",
    //   "descr": "Alert: CMS is changing from the Medicare Health Insurance Claim number (HICN) to the new Medicare Beneficiary Identifier (MBI). You can use either the HICN or MBI during the transition period. Visit www.cms.gov/medicare/ssnri for important dates and information about this change. "
    // },
    // {
    //   "code": "N794",
    //   "descr": "Payment adjusted based on type of technology used. "
    // }
  ];
}
